
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2Yc46", function(module, exports) {
/**
 * Auto-apply controllers and hooks
 */ 
var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $dh538 = parcelRequire("dh538");


var $16lEl = parcelRequire("16lEl");

var $7pmZw = parcelRequire("7pmZw");


var $i1Nyn = parcelRequire("i1Nyn");





var $gHaxX = parcelRequire("gHaxX");


var $d4Pk4 = parcelRequire("d4Pk4");

/**
 * Constants for auto-apply functionality
 */ const $5bb909103ff2a6d1$export$3317b9c0d88ecd38 = 'ai-mate-auto-apply-enabled';
const $5bb909103ff2a6d1$export$e46d7815fa70b734 = 'enable_auto_apply_toggling';


/**
 * @generated SignedSource<<44740e0f599cf23fde7ac25cf45f343d>>
 * @relayHash de75149bd6de46cf773dd86b1156f83a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b
const $3ad35185df377655$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "SettingsCreationSettings",
            "kind": "LinkedField",
            "name": "settings_updateCreationSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "autoApply"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "creationSettingsMutationMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "creationSettingsMutationMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b",
            "metadata": {},
            "name": "creationSettingsMutationMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$3ad35185df377655$var$node.hash = "2764b2132df7149a218d7fe86758b452";
var $3ad35185df377655$export$2e2bcd8739ae039 = $3ad35185df377655$var$node;


/**
 * @generated SignedSource<<db4dd10a4e100afc581c7518b1f1eaff>>
 * @relayHash 2da18ddcf067ae3b3f655513eb48acac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0
const $406a28720a18ef49$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ownerAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                }
            ],
            "concreteType": "SettingsCreationSettings",
            "kind": "LinkedField",
            "name": "settings_creationSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "autoApply"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "creationSettingsQueryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "creationSettingsQueryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "956e6f209e8636ab81a23303d07e8588229617e5b9b8b1456e7b0510e082a8f0",
            "metadata": {},
            "name": "creationSettingsQueryQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$406a28720a18ef49$var$node.hash = "d5e237e68920e0355d028a1df4e44e10";
var $406a28720a18ef49$export$2e2bcd8739ae039 = $406a28720a18ef49$var$node;


/**
 * Convert cloudId to tenantId ARI format
 */ function $45c1578a6ac72ff4$var$tenantIdToAri(cloudId) {
    return (0, $d4Pk4.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
}
/**
 * Convert userId to ownerAri format
 */ function $45c1578a6ac72ff4$var$userIdToAri(userId) {
    return (0, $gHaxX.IdentityUserAri).create({
        userId: userId
    }).toString();
}
function $45c1578a6ac72ff4$export$cbd1b24c4f50480f() {
    try {
        const stored = window.localStorage.getItem((0, $5bb909103ff2a6d1$export$3317b9c0d88ecd38));
        return stored !== null ? JSON.parse(stored) : true;
    } catch  {
        return true; // fallback to default
    }
}
function $45c1578a6ac72ff4$export$dedcc43382a0a2d(enabled) {
    try {
        window.localStorage.setItem((0, $5bb909103ff2a6d1$export$3317b9c0d88ecd38), JSON.stringify(enabled));
        window.dispatchEvent(new CustomEvent('autoApplyChanged'));
    } catch  {
    // Silently fail if localStorage is unavailable
    }
}
function $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri) {
    const variables = {
        tenantId: tenantId,
        ownerAri: ownerAri
    };
    return (0, $irOoi.fetchQuery)(environment, (0, $406a28720a18ef49$export$2e2bcd8739ae039), variables).toPromise().then((response)=>{
        // Reject if no response
        if (!response) throw new Error('Failed to fetch creation settings: No response');
        // Return the autoApply value from backend, default to true if not found
        const autoApply = response?.settings_creationSettings?.autoApply ?? true;
        return autoApply;
    });
}
function $45c1578a6ac72ff4$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, autoApply) {
    const input = {
        tenantId: tenantId,
        ownerAri: ownerAri,
        autoApply: autoApply
    };
    return new Promise((resolve, reject)=>{
        (0, $irOoi.commitMutation)(environment, {
            mutation: (0, $3ad35185df377655$export$2e2bcd8739ae039),
            variables: {
                input: input
            },
            onCompleted: (response, errors)=>{
                const payload = response.settings_updateCreationSettings;
                if (errors || !payload) reject(errors || 'Failed to update creation settings');
                else {
                    // Also update localStorage as cache/fallback
                    $45c1578a6ac72ff4$export$dedcc43382a0a2d(autoApply);
                    resolve(autoApply);
                }
            },
            onError: (error)=>{
                // Reject so caller can handle the failure
                reject(error);
            }
        });
    });
}
function $45c1578a6ac72ff4$export$ff4d41d780f8bf44() {
    const currentState = $45c1578a6ac72ff4$export$cbd1b24c4f50480f();
    const newState = !currentState;
    $45c1578a6ac72ff4$export$dedcc43382a0a2d(newState);
    return newState;
}
async function $45c1578a6ac72ff4$export$5b78d0cd3e8869ab(environment, sessionData) {
    const currentState = await $45c1578a6ac72ff4$export$de3027235ba834ab(environment, sessionData);
    const newState = !currentState;
    // Update both backend and localStorage
    await $45c1578a6ac72ff4$export$284464f4da8ebd9(environment, sessionData, newState);
    return newState;
}
async function $45c1578a6ac72ff4$export$32ad7f49a3b9fcd9(environment, tenantId, ownerAri) {
    const currentState = await $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri);
    const newState = !currentState;
    // Update both backend and localStorage
    await $45c1578a6ac72ff4$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, newState);
    return newState;
}
async function $45c1578a6ac72ff4$export$de3027235ba834ab(environment, sessionData) {
    if (!sessionData.userId) // Fallback to localStorage for anonymous users
    return $45c1578a6ac72ff4$export$cbd1b24c4f50480f();
    const tenantId = $45c1578a6ac72ff4$var$tenantIdToAri(sessionData.cloudId);
    const ownerAri = $45c1578a6ac72ff4$var$userIdToAri(sessionData.userId);
    return $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri);
}
async function $45c1578a6ac72ff4$export$284464f4da8ebd9(environment, sessionData, autoApply) {
    if (!sessionData.userId) {
        // Fallback to localStorage for anonymous users
        $45c1578a6ac72ff4$export$dedcc43382a0a2d(autoApply);
        return autoApply;
    }
    const tenantId = $45c1578a6ac72ff4$var$tenantIdToAri(sessionData.cloudId);
    const ownerAri = $45c1578a6ac72ff4$var$userIdToAri(sessionData.userId);
    return $45c1578a6ac72ff4$export$2c52b5b9e34ef0b0(environment, tenantId, ownerAri, autoApply);
}
function $45c1578a6ac72ff4$export$308de05ffc91835d(environment, tenantId, ownerAri, setState) {
    return async ()=>{
        const enabled = await $45c1578a6ac72ff4$export$490b52318e47ac6c(environment, tenantId, ownerAri);
        setState(enabled);
    };
}


// ============================================================================
// Helpers
// ============================================================================
/**
 * Safely gets the Relay environment without throwing if no provider is available.
 * This allows the hook to work in test environments or contexts without RelayEnvironmentProvider.
 */ const $5dd52072ecf7ce89$var$useSafeRelayEnvironment = ()=>{
    try {
        return (0, $irOoi.useRelayEnvironment)();
    } catch (error) {
        // No RelayEnvironmentProvider available, return null
        // The hook will fall back to localStorage-only mode
        return null;
    }
};
const $5dd52072ecf7ce89$export$e7148f1ad1bea80c = (contentContext, useCurrentPageContext, isConversationAgentic, productKey)=>{
    // Get editor context to determine if there's an active editor to stream to
    const [editorContext] = (0, $i1Nyn.useChatContextEditorContext)();
    let autoApplyAvailability = {
        type: 'unavailable',
        reason: 'no_editor_context'
    };
    // Agentic conversations handle their own application
    if (isConversationAgentic) autoApplyAvailability = {
        type: 'unavailable',
        reason: 'agentic_conversation'
    };
    else if (contentContext === 'staging-area') autoApplyAvailability = {
        type: 'available'
    };
    else if (!useCurrentPageContext) autoApplyAvailability = {
        type: 'unavailable',
        reason: 'no_page_context'
    };
    else if (contentContext === 'global' && productKey === 'jira') autoApplyAvailability = {
        type: 'available'
    };
    else if (contentContext === 'global' && Boolean(editorContext)) autoApplyAvailability = {
        type: 'available'
    };
    return {
        autoApplyAvailability: autoApplyAvailability
    };
};
const $5dd52072ecf7ce89$export$97bf7cbb478ab6de = (sessionData, contentContext, useCurrentPageContext, isConversationAgentic)=>{
    const environment = $5dd52072ecf7ce89$var$useSafeRelayEnvironment();
    const experienceTracker = (0, $7pmZw.useAIMateExperienceTracker)();
    const [enabled, setEnabledState] = (0, $42omo.useState)(()=>(0, $45c1578a6ac72ff4$export$cbd1b24c4f50480f)());
    const [loading, setLoading] = (0, $42omo.useState)(false);
    const [error, setError] = (0, $42omo.useState)(null);
    // Cache the current state to avoid unnecessary re-renders
    const stateRef = (0, $42omo.useRef)(enabled);
    stateRef.current = enabled;
    // Determine if we should make backend calls (need environment + session + feature gate)
    const shouldUseBackend = environment && sessionData && sessionData.userId && (0, $dh538.fg)('enable_auto_apply_toggling');
    // Determine if we should use localStorage fallback
    const shouldUseLocalStorage = (!sessionData || !sessionData.userId || !environment) && (0, $dh538.fg)('enable_auto_apply_toggling');
    // If feature gate is off, don't provide any auto-apply functionality
    const isFeatureDisabled = !(0, $dh538.fg)('enable_auto_apply_toggling');
    // Load state from backend when component mounts or sessionData changes
    const refresh = (0, $42omo.useCallback)(async ()=>{
        if (isFeatureDisabled) return;
        if (shouldUseBackend) {
            const experienceId = `${(0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE}-${Date.now()}`;
            experienceTracker.start({
                id: experienceId,
                name: (0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE
            });
            setLoading(true);
            setError(null);
            try {
                const backendState = await (0, $45c1578a6ac72ff4$export$de3027235ba834ab)(environment, sessionData);
                if (backendState !== stateRef.current) setEnabledState(backendState);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE
                });
            } catch (err) {
                // Store error and keep current state - don't fall back to localStorage
                const error = err instanceof Error ? err : new Error('Failed to fetch auto-apply state');
                setError(error);
                experienceTracker.fail({
                    name: (0, $16lEl.ExperienceName).GET_AUTO_APPLY_STATE,
                    error: error
                });
            } finally{
                setLoading(false);
            }
        } else if (shouldUseLocalStorage) {
            const localState = (0, $45c1578a6ac72ff4$export$cbd1b24c4f50480f)();
            if (localState !== stateRef.current) setEnabledState(localState);
        }
    }, [
        environment,
        sessionData,
        shouldUseBackend,
        shouldUseLocalStorage,
        isFeatureDisabled,
        experienceTracker
    ]);
    // Set state with backend persistence
    const setEnabled = (0, $42omo.useCallback)(async (newEnabled)=>{
        if (isFeatureDisabled) return;
        if (newEnabled === stateRef.current) return; // No change needed
        const experienceId = `${(0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE}-${Date.now()}`;
        setLoading(true);
        setError(null);
        try {
            if (shouldUseBackend) {
                experienceTracker.start({
                    id: experienceId,
                    name: (0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE
                });
                await (0, $45c1578a6ac72ff4$export$284464f4da8ebd9)(environment, sessionData, newEnabled);
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE,
                    attributes: {
                        autoApplyEnabled: newEnabled
                    }
                });
            } else if (shouldUseLocalStorage) (0, $45c1578a6ac72ff4$export$dedcc43382a0a2d)(newEnabled);
            setEnabledState(newEnabled);
        } catch (err) {
            // Store error and keep current state, don't update UI
            const error = err instanceof Error ? err : new Error('Failed to update auto-apply state');
            setError(error);
            if (shouldUseBackend) experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).SET_AUTO_APPLY_STATE,
                error: error,
                attributes: {
                    autoApplyEnabled: newEnabled
                }
            });
            throw error; // Re-throw so the component can handle it
        } finally{
            setLoading(false);
        }
    }, [
        environment,
        sessionData,
        shouldUseBackend,
        shouldUseLocalStorage,
        isFeatureDisabled,
        experienceTracker
    ]);
    // Initialize state from backend
    (0, $42omo.useEffect)(()=>{
        refresh();
    }, [
        refresh
    ]);
    return {
        enabled: isFeatureDisabled ? false : enabled,
        loading: isFeatureDisabled ? false : loading,
        error: isFeatureDisabled ? null : error,
        setEnabled: setEnabled,
        refresh: refresh
    };
};
module.exports["useAutoApplyAvailability"] = $5dd52072ecf7ce89$export$e7148f1ad1bea80c;
module.exports["useAutoApplyState"] = $5dd52072ecf7ce89$export$97bf7cbb478ab6de;

});

parcelRegister("gALmy", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $9e53e00656dc1680$export$9090fb60710493e4 {
    insertText(transcript, tr) {
        if (!transcript) return tr;
        const { selection: selection } = tr;
        let pos = selection.$head.pos;
        // set the initial position of the interim text aand cache it
        if (this.interimTextFrom === null) this.interimTextFrom = pos;
        else pos = this.interimTextFrom;
        if (this.interimTextFrom && this.interimTextTo) tr.delete(this.interimTextFrom, this.interimTextTo);
        tr.insertText(transcript, pos);
        this.interimTextTo = pos + transcript.length;
        return tr;
    }
    rejectTranscriptedText(tr) {
        const from = this.interimTextFrom;
        const to = this.interimTextTo;
        if (!from || !to) return tr;
        tr.delete(from, to);
        this.disposeTranscriptedText();
        return tr;
    }
    disposeTranscriptedText() {
        this.interimTextFrom = null;
        this.interimTextTo = null;
    }
    constructor(interimTextFrom = null, interimTextTo = null){
        this.interimTextFrom = interimTextFrom;
        this.interimTextTo = interimTextTo;
    }
}


const $56624fed415e1fb7$export$5bd0207bc8bc9737 = ()=>{
    const prosemirrorInsertTextManager = (0, $42omo.useRef)(new (0, $9e53e00656dc1680$export$9090fb60710493e4)());
    const handleTranscriptUpdate = (0, $42omo.useCallback)((transcript, tr)=>{
        return prosemirrorInsertTextManager.current.insertText(transcript, tr);
    }, []);
    const rejectTranscriptedText = (0, $42omo.useCallback)((tr)=>{
        return prosemirrorInsertTextManager.current.rejectTranscriptedText(tr);
    }, []);
    const disposeTranscriptedText = (0, $42omo.useCallback)(()=>{
        prosemirrorInsertTextManager.current.disposeTranscriptedText();
    }, []);
    return {
        handleTranscriptUpdate: handleTranscriptUpdate,
        rejectTranscriptedText: rejectTranscriptedText,
        disposeTranscriptedText: disposeTranscriptedText
    };
};
module.exports["useTranscriptionToEditorText"] = $56624fed415e1fb7$export$5bd0207bc8bc9737;

});

parcelRegister("bEPY6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $fYQcF = parcelRequire("fYQcF");


var $TwPkE = parcelRequire("TwPkE");





var $9NDUe = parcelRequire("9NDUe");


var $54pZY = parcelRequire("54pZY");


var $5aVN7 = parcelRequire("5aVN7");

class $90e6ea796011af08$export$dcd1eb6913d822b extends (0, $5aVN7.UFOExperience) {
    startConnectionAttempt() {
        this.webSocketConnectionTiming = {
            key: 'ws_connection',
            startTime: (0, $54pZY.perfNowOrTimestamp)(),
            duration: 0
        };
    }
    success(config) {
        this.addAverageChunkDuration();
        return super.success(config);
    }
    failure(config) {
        this.addAverageChunkDuration();
        return super.failure(config);
    }
    abort(config) {
        this.addAverageChunkDuration();
        return super.abort(config);
    }
    connectionEstablished() {
        if (this.webSocketConnectionTiming) {
            this.webSocketConnectionTiming.duration = (0, $54pZY.perfNowOrTimestamp)() - this.webSocketConnectionTiming.startTime;
            this.addMetadata({
                ws_connection: {
                    ...this.webSocketConnectionTiming
                }
            });
        }
        this.ttfbTiming = {
            startTime: (0, $54pZY.perfNowOrTimestamp)(),
            duration: 0
        };
    }
    reportTTFB() {
        if (this.ttfbTiming) {
            this.ttfbTiming.duration = (0, $54pZY.perfNowOrTimestamp)() - this.ttfbTiming.startTime;
            this.addMetadata({
                ttfb: {
                    ...this.ttfbTiming
                }
            });
            this.updateChunkTiming(this.ttfbTiming, 1);
        }
    }
    addExperienceTotalDuration() {
        this.addMetadata({
            total_duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
        });
    }
    addAverageChunkDuration() {
        const durations = Array.from(this.chunksResponseTime.values()).map((chunk)=>chunk.duration).filter((duration)=>duration > 0);
        const averageDurationInMilliseconds = durations.reduce((sum, milliseconds)=>sum + milliseconds, 0) / durations.length;
        if (this.metrics.startTime) this.markInlineResponse(this.metrics.startTime + averageDurationInMilliseconds);
    }
    updateChunkTiming(currentChunkTiming, createdItemChunkIndex) {
        this.chunksResponseTime.set(createdItemChunkIndex, {
            duration: (0, $54pZY.perfNowOrTimestamp)() - currentChunkTiming.startTime,
            startTime: currentChunkTiming.startTime
        });
        this.chunksResponseTime.set(createdItemChunkIndex + 1, {
            duration: 0,
            startTime: (0, $54pZY.perfNowOrTimestamp)()
        });
    }
    reportRTT(createdItemChunkIndex) {
        const currentChunkTiming = this.chunksResponseTime.get(createdItemChunkIndex);
        if (currentChunkTiming) {
            this.updateChunkTiming(currentChunkTiming, createdItemChunkIndex);
            this.addMetadata({
                chunks_rtt: Object.fromEntries(Array.from(this.chunksResponseTime.entries()).filter(([_, value])=>value.duration > 0).map(([key, value])=>[
                        `chunk_rtt_${key}`,
                        value.duration
                    ]))
            });
        }
    }
    constructor(id, config, instanceId = null){
        super(id, config, instanceId);
        this.chunksResponseTime = new Map();
        this.webSocketConnectionTiming = null;
        this.ttfbTiming = null;
    }
}


const $0e9683b90b7b6f6f$export$9a1b2bd9844b88ce = (id, component)=>{
    const ref = (0, $42omo.useRef)(new (0, $90e6ea796011af08$export$dcd1eb6913d822b)(id, {
        type: (0, $9NDUe.ExperienceTypes).Experience,
        performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: component
        }
    }));
    const start = ()=>{
        ref.current.start();
    };
    const success = (config)=>{
        ref.current.success(config);
    };
    const failure = (config)=>{
        ref.current.failure(config);
    };
    const abort = (config)=>{
        ref.current.abort(config);
    };
    const startConnectionAttempt = ()=>{
        ref.current.startConnectionAttempt();
    };
    const successConnectionEstablished = ()=>{
        ref.current.connectionEstablished();
    };
    const reportTTFB = ()=>{
        ref.current.reportTTFB();
    };
    const reportRTT = (chunkIndex)=>{
        ref.current.reportRTT(chunkIndex);
    };
    return {
        startConnectionAttempt: startConnectionAttempt,
        successConnectionEstablished: successConnectionEstablished,
        reportTTFB: reportTTFB,
        reportRTT: reportRTT,
        start: start,
        success: success,
        failure: failure,
        abort: abort
    };
};



var $6VMxF = parcelRequire("6VMxF");

const $2ca98075bc15791d$export$35a6f2c29539ef8f = (result, action)=>{
    switch(action.type){
        case 'SET_INITIALIZING':
            return {
                state: (0, $6VMxF.VoiceDictationState).Initializing,
                transcription: null
            };
        case 'SET_RECORDING':
            return {
                state: (0, $6VMxF.VoiceDictationState).Recording,
                transcription: action.payload.transcription,
                chunkIndex: action.payload.chunkIndex
            };
        case 'SET_STOPPED':
            return {
                ...result,
                state: (0, $6VMxF.VoiceDictationState).Stopped,
                stopReason: action.payload.stopReason
            };
        case 'SET_ERROR':
            return {
                ...result,
                state: (0, $6VMxF.VoiceDictationState).Error,
                error: action.payload.error
            };
        default:
            return result;
    }
};


/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $c6GJD = parcelRequire("c6GJD");

var $f81391bdbd232abd$export$b1a2c42ac49f689c = /*#__PURE__*/ function(ConvoAIWebSocketServerMessageType) {
    ConvoAIWebSocketServerMessageType["TranscriptionResponseDelta"] = "transcription.response.delta";
    ConvoAIWebSocketServerMessageType["TranscriptionItemCreated"] = "transcription.item.created";
    return ConvoAIWebSocketServerMessageType;
}({});
var $f81391bdbd232abd$export$533906f021c29dcb = /*#__PURE__*/ function(ConvoAIWebSocketClientMessageType) {
    ConvoAIWebSocketClientMessageType["AudioBufferAppend"] = "audio.buffer.append";
    ConvoAIWebSocketClientMessageType["AudioBufferCommit"] = "audio.buffer.commit";
    ConvoAIWebSocketClientMessageType["AudioSessionUpdate"] = "audio.session.update";
    return ConvoAIWebSocketClientMessageType;
}({});
class $f81391bdbd232abd$export$843496a58dc19cce {
    updateTranscriptionConfig(instructions = `Transcribe speech to text. You may get wake words like 'Hey Rovo!' or 'Hey Atlassian!' or 'Rovo, '. Do not include the waking phrase at the beginning of transcription`, noise_detection = 'near_field', vad_type = 'semantic_vad', eagerness = 'medium', model = 'gpt-4o-transcribe', include = [
        'item.input_audio_transcription.logprobs'
    ]) {
        this.socket.send(JSON.stringify({
            type: 'audio.session.update',
            model: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'model', model),
            include: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'include', include),
            vad_type: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'vad_type', vad_type),
            eagerness: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'eagerness', eagerness),
            instructions: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'instructions', instructions),
            noise_detection: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'noise_detection', noise_detection)
        }));
    }
    sendAudio(audio) {
        this.socket.send(JSON.stringify({
            audio: audio,
            type: "audio.buffer.append"
        }));
    }
    commitAudio() {
        this.socket.send(JSON.stringify({
            type: "audio.buffer.commit"
        }));
    }
    connect() {
        return new Promise((resolve, reject)=>{
            this.socket.onopen = ()=>resolve(this);
            this.socket.onerror = (event)=>reject(event);
        });
    }
    disconnect() {
        this.socket?.close();
    }
    static create(cloudID, product, experience, onMessage) {
        const api = new $f81391bdbd232abd$export$843496a58dc19cce(cloudID, product, experience, onMessage);
        return api.connect();
    }
    constructor(cloudID, product, experience, onMessage){
        this.onMessage = onMessage;
        this.socket = void 0;
        this.onServerMessage = (event)=>{
            const data = JSON.parse(event.data);
            this.onMessage(data);
        };
        this.socket = new WebSocket(`/wss/${cloudID}/ai-feature/audio/realtime-transcriptions?product=${product}&experience=${experience}`);
        this.socket.addEventListener('message', this.onServerMessage);
    }
}


/* eslint-disable @atlaskit/platform/use-recommended-utils */ 


const $d4d8bb8b0048aed9$export$e70ce39e35650c8d = async ({ audioString: audioString })=>{
    const response = await fetch('/gateway/api/v1/audio/transcriptions', {
        method: 'POST',
        body: JSON.stringify({
            data: [
                {
                    audio: audioString
                }
            ],
            model: 'whisper-1',
            audio_format: 'wav'
        }),
        headers: {
            'Content-Type': 'application/json',
            'Request-ID': crypto.randomUUID()
        }
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    if (!response.body) throw new Error('Response body is null');
    return response.json();
};


const $85e69f175dc787f8$export$c5d4e064eaa9ff1f = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const result = reader.result;
            const base64 = result.split(',')[1];
            resolve(base64);
        };
        reader.onerror = ()=>reject(new Error('Failed to convert to base64'));
        reader.readAsDataURL(blob);
    });


/**
 * Applies audio gain (amplification) to an AudioBuffer
 *
 * This function multiplies all audio samples by a gain factor to increase or decrease
 * the audio volume. The gain is applied uniformly across all channels.
 *
 * @param audioBuffer - The AudioBuffer to apply gain to
 * @param gainFactor - The gain multiplier (1.0 = no change, 2.0 = double volume, 0.5 = half volume)
 *                     Values > 1.0 amplify the audio, values < 1.0 attenuate it
 * @param preventClipping - Whether to prevent clipping by normalizing if gain would cause overflow
 *
 * @returns A new AudioBuffer with gain applied
 *
 * @example
 * ```typescript
 * // Double the audio volume
 * const amplifiedBuffer = applyAudioGain(originalBuffer, 2.0);
 *
 * // Reduce volume by half
 * const quieterBuffer = applyAudioGain(originalBuffer, 0.5);
 *
 * // Amplify with clipping prevention
 * const safeBuffer = applyAudioGain(originalBuffer, 3.0, true);
 * ```
 */ const $740746d2cbc3cc73$export$fdc1ec94e71033b9 = (audioBuffer, gainFactor, preventClipping = true)=>{
    // Create a new AudioBuffer with the same properties
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const newBuffer = audioContext.createBuffer(audioBuffer.numberOfChannels, audioBuffer.length, audioBuffer.sampleRate);
    // Apply gain to each channel
    for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
        const originalData = audioBuffer.getChannelData(channel);
        const newData = newBuffer.getChannelData(channel);
        // First pass: apply gain and find peak if clipping prevention is enabled
        let peak = 0;
        for(let i = 0; i < originalData.length; i++){
            const amplifiedSample = originalData[i] * gainFactor;
            newData[i] = amplifiedSample;
            if (preventClipping) peak = Math.max(peak, Math.abs(amplifiedSample));
        }
        // Second pass: normalize if clipping would occur
        if (preventClipping && peak > 1.0) {
            const normalizationFactor = 1.0 / peak;
            for(let i = 0; i < newData.length; i++)newData[i] *= normalizationFactor;
        } else if (!preventClipping) // Clamp values to prevent distortion if clipping prevention is disabled
        for(let i = 0; i < newData.length; i++)newData[i] = Math.max(-1, Math.min(1.0, newData[i]));
    }
    return newBuffer;
};
const $740746d2cbc3cc73$export$dae3aad198bcc4dd = (audioBuffer)=>{
    let sumSquares = 0;
    let sampleCount = 0;
    for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let i = 0; i < channelData.length; i++){
            sumSquares += channelData[i] * channelData[i];
            sampleCount++;
        }
    }
    return Math.sqrt(sumSquares / sampleCount);
};
const $740746d2cbc3cc73$export$a4f04dc9b8c85a93 = (audioBuffer, targetRMS = 0.2, maxGain = 10.0)=>{
    const currentRMS = $740746d2cbc3cc73$export$dae3aad198bcc4dd(audioBuffer);
    if (currentRMS === 0) return 1.0; // Avoid division by zero for silent audio
    const calculatedGain = targetRMS / currentRMS;
    return Math.min(calculatedGain, maxGain);
};


/**
 * Audio analysis utilities for detecting sound content and audio quality
 */ /**
 * Detects if audio buffer contains sound above a threshold using RMS analysis
 * @param audioBuffer - The AudioBuffer to analyze
 * @param threshold - RMS threshold for sound detection (default: 0.01)
 * @returns true if audio contains sound, false if silent
 */ const $6c5f2eec39a185b4$export$fb7d0dbec0b9c428 = (audioBuffer, threshold = 0.01)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    // Calculate RMS (Root Mean Square) for each channel
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        let sumSquares = 0;
        // Calculate sum of squares for RMS
        for(let sample = 0; sample < length; sample++)sumSquares += channelData[sample] * channelData[sample];
        // Calculate RMS for this channel
        const rms = Math.sqrt(sumSquares / length);
        // If any channel has audio above threshold, return true
        if (rms > threshold) return true;
    }
    return false;
};
const $6c5f2eec39a185b4$export$41efb760936b1083 = (audioBuffer, threshold = 0.005)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    // Check peak amplitude for each channel
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let sample = 0; sample < length; sample++){
            const amplitude = Math.abs(channelData[sample]);
            if (amplitude > threshold) return true;
        }
    }
    return false;
};
const $6c5f2eec39a185b4$export$ac8474076d842596 = (audioBuffer, threshold = 0.1)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        let zeroCrossings = 0;
        // Count zero crossings
        for(let sample = 1; sample < length; sample++)if (channelData[sample] >= 0 && channelData[sample - 1] < 0 || channelData[sample] < 0 && channelData[sample - 1] >= 0) zeroCrossings++;
        // Calculate zero-crossing rate
        const zeroCrossingRate = zeroCrossings / length;
        if (zeroCrossingRate > threshold) return true;
    }
    return false;
};
const $6c5f2eec39a185b4$export$7c7be76b9ed1e76f = (audioBuffer, options = {})=>{
    const { rmsThreshold: rmsThreshold = 0.01, peakThreshold: peakThreshold = 0.005, zeroCrossingThreshold: zeroCrossingThreshold = 0.1, requireAll: requireAll = false } = options;
    const rmsResult = $6c5f2eec39a185b4$export$fb7d0dbec0b9c428(audioBuffer, rmsThreshold);
    const peakResult = $6c5f2eec39a185b4$export$41efb760936b1083(audioBuffer, peakThreshold);
    const zeroCrossingResult = $6c5f2eec39a185b4$export$ac8474076d842596(audioBuffer, zeroCrossingThreshold);
    if (requireAll) return rmsResult && peakResult && zeroCrossingResult;
    // Return true if any method detects sound (more sensitive)
    return rmsResult || peakResult || zeroCrossingResult;
};


/**
 * Creates PCM16 data from an AudioBuffer
 *
 * This function converts Web Audio API AudioBuffer data into raw PCM16 format
 * (16-bit signed integer samples) without any file headers. This is more efficient
 * than WAV format for audio processing since it eliminates header overhead.
 *
 * @param audioBuffer - The AudioBuffer to convert to PCM16 format. This should contain
 *                      audio data from the Web Audio API (e.g., from MediaRecorder, AudioContext, etc.)
 *
 * @returns An ArrayBuffer containing the raw PCM16 audio data.
 *          The audio is encoded as 16-bit signed integers at the original sample rate and channel count.
 *
 * @example
 * ```typescript
 * // Convert an AudioBuffer to PCM16 format
 * const audioBuffer = audioContext.createBuffer(2, 44100, 44100); // 2 channels, 44.1kHz, 1 second
 * const pcm16Buffer = createPCM16FromAudioBuffer(audioBuffer);
 *
 * // Create a Blob for file download or processing
 * const blob = new Blob([pcm16Buffer], { type: 'audio/pcm' });
 *
 * // Or use directly with other APIs
 * const audioData = new Int16Array(pcm16Buffer);
 * ```
 *
 * @remarks
 * - The function generates raw PCM16 data without any file headers
 * - Supports any number of channels (mono, stereo, surround, etc.)
 * - Preserves the original sample rate from the AudioBuffer
 * - Output is little-endian 16-bit signed integers
 * - No header overhead, making it more efficient for processing
 * - Each sample is 2 bytes (16-bit)
 */ const $0d8536a4cd8d0d17$export$1c5b7794d3e4d402 = (audioBuffer)=>{
    // Extract audio properties from the buffer
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length; // Total number of samples
    // Validate that we're working with mono audio as expected
    // Note: This function is designed to work with mono audio (1 channel) as configured in getUserMedia
    // Calculate buffer size: audio data only (no headers)
    // Each sample is 16-bit (2 bytes), multiplied by number of channels
    const buffer = new ArrayBuffer(length * numChannels * 2);
    const view = new DataView(buffer);
    // Write audio data starting at byte 0
    let offset = 0;
    // Convert each channel's float32 data to int16
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let sample = 0; sample < length; sample++){
            // Convert float32 (-1.0 to 1.0) to int16 (-32768 to 32767)
            // Clamp to prevent overflow
            const floatSample = Math.max(-1, Math.min(1.0, channelData[sample]));
            const int16Sample = Math.round(floatSample * 32767);
            // Write as little-endian 16-bit signed integer
            view.setInt16(offset, int16Sample, true); // true = little-endian
            offset += 2;
        }
    }
    return buffer;
};


/**
 * Creates a WAV file from an AudioBuffer
 *
 * This function converts Web Audio API AudioBuffer data into a standard WAV format
 * that can be saved as a file or transmitted over the network. The function generates
 * a complete WAV file with proper headers including RIFF chunk, format chunk, and data chunk.
 *
 * @param audioBuffer - The AudioBuffer to convert to WAV format. This should contain
 *                      audio data from the Web Audio API (e.g., from MediaRecorder, AudioContext, etc.)
 *
 * @returns An ArrayBuffer containing the complete WAV file data with headers and audio samples.
 *          The audio is encoded as 16-bit PCM at the original sample rate and channel count.
 *
 * @example
 * ```typescript
 * // Convert an AudioBuffer to WAV format
 * const audioBuffer = audioContext.createBuffer(2, 44100, 44100); // 2 channels, 44.1kHz, 1 second
 * const wavBuffer = createWAVFromAudioBuffer(audioBuffer);
 *
 * // Create a Blob for file download
 * const blob = new Blob([wavBuffer], { type: 'audio/wav' });
 * const url = URL.createObjectURL(blob);
 *
 * // Or use directly with other APIs
 * const audioData = new Uint8Array(wavBuffer);
 * ```
 *
 * @remarks
 * - The function generates standard WAV format with 16-bit PCM encoding
 * - Supports any number of channels (mono, stereo, surround, etc.)
 * - Preserves the original sample rate from the AudioBuffer
 * - Output is little-endian as per WAV specification
 * - Header size is always 44 bytes + audio data
 *
 * @see {@link https://en.wikipedia.org/wiki/WAV|WAV file format specification}
 */ const $f5b30fae2e708424$export$279cd95a97baa2e3 = (audioBuffer)=>{
    // Extract audio properties from the buffer
    const numChannels = audioBuffer.numberOfChannels; // Mono = 1, Stereo = 2, etc.
    const sampleRate = audioBuffer.sampleRate; // Samples per second (e.g., 44100 Hz)
    const length = audioBuffer.length; // Total number of samples
    // Calculate buffer size: 44 bytes for WAV header + audio data
    // Each sample is 16-bit (2 bytes), multiplied by number of channels
    const buffer = new ArrayBuffer(44 + length * numChannels * 2);
    const view = new DataView(buffer);
    /**
	 * Helper function to write ASCII strings to the buffer
	 * WAV files use ASCII strings for chunk identifiers
	 */ const writeString = (offset, string)=>{
        for(let i = 0; i < string.length; i++)view.setUint8(offset + i, string.charCodeAt(i));
    };
    // Write WAV file header (44 bytes total)
    // RIFF chunk identifier - indicates this is a RIFF-formatted file
    writeString(0, 'RIFF');
    // File size minus 8 bytes (RIFF identifier + size field)
    // 36 bytes for remaining header + audio data size
    view.setUint32(4, 36 + length * numChannels * 2, true); // true = little-endian
    // WAVE format identifier
    writeString(8, 'WAVE');
    // Format chunk identifier
    writeString(12, 'fmt ');
    // Format chunk size (16 bytes for PCM format)
    view.setUint32(16, 16, true);
    // Audio format (1 = PCM/uncompressed)
    view.setUint16(20, 1, true);
    // Number of channels (1 = mono, 2 = stereo, etc.)
    view.setUint16(22, numChannels, true);
    // Sample rate in Hz (e.g., 44100, 48000)
    view.setUint32(24, sampleRate, true);
    // Byte rate: sample rate * number of channels * bytes per sample
    view.setUint32(28, sampleRate * numChannels * 2, true);
    // Block align: number of channels * bytes per sample
    view.setUint16(32, numChannels * 2, true);
    // Bits per sample (16-bit audio)
    view.setUint16(34, 16, true);
    // Data chunk identifier
    writeString(36, 'data');
    // Data chunk size: total audio data size in bytes
    view.setUint32(40, length * numChannels * 2, true);
    // Write audio data starting at byte 44 (after header)
    let offset = 44;
    // Iterate through each sample in the audio buffer
    for(let i = 0; i < length; i++)// For each sample, write data from all channels
    for(let channel = 0; channel < numChannels; channel++){
        // Get the sample value for this channel and sample index
        // Clamp the value between -1 and 1 (Web Audio API range)
        const sample = Math.max(-1, Math.min(1, audioBuffer.getChannelData(channel)[i]));
        // Convert float sample (-1 to 1) to 16-bit integer
        // For negative values: multiply by 0x8000 (32768)
        // For positive values: multiply by 0x7fff (32767)
        // This ensures proper 16-bit signed integer representation
        view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
        // Move to next sample position (2 bytes per sample)
        offset += 2;
    }
    return buffer;
};


const $31b1773bb64d7438$export$947890ff7373a8ab = async (audioBlob, lastProcessedPosition, sampleRate = 24000)=>{
    const arrayBuffer = await audioBlob.arrayBuffer();
    const audioContext = new AudioContext({
        sampleRate: sampleRate
    });
    try {
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const totalSamples = audioBuffer.length;
        const newSamples = totalSamples - lastProcessedPosition;
        if (newSamples <= 0) {
            await audioContext.close();
            return {
                audioBuffer: null,
                newAudioEndPosition: 0
            };
        }
        const newAudioStart = lastProcessedPosition;
        const newAudioEndPosition = totalSamples;
        const newAudioLength = newAudioEndPosition - newAudioStart;
        const newAudioBuffer = audioContext.createBuffer(audioBuffer.numberOfChannels, newAudioLength, audioBuffer.sampleRate);
        // Copy audio data from the specified range for each channel
        for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
            const channelData = audioBuffer.getChannelData(channel);
            const newChannelData = newAudioBuffer.getChannelData(channel);
            newChannelData.set(channelData.slice(newAudioStart, newAudioEndPosition));
        }
        await audioContext.close();
        return {
            audioBuffer: newAudioBuffer,
            newAudioEndPosition: newAudioEndPosition
        };
    } catch (error) {
        await audioContext.close();
        throw error;
    }
};


const $73101da86f523d32$export$e8bef16f28ed7bfe = async (audioChunks, lastProcessedPosition, sampleRate, audioGain = {
    enableGain: false,
    gainFactor: 3.0,
    autoNormalize: false,
    targetRMS: 0.2,
    preventClipping: true
})=>{
    const completeAudio = new Blob(audioChunks);
    const { audioBuffer: audioBuffer, newAudioEndPosition: newAudioEndPosition } = await (0, $31b1773bb64d7438$export$947890ff7373a8ab)(completeAudio, lastProcessedPosition, sampleRate);
    if (!audioBuffer) return {
        audioString: null,
        newAudioEndPosition: newAudioEndPosition
    };
    // Apply audio gain if enabled
    let processedAudioBuffer = audioBuffer;
    if (audioGain.enableGain) {
        const { gainFactor: gainFactor = 1.0, autoNormalize: autoNormalize = false, targetRMS: targetRMS = 0.2, preventClipping: preventClipping = true } = audioGain;
        const finalGainFactor = autoNormalize ? (0, $740746d2cbc3cc73$export$a4f04dc9b8c85a93)(audioBuffer, targetRMS) : gainFactor;
        processedAudioBuffer = (0, $740746d2cbc3cc73$export$fdc1ec94e71033b9)(audioBuffer, finalGainFactor, preventClipping);
    }
    const wavBuffer = (0, $f5b30fae2e708424$export$279cd95a97baa2e3)(processedAudioBuffer);
    const wavBlob = new Blob([
        wavBuffer
    ], {
        type: 'audio/wav'
    });
    const audioString = await (0, $85e69f175dc787f8$export$c5d4e064eaa9ff1f)(wavBlob);
    const transcription = await (0, $d4d8bb8b0048aed9$export$e70ce39e35650c8d)({
        audioString: audioString
    });
    return {
        transcription: transcription[0],
        newAudioEndPosition: newAudioEndPosition
    };
};
const $73101da86f523d32$export$a9f63bcc44fdaea4 = async (audioChunks, lastProcessedPosition, sampleRate, soundDetection = {
    enableSoundDetection: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientEnableSoundDetection', false),
    useComprehensiveDetection: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientUseComprehensiveDetection', false),
    soundThreshold: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientSoundThreshold', 0.005)
}, audioGain = {
    enableGain: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientEnableGain', false),
    gainFactor: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientGainFactor', 3.0),
    autoNormalize: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientAutoNormalize', false),
    targetRMS: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientTargetRMS', 0.2),
    preventClipping: (0, $c6GJD.default).getExperimentValue('ai-stt-prompt', 'clientPreventClipping', true)
})=>{
    const { enableSoundDetection: enableSoundDetection, useComprehensiveDetection: useComprehensiveDetection, soundThreshold: soundThreshold } = soundDetection;
    const completeAudio = new Blob(audioChunks);
    const { audioBuffer: audioBuffer, newAudioEndPosition: newAudioEndPosition } = await (0, $31b1773bb64d7438$export$947890ff7373a8ab)(completeAudio, lastProcessedPosition, sampleRate);
    if (!audioBuffer) return {
        audioString: null,
        newAudioEndPosition: newAudioEndPosition
    };
    if (enableSoundDetection) {
        const hasSound = useComprehensiveDetection ? (0, $6c5f2eec39a185b4$export$7c7be76b9ed1e76f)(audioBuffer, {
            rmsThreshold: soundThreshold
        }) : (0, $6c5f2eec39a185b4$export$fb7d0dbec0b9c428)(audioBuffer, soundThreshold);
        if (!hasSound) return {
            audioString: null,
            newAudioEndPosition: newAudioEndPosition
        };
    }
    let processedAudioBuffer = audioBuffer;
    if (audioGain.enableGain) {
        const { gainFactor: gainFactor = 1.0, autoNormalize: autoNormalize = false, targetRMS: targetRMS = 0.2, preventClipping: preventClipping = true } = audioGain;
        const finalGainFactor = autoNormalize ? (0, $740746d2cbc3cc73$export$a4f04dc9b8c85a93)(audioBuffer, targetRMS) : gainFactor;
        processedAudioBuffer = (0, $740746d2cbc3cc73$export$fdc1ec94e71033b9)(audioBuffer, finalGainFactor, preventClipping);
    }
    const pcm16Buffer = (0, $0d8536a4cd8d0d17$export$1c5b7794d3e4d402)(processedAudioBuffer);
    const pcm16Blob = new Blob([
        pcm16Buffer
    ], {
        type: 'audio/pcm'
    });
    const audioString = await (0, $85e69f175dc787f8$export$c5d4e064eaa9ff1f)(pcm16Blob);
    return {
        audioString: audioString,
        newAudioEndPosition: newAudioEndPosition
    };
};





class $fa8ffd328dcba7ca$export$b5efe1d364105d67 {
    async startRecording() {
        this.resetInMemoryState();
        this.onTranscription({
            type: 'SET_INITIALIZING'
        });
        await this.connectWebSocketConvoAIAPI();
        this.mediaStream = await navigator.mediaDevices.getUserMedia({
            audio: {
                sampleRate: this.sampleRate,
                echoCancellation: true,
                noiseSuppression: true,
                autoGainControl: true
            }
        });
        // eslint-disable-next-line compat/compat
        this.mediaRecorder = new MediaRecorder(this.mediaStream, {
            audioBitsPerSecond: this.audioBitsPerSecond,
            mimeType: 'audio/webm'
        });
        this.mediaRecorder.start(this.timeSlice);
        this.mediaRecorder.addEventListener('dataavailable', this.onMediaRecorderDataAvailable);
        this.mediaRecorder.addEventListener('stop', this.onMediaRecorderStop);
        this.mediaRecorder.addEventListener('error', this.onMediaRecorderError);
        this.recordingTimeout = setTimeout(()=>{
            this.stopRecording((0, $6VMxF.VoiceDictationStopReason).TimeoutAccepted);
        }, this.maxRecordingDurationMs);
    }
    stopRecording(stopReason = (0, $6VMxF.VoiceDictationStopReason).StoppedAccepted) {
        this.insertEmptySpaceIntoTranscription();
        this.clearRecordingTimeout();
        this.onTrace?.({
            type: 'STOP_RECORDING',
            payload: {
                stopReason: stopReason
            }
        });
        this.onTranscription({
            type: 'SET_STOPPED',
            payload: {
                stopReason: stopReason
            }
        });
        this.mediaRecorder?.stop();
    }
    async connectWebSocketConvoAIAPI() {
        try {
            this.onTrace?.({
                type: 'START_WEBSOCKET_CONNECTION'
            });
            this.convoAIWebSocketAPI = await (0, $f81391bdbd232abd$export$843496a58dc19cce).create(this.cloudID, this.product, this.experience, this.onMessage);
            this.onTrace?.({
                type: 'WEBSOCKET_CONNECTION_SUCCESS'
            });
            this.convoAIWebSocketAPI.updateTranscriptionConfig();
        } catch (error) {
            this.onTranscription({
                type: 'SET_ERROR',
                payload: {
                    error: error instanceof Error ? error.message : 'Unknown error'
                }
            });
            this.onTrace?.({
                type: 'ERROR',
                payload: {
                    error: error instanceof Error ? error.message : 'Unknown error'
                }
            });
        }
    }
    insertEmptySpaceIntoTranscription() {
        if (this.transcription) {
            this.transcription = this.transcription + ' ';
            this.onTranscription({
                type: 'SET_RECORDING',
                payload: {
                    transcription: this.transcription,
                    chunkIndex: this.chunkIndex
                }
            });
        }
    }
    clearRecordingTimeout() {
        if (this.recordingTimeout) {
            clearTimeout(this.recordingTimeout);
            this.recordingTimeout = null;
        }
    }
    resetInMemoryState() {
        this.chunkIndex = 0;
        this.createdItemChunkIndex = 0;
        this.lastProcessedPosition = 0;
        this.processedChunksCountAfterLastCommit = 0;
        this.lastAudioChunkWasProcessed = false;
        this.transcription = null;
        this.audioChunks = [];
        this.clearRecordingTimeout();
    }
    constructor(options){
        this.audioChunks = [];
        this.lastProcessedPosition = 0;
        this.processedChunksCountAfterLastCommit = 0;
        this.convoAIWebSocketAPI = null;
        this.mediaStream = null;
        this.mediaRecorder = null;
        this.lastAudioChunkWasProcessed = false;
        this.recordingTimeout = null;
        this.transcription = null;
        this.chunkIndex = 0;
        this.createdItemChunkIndex = 0;
        this.cloudID = void 0;
        this.sampleRate = void 0;
        this.audioBitsPerSecond = void 0;
        this.timeSlice = void 0;
        this.maxRecordingDurationMs = void 0;
        this.product = void 0;
        this.experience = void 0;
        this.onTrace = void 0;
        this.onTranscription = void 0;
        this.onMessage = (event)=>{
            switch(event.type){
                case (0, $f81391bdbd232abd$export$b1a2c42ac49f689c).TranscriptionResponseDelta:
                    this.transcription = this.transcription ? this.transcription + event.delta : event.delta;
                    this.chunkIndex++;
                    this.onTranscription({
                        type: 'SET_RECORDING',
                        payload: {
                            transcription: this.transcription,
                            chunkIndex: this.chunkIndex
                        }
                    });
                    break;
                case (0, $f81391bdbd232abd$export$b1a2c42ac49f689c).TranscriptionItemCreated:
                    this.createdItemChunkIndex++;
                    this.onTrace?.({
                        type: 'TRANSCRIPTION_ITEM_CREATED',
                        payload: {
                            createdItemChunkIndex: this.createdItemChunkIndex
                        }
                    });
                    this.insertEmptySpaceIntoTranscription();
                    break;
            }
        };
        this.onMediaRecorderStop = ()=>{
            this.mediaStream?.getTracks().forEach((track)=>track.stop());
            this.convoAIWebSocketAPI?.disconnect();
        };
        this.onMediaRecorderError = (event)=>{
            this.onTranscription({
                type: 'SET_ERROR',
                payload: {
                    error: event.message
                }
            });
            this.onTrace?.({
                type: 'ERROR',
                payload: {
                    error: event.message
                }
            });
        };
        this.onMediaRecorderDataAvailable = async (event)=>{
            this.audioChunks.push(event.data);
            try {
                const { audioString: audioString, newAudioEndPosition: newAudioEndPosition } = await (0, $73101da86f523d32$export$a9f63bcc44fdaea4)(this.audioChunks, this.lastProcessedPosition, this.sampleRate);
                this.lastProcessedPosition = newAudioEndPosition;
                if (audioString) {
                    this.lastAudioChunkWasProcessed = true;
                    this.processedChunksCountAfterLastCommit++;
                    this.convoAIWebSocketAPI?.sendAudio(audioString);
                } else if (audioString === null && this.lastAudioChunkWasProcessed) {
                    this.convoAIWebSocketAPI?.commitAudio();
                    this.processedChunksCountAfterLastCommit = 0;
                    this.lastAudioChunkWasProcessed = false;
                }
            } catch (error) {
                this.onTranscription({
                    type: 'SET_ERROR',
                    payload: {
                        error: error instanceof Error ? error.message : 'Unknown error'
                    }
                });
                this.onTrace?.({
                    type: 'ERROR',
                    payload: {
                        error: error instanceof Error ? error.message : 'Unknown error'
                    }
                });
            }
        };
        const { onTranscription: onTranscription, cloudID: cloudID, sampleRate: sampleRate = 24000, audioBitsPerSecond: audioBitsPerSecond = 16000, timeSlice: timeSlice = 1000, maxRecordingDurationMs: maxRecordingDurationMs = 60000, onTrace: onTrace, product: product = 'confluence', experience: experience = 'confluence-ai-first-creation' } = options;
        this.onTranscription = onTranscription;
        this.cloudID = cloudID;
        this.sampleRate = sampleRate;
        this.audioBitsPerSecond = audioBitsPerSecond;
        this.timeSlice = timeSlice;
        this.maxRecordingDurationMs = maxRecordingDurationMs;
        this.onTrace = onTrace;
        this.product = product;
        this.experience = experience;
    }
}





const $b552144d758fc88c$export$ba4cb2752281b87f = (onVoiceDictationUpdate, cloudID, audioBitsPerSecond = 16000, sampleRate = 24000, timeSlice = 1000, maxRecordingDurationMs = 60000)=>{
    const { sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, isInSmartCreateFlow: isInSmartCreateFlow } = (0, $42omo.useContext)((0, $TwPkE.SharedFeaturesInstrumentationIdContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultDiscarded: trackAIResultDiscarded } = (0, $fYQcF.useAIEventsInstrumentation)({
        product: 'platform',
        subproduct: 'platform',
        aiFeatureName: 'aiVoiceDictation',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        additionalAttributes: {
            productAttributionOverride: 'confluence',
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    });
    const { start: start, success: success, startConnectionAttempt: startConnectionAttempt, successConnectionEstablished: successConnectionEstablished, reportTTFB: reportTTFB, reportRTT: reportRTT, failure: failure } = (0, $0e9683b90b7b6f6f$export$9a1b2bd9844b88ce)('streaming-stt', 'ai-speech-to-text');
    const [result, dispatch] = (0, $42omo.useReducer)((0, $2ca98075bc15791d$export$35a6f2c29539ef8f), {
        state: (0, $6VMxF.VoiceDictationState).Uninitialized,
        transcription: null
    });
    const trace = (0, $42omo.useCallback)((action)=>{
        (0, $dWJ5i.match)(action).with({
            type: 'START_WEBSOCKET_CONNECTION'
        }, ()=>{
            start();
            startConnectionAttempt();
        }).with({
            type: 'WEBSOCKET_CONNECTION_SUCCESS'
        }, ()=>{
            successConnectionEstablished();
        }).with({
            type: 'TRANSCRIPTION_ITEM_CREATED',
            payload: {
                createdItemChunkIndex: 1
            }
        }, ()=>{
            // Time to First Byte for first chunk
            reportTTFB();
        }).with({
            type: 'TRANSCRIPTION_ITEM_CREATED',
            payload: {
                createdItemChunkIndex: (0, $dWJ5i.P).number
            }
        }, ({ payload: { createdItemChunkIndex: createdItemChunkIndex } })=>{
            // Round-trip time between received server messages
            reportRTT(createdItemChunkIndex);
        }).with({
            type: 'STOP_RECORDING'
        }, (stopAction)=>{
            success({
                metadata: {
                    stopReason: stopAction.payload.stopReason
                }
            });
        }).with({
            type: 'ERROR'
        }, (errorAction)=>{
            failure({
                metadata: {
                    error: errorAction.payload.error
                }
            });
        }).exhaustive();
    }, [
        reportRTT,
        reportTTFB,
        start,
        startConnectionAttempt,
        successConnectionEstablished,
        failure,
        success
    ]);
    const speechToTextManager = (0, $42omo.useRef)(new (0, $fa8ffd328dcba7ca$export$b5efe1d364105d67)({
        onTranscription: (action)=>dispatch(action),
        onTrace: (action)=>trace(action),
        cloudID: cloudID,
        sampleRate: sampleRate,
        audioBitsPerSecond: audioBitsPerSecond,
        timeSlice: timeSlice,
        maxRecordingDurationMs: maxRecordingDurationMs
    }));
    (0, $42omo.useEffect)(()=>{
        onVoiceDictationUpdate(result);
    }, [
        result,
        onVoiceDictationUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $dWJ5i.match)(result).with({
            state: (0, $6VMxF.VoiceDictationState).Initializing
        }, ()=>trackAIInteractionInit()).with({
            state: (0, $6VMxF.VoiceDictationState).Recording,
            chunkIndex: 1
        }, ()=>trackAIResultView()).with({
            state: (0, $6VMxF.VoiceDictationState).Stopped,
            stopReason: (0, $6VMxF.VoiceDictationStopReason).StoppedAccepted
        }, ()=>trackAIResultAction('STTAcceptedByUser')).with({
            state: (0, $6VMxF.VoiceDictationState).Stopped,
            stopReason: (0, $6VMxF.VoiceDictationStopReason).StoppedRejected
        }, ()=>trackAIResultDiscarded('STTRejectedByUser')).with({
            state: (0, $6VMxF.VoiceDictationState).Stopped,
            stopReason: (0, $6VMxF.VoiceDictationStopReason).TimeoutAccepted
        }, ()=>trackAIResultAction('STTAcceptedDueToTimeout')).with({
            state: (0, $6VMxF.VoiceDictationState).Error
        }, (errorResult)=>trackAIResultError({
                aiErrorMessage: errorResult.error
            })).with((0, $dWJ5i.P)._, ()=>{}).exhaustive();
    }, [
        result,
        trackAIInteractionInit,
        trackAIInteractionDismiss,
        trackAIResultView,
        trackAIResultError,
        trackAIResultAction,
        trackAIResultDiscarded
    ]);
    const startRecording = (0, $42omo.useCallback)(()=>{
        speechToTextManager.current.startRecording();
    }, []);
    const stopRecording = (0, $42omo.useCallback)((stopReason = (0, $6VMxF.VoiceDictationStopReason).StoppedAccepted)=>{
        speechToTextManager.current.stopRecording(stopReason);
    }, []);
    (0, $42omo.useEffect)(()=>{
        return ()=>stopRecording();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return [
        result,
        {
            startRecording: startRecording,
            stopRecording: stopRecording
        }
    ];
};
module.exports["useVoiceDictation"] = $b552144d758fc88c$export$ba4cb2752281b87f;

});

parcelRegister("6VMxF", function(module, exports) {
var $486b2ac72fd82779$export$1684d4fa8efc3301 = /*#__PURE__*/ function(VoiceDictationState) {
    VoiceDictationState["Initializing"] = "Initializing";
    VoiceDictationState["Uninitialized"] = "Uninitialized";
    VoiceDictationState["Unsupported"] = "Unsupported";
    VoiceDictationState["Recording"] = "Recording";
    VoiceDictationState["Stopped"] = "Stopped";
    VoiceDictationState["Error"] = "Error";
    return VoiceDictationState;
}({});
var $486b2ac72fd82779$export$1ba6d610c872ae71 = /*#__PURE__*/ function(VoiceDictationStopReason) {
    VoiceDictationStopReason["StoppedAccepted"] = "STOPPED_ACCEPTED";
    VoiceDictationStopReason["StoppedRejected"] = "STOPPED_REJECTED";
    VoiceDictationStopReason["TimeoutAccepted"] = "TIMEOUT_ACCEPTED";
    return VoiceDictationStopReason;
}({});
module.exports["VoiceDictationState"] = $486b2ac72fd82779$export$1684d4fa8efc3301;
module.exports["VoiceDictationStopReason"] = $486b2ac72fd82779$export$1ba6d610c872ae71;

});

parcelRegister("euw6P", function(module, exports) {

var $8C5kA = parcelRequire("8C5kA");


var $477dG = parcelRequire("477dG");


var $gVoWJ = parcelRequire("gVoWJ");


var $1JdaQ = parcelRequire("1JdaQ");


var $agrUc = parcelRequire("agrUc");


var $eyggb = parcelRequire("eyggb");


var $fYKTL = parcelRequire("fYKTL");


var $5HHoF = parcelRequire("5HHoF");


var $5u7tz = parcelRequire("5u7tz");


var $gCiM9 = parcelRequire("gCiM9");


var $dh538 = parcelRequire("dh538");


var $jhcFr = parcelRequire("jhcFr");


var $42omo = parcelRequire("42omo");


var $1S4f7 = parcelRequire("1S4f7");


var $l6okE = parcelRequire("l6okE");


var $2pjJ5 = parcelRequire("2pjJ5");


var $ks2lK = parcelRequire("ks2lK");


var $4pEXC = parcelRequire("4pEXC");

const $88bdc5831095534b$export$811d95c3175e32b1 = ({ config: { onArrowUp: onArrowUp, onArrowDown: onArrowDown, onInputChange: onInputChange }, api: api })=>{
    return {
        name: 'arrowKeyPlugin',
        pmPlugins () {
            return [
                {
                    name: 'arrowKeyPlugin',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            props: {
                                handleTextInput: ()=>{
                                    onInputChange();
                                },
                                handleKeyDown: (view, event)=>{
                                    if (event.key === 'Backspace') onInputChange();
                                    if (!(0, $l6okE.atTheBeginningOfDoc)(view.state)) return;
                                    if (event.key === 'ArrowUp') onArrowUp({
                                        replaceDocument: (value)=>api?.core.actions.replaceDocument(value),
                                        view: view
                                    });
                                    else if (event.key === 'ArrowDown') onArrowDown({
                                        replaceDocument: (value)=>{
                                            api?.core.actions.replaceDocument(value);
                                            // Needed because the down arrow by default moves the cursor to the end of the input
                                            // preventDefault, stopPropagation, etc. doesn't work to prevent this in this callback
                                            // So we need to wait for the next tick to move the cursor to the start of the input
                                            new Promise((resolve)=>{
                                                setTimeout(()=>{
                                                    view.dispatch(view.state.tr.setSelection(new (0, $ks2lK.TextSelection)(view.state.tr.doc.resolve(0), view.state.tr.doc.resolve(0))));
                                                    resolve(true);
                                                }, 0);
                                            });
                                        },
                                        view: view
                                    });
                                }
                            }
                        });
                    }
                }
            ];
        }
    };
};
const $88bdc5831095534b$export$bb1e6e55f39d8be9 = ({ userMessages: userMessages })=>{
    const storeMessagesRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(userMessages);
    storeMessagesRef.current = userMessages;
    const currentMessageRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        currentMessageRef.current = undefined;
    }, [
        userMessages.length
    ]);
    const moveMessageUpOrDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ replaceDocument: replaceDocument, position: position, view: view })=>{
        const increment = position === 'up' ? -1 : 1;
        const isEmpty = (0, $2pjJ5.isEmptyDocument)(view.state.doc);
        if (!storeMessagesRef.current.length) return;
        // If the input is not empty and the current message is not set(it's not the history message), do nothing
        if (!isEmpty && currentMessageRef.current === undefined) return;
        const currentMessageIndex = currentMessageRef.current ? storeMessagesRef.current.findIndex((message)=>message.id === currentMessageRef.current?.id) : storeMessagesRef.current.length;
        // If the currentindex is humanMessages.length, the next index will either be the last message (pressing up)
        // or out of bounds (pressing down and resetting the current message to undefined)
        const newMessageIndex = Math.max(0, currentMessageIndex + increment);
        const newMessage = storeMessagesRef.current[newMessageIndex];
        currentMessageRef.current = newMessage;
        replaceDocument(newMessage?.content ?? (0, $4pEXC.encodeAdf)(''));
    }, []);
    const handleArrowUp = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ replaceDocument: replaceDocument, view: view })=>{
        moveMessageUpOrDown({
            replaceDocument: replaceDocument,
            position: 'up',
            view: view
        });
    }, [
        moveMessageUpOrDown
    ]);
    const handleArrowDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ replaceDocument: replaceDocument, view: view })=>{
        moveMessageUpOrDown({
            replaceDocument: replaceDocument,
            position: 'down',
            view: view
        });
    }, [
        moveMessageUpOrDown
    ]);
    const handleInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        // Reset the current message to undefined when input gets updated
        currentMessageRef.current = undefined;
    }, []);
    return {
        handleArrowUp: handleArrowUp,
        handleArrowDown: handleArrowDown,
        handleInputChange: handleInputChange
    };
};



var $cgtv4 = parcelRequire("cgtv4");

var $5335087dbbae3a25$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    placeholder: {
        id: "ai-mate.chat-input.placeholder",
        defaultMessage: "Write a prompt to get started"
    }
});


const $dd4d4a3c0d9a1cfa$export$451e6f6982270493 = 256000;
const $dd4d4a3c0d9a1cfa$export$22e9fc2aa16bb38f = ({ onSave: onSave, arrowKeyPluginConfig: arrowKeyPluginConfig, productKey: productKey, siteId: siteId, placeholderPrompts: placeholderPrompts, linkPickerOptions: linkPickerOptions = {} })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const linkPicker = (0, $jhcFr.useLinkPickerEditorProps)(linkPickerOptions, {
        cloudId: siteId,
        product: productKey
    });
    const { handleArrowDown: handleArrowDown, handleArrowUp: handleArrowUp, handleInputChange: handleInputChange } = (0, $88bdc5831095534b$export$bb1e6e55f39d8be9)({
        userMessages: arrowKeyPluginConfig.userMessages
    });
    const { preset: preset, editorApi: editorApi } = (0, $1JdaQ.usePreset)(()=>{
        const placeholderConfig = placeholderPrompts && (0, $dh538.fg)('aifc_create_enabled') ? {
            placeholderPrompts: placeholderPrompts
        } : {
            placeholder: formatMessage((0, $5335087dbbae3a25$export$2e2bcd8739ae039).placeholder)
        };
        return (0, $gVoWJ.createDefaultPreset)({
            placeholder: placeholderConfig,
            hyperlinkOptions: {
                linkPicker: linkPicker,
                lpLinkPicker: true
            },
            blockType: {
                allowBlockType: {
                    exclude: [
                        'heading'
                    ]
                },
                lastNodeMustBeParagraph: true
            },
            toolbar: {
                enableNewToolbarExperience: false
            }
        }).add([
            (0, $gCiM9.saveOnEnterPlugin),
            onSave
        ]).add((0, $5u7tz.mentionsPlugin)).add((0, $fYKTL.gridPlugin)).add([
            (0, $agrUc.cardPlugin),
            {
                allowBlockCards: false,
                allowEmbeds: false,
                linkPicker: linkPicker,
                lpLinkPicker: true,
                provider: Promise.resolve((0, $477dG.editorCardProvider))
            }
        ]).add((0, $5HHoF.listPlugin)).maybeAdd((0, $eyggb.extensionPlugin), (0, $dh538.fg)('rovo_chat_editor_add_extension_plugin')).add([
            (0, $88bdc5831095534b$export$811d95c3175e32b1),
            {
                onArrowDown: handleArrowDown,
                onArrowUp: handleArrowUp,
                onInputChange: handleInputChange
            }
        ]);
    }, []);
    return {
        preset: preset,
        editorApi: editorApi
    };
};
module.exports["MAX_CHARACTERS_INPUT"] = $dd4d4a3c0d9a1cfa$export$451e6f6982270493;
module.exports["useEditorPreset"] = $dd4d4a3c0d9a1cfa$export$22e9fc2aa16bb38f;

});

parcelRegister("5fzJo", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $a2921a3f0cac1584$var$initialState = {};
const $a2921a3f0cac1584$export$f80440bac8b4447 = $a2921a3f0cac1584$var$initialState;
const $a2921a3f0cac1584$var$rovoMentionProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($a2921a3f0cac1584$var$initialState);
const $a2921a3f0cac1584$export$188c81c2e93279c4 = $a2921a3f0cac1584$var$rovoMentionProvider.Provider;
const $a2921a3f0cac1584$export$c577383a2f7ca57d = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($a2921a3f0cac1584$var$rovoMentionProvider);
module.exports["useRovoMentionProvider"] = $a2921a3f0cac1584$export$c577383a2f7ca57d;

});

parcelRegister("2e6ow", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $4pEXC = parcelRequire("4pEXC");

const $e5657d5e856c1c46$export$b663bc0d84e6eaa6 = '`';
const $e5657d5e856c1c46$var$state = (0, $1P1Tu.createStore)({
    initialState: {
        placeholder: null
    },
    actions: {
        setPlaceholder: (placeholder)=>({ setState: setState })=>{
                setState({
                    placeholder: placeholder
                });
            }
    }
});
const $e5657d5e856c1c46$export$caaec55db704374b = (0, $9zUhf.createHook)($e5657d5e856c1c46$var$state);
const $e5657d5e856c1c46$var$getPlaceholderType = (placeholderLabel)=>{
    switch(placeholderLabel){
        case 'person':
            return 'person';
        case 'skill':
            return 'skill';
        default:
            return 'link';
    }
};
const $e5657d5e856c1c46$var$isPromptWithPlaceholder = (prompt)=>{
    return prompt.includes($e5657d5e856c1c46$export$b663bc0d84e6eaa6);
};
const $e5657d5e856c1c46$export$96ba721a063d462c = ()=>{
    const [{ placeholder: placeholder }, { setPlaceholder: setPlaceholder }] = $e5657d5e856c1c46$export$caaec55db704374b();
    const insertPlaceholder = (0, $42omo.useCallback)((prompt, overrideType)=>{
        if (overrideType === 'skill') {
            const { adf: adf, promptLength: promptLength } = (0, $4pEXC.encodeSkillPromptToAdf)(prompt);
            setPlaceholder({
                prompt: prompt,
                adfDocument: adf,
                type: 'generic',
                selectionStartIndex: promptLength,
                selectionEndIndex: promptLength
            });
            return;
        }
        const startIndexOfPlaceholder = prompt.indexOf($e5657d5e856c1c46$export$b663bc0d84e6eaa6);
        const endIndexOfPlaceholder = prompt.lastIndexOf($e5657d5e856c1c46$export$b663bc0d84e6eaa6);
        if (startIndexOfPlaceholder !== -1 && endIndexOfPlaceholder !== -1) {
            const placeholderLabel = prompt.slice(startIndexOfPlaceholder + 1, endIndexOfPlaceholder);
            const placeholderType = overrideType ?? $e5657d5e856c1c46$var$getPlaceholderType(placeholderLabel);
            const selectionStartIndex = startIndexOfPlaceholder + 1;
            const selectionEndIndex = endIndexOfPlaceholder;
            const promptWithoutBackticks = prompt.replace(new RegExp($e5657d5e856c1c46$export$b663bc0d84e6eaa6, 'g'), '');
            const adfDocument = (0, $4pEXC.encodeAdf)(promptWithoutBackticks);
            setPlaceholder({
                prompt: promptWithoutBackticks,
                adfDocument: adfDocument,
                type: placeholderType,
                selectionStartIndex: selectionStartIndex,
                selectionEndIndex: selectionEndIndex
            });
        } else // A proper placeholder was not found
        setPlaceholder({
            prompt: prompt,
            type: 'generic',
            selectionStartIndex: prompt.length + 1,
            selectionEndIndex: prompt.length + 1
        });
    }, [
        setPlaceholder
    ]);
    const clearPlaceholder = (0, $42omo.useCallback)(()=>{
        setPlaceholder(null);
    }, [
        setPlaceholder
    ]);
    return {
        insertPlaceholder: insertPlaceholder,
        clearPlaceholder: clearPlaceholder,
        placeholder: placeholder,
        isPromptWithPlaceholder: $e5657d5e856c1c46$var$isPromptWithPlaceholder
    };
};
module.exports["useEditorPlaceholder"] = $e5657d5e856c1c46$export$96ba721a063d462c;

});

parcelRegister("6Y7nw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $dpPtd = parcelRequire("dpPtd");


var $a3fRD = parcelRequire("a3fRD");


var $gdv5Z = parcelRequire("gdv5Z");


var $16lEl = parcelRequire("16lEl");

var $kIvLT = parcelRequire("kIvLT");


var $5MO1q = parcelRequire("5MO1q");

var $h26dv = parcelRequire("h26dv");

var $29BPs = parcelRequire("29BPs");


var $bJOL1 = parcelRequire("bJOL1");


var $cgtv4 = parcelRequire("cgtv4");

var $34c8be18a88f108e$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    unsupportedFile: {
        id: "ai-mate.upload-files-to-conversation.unsupported-file",
        defaultMessage: "Unsupported file type"
    },
    unknownError: {
        id: "ai-mate.upload-files-to-conversation.unknown-error",
        defaultMessage: "There was an error uploading the file. Please try again."
    },
    fileRaiPolicyViolationError: {
        id: "ai-mate.upload-files-to-conversation.file-rai-policy-violation",
        defaultMessage: "The file might not comply with our Acceptable Use Policy. Try a different file."
    },
    failToValidateFilesTitle: {
        id: "ai-mate.upload-files-to-conversation.fail-to-validate-files-title",
        defaultMessage: "Failed to validate files"
    },
    failToValidateFilesDescription: {
        id: "ai-mate.upload-files-to-conversation.fail-to-validate-files-description",
        defaultMessage: "Error occurred while validating files, please try again."
    },
    invalidFilesTitle: {
        id: "ai-mate.upload-files-to-conversation.refresh.invalid-files-title",
        defaultMessage: "{count, plural, one {File type} other {File types}} not supported"
    },
    invalidFilesDescription: {
        id: "ai-mate.upload-files-to-conversation.refresh.invalid-files-description",
        defaultMessage: "{count, plural, one {The file \"{fileNames}\" is not supported. Reason: {reasons}} other {The following files: \"{fileNames}\" are not supported. Reason: {reasons}}}"
    },
    fileInvalidIconLabel: {
        id: "ai-mate.upload-files-to-conversation.file-invalid-icon-label",
        defaultMessage: "File is invalid"
    },
    validationErrorInvalidContentType: {
        id: "ai-mate.upload-files-to-conversation.validation-error-invalid-content-type",
        defaultMessage: "File type is not supported"
    },
    validationErrorFileTooLarge: {
        id: "ai-mate.upload-files-to-conversation.validation-error-file-too-large",
        defaultMessage: "File size is too large"
    },
    validationErrorFileNameMissing: {
        id: "ai-mate.upload-files-to-conversation.validation-error-file-name-missing",
        defaultMessage: "File name is missing"
    },
    validationErrorUnknownError: {
        id: "ai-mate.upload-files-to-conversation.validation-error-unknown-error",
        defaultMessage: "Fail to validate file for unknown reason"
    },
    validationErrorMissingErrorCode: {
        id: "ai-mate.upload-files-to-conversation.validation-error-missing-error-code",
        defaultMessage: "Validation result unknown"
    },
    validationErrorNotFound: {
        id: "ai-mate.upload-files-to-conversation.validation-error-not-found",
        defaultMessage: "Validation result is not found"
    }
});





var $flpNp = parcelRequire("flpNp");


var $3X525 = parcelRequire("3X525");


const $b19d6aa036e9e860$export$c71ec59453b6867a = (addedFiles, currentFiles)=>{
    const remainingSlots = (0, $3X525.MAX_FILES) - currentFiles.length;
    const limitedFiles = addedFiles.slice(0, remainingSlots > 0 ? remainingSlots : 0);
    return limitedFiles;
};
const $b19d6aa036e9e860$export$1156f3d82b1d9e10 = (errorCode)=>{
    switch(errorCode){
        case 'INVALID_CONTENT_TYPE':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorInvalidContentType;
        case 'FILE_TOO_LARGE':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorFileTooLarge;
        case 'FILE_NAME_MISSING':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorFileNameMissing;
        case 'VALIDATION_RESULT_MISSING_ERROR_CODE':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorMissingErrorCode;
        case 'VALIDATION_RESULT_NOT_FOUND':
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorNotFound;
        case 'UNKNOWN_ERROR':
        default:
            return (0, $34c8be18a88f108e$export$2e2bcd8739ae039).validationErrorUnknownError;
    }
};
const $b19d6aa036e9e860$export$4c9efc922a2449ec = (error)=>{
    if (!(0, $flpNp.isApiError)(error)) return false;
    return error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).UNSUPPORTED_FILE_TYPE || error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).FILE_SIZE_TOO_LARGE || error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).FILE_RAI_POLICY_VIOLATION;
};


const $2dc4faee3a604e24$export$1e28ba9a04bf7961 = (0, $h26dv.createHookWithAssistanceService)(({ key: key, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $fBMbo.di)((0, $dpPtd.useFlags), (0, $kIvLT.useAnalytics));
    const [files, { addFiles: addFiles, removeFile: removeFile, clearFiles: clearFiles, updateFileWithName: updateFileWithName, clearAttachments: clearAttachments }] = (0, $bJOL1.useFileAttachmentsStore)(key);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const anyFilesUploading = (0, $42omo.useMemo)(()=>{
        return files.some((file)=>file.isLoading);
    }, [
        files
    ]);
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const { mutate: mutateUploadFiles, isSubmitting: isSubmittingUploadFiles } = (0, $29BPs.useMutation)({
        mutationFn: (payload)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION,
                name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
            });
            addFiles(key, [
                {
                    id: '',
                    name: payload.file.name,
                    isLoading: true,
                    fileObject: (0, $c6GJD.default).getExperimentValue('rovo_chat_file_previews_experiment', 'isEnabled', false) ? payload.file : undefined
                }
            ]);
            return assistanceService.uploadFiles({
                files: [
                    payload.file
                ]
            });
        },
        onSuccess: ({ data: data })=>{
            data.forEach((file)=>{
                updateFileWithName(key, file.name, {
                    id: file.id,
                    isLoading: false
                });
                sendAnalyticsEvent({
                    action: 'added',
                    actionSubject: 'rovoChatContext',
                    actionSubjectId: 'file',
                    attributes: {
                        fileType: file.type || 'unknown',
                        fileSize: file.size || 0
                    }
                });
            });
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
            });
        },
        onError: (error, payload)=>{
            const errorMessage = (()=>{
                if (error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).UNSUPPORTED_FILE_TYPE) return formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).unsupportedFile);
                if (error.errorAttributes.errorCode === (0, $5MO1q.ASSISTANCE_SERVICE_ERROR_CODES).FILE_SIZE_TOO_LARGE) return error.errorAttributes.rawErrorMessage;
                // Not handled by /validation due to requirement of CSAM check, we need to store the file first.
                // Check: https://atlassian.slack.com/archives/C0677M19GU9/p1751941718503669?thread_ts=1751919192.446729&cid=C0677M19GU9
                if (error.errorAttributes.statusCode === (0, $5MO1q.STATUS_CODES).FILE_RAI_POLICY_VIOLATION) return formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).fileRaiPolicyViolationError);
                return formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).unknownError);
            })();
            updateFileWithName(key, payload.file.name, {
                isLoading: false,
                error: errorMessage
            });
            if ((0, $b19d6aa036e9e860$export$4c9efc922a2449ec)(error)) {
                experienceTracker.succeed({
                    name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).UPLOAD_FILES_TO_CONVERSATION,
                error: error
            });
        }
    });
    const { mutate: mutateValidateFiles, isSubmitting: isSubmittingValidateFiles } = (0, $29BPs.useMutation)({
        mutationFn: (payload)=>{
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).VALIDATE_FILES,
                name: (0, $16lEl.ExperienceName).VALIDATE_FILES
            });
            return assistanceService.validateFiles({
                fileMetadata: payload.files.map((file)=>({
                        originalFilename: file.name,
                        contentType: file.type,
                        size: file.size
                    }))
            });
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).VALIDATE_FILES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).VALIDATE_FILES,
                error: error
            });
        }
    });
    const handleFilesSelected = (0, $42omo.useCallback)(async (uploadedFiles)=>{
        if (!uploadedFiles?.length) return;
        const newFiles = uploadedFiles.filter((file)=>!files.some((f)=>f.name === file.name));
        // Validate files before uploading them
        const validateResponse = await mutateValidateFiles({
            files: newFiles
        });
        const getErrorIcon = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).fileInvalidIconLabel),
                color: "var(--ds-icon-danger, #C9372C)"
            });
        if (!validateResponse) {
            showFlag({
                id: `conversation-files-fail-to-validate-files-${Date.now()}`,
                title: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).failToValidateFilesTitle),
                description: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).failToValidateFilesDescription),
                icon: getErrorIcon()
            });
            return;
        }
        const { validFiles: validFiles, invalidFiles: invalidFiles } = newFiles.reduce((acc, file)=>{
            const validationResult = validateResponse.validationResults.find((result)=>result.fileMetadata.originalFilename === file.name);
            if (!validationResult) {
                acc.invalidFiles.push({
                    fileName: file.name,
                    errorCode: 'VALIDATION_RESULT_NOT_FOUND'
                });
                return acc;
            }
            if (validationResult.isSupported) acc.validFiles.push(file);
            else acc.invalidFiles.push({
                fileName: validationResult.fileMetadata.originalFilename,
                errorCode: validationResult.errorCode ?? 'VALIDATION_RESULT_MISSING_ERROR_CODE'
            });
            return acc;
        }, {
            validFiles: [],
            invalidFiles: []
        });
        if (invalidFiles.length) showFlag({
            id: `conversation-files-validation-error-${Date.now()}`,
            title: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).invalidFilesTitle, {
                count: invalidFiles.length
            }),
            description: formatMessage((0, $34c8be18a88f108e$export$2e2bcd8739ae039).invalidFilesDescription, {
                count: invalidFiles.length,
                fileNames: invalidFiles.map((file)=>file.fileName).join(', '),
                reasons: Array.from(new Set(invalidFiles.map((file)=>formatMessage((0, $b19d6aa036e9e860$export$1156f3d82b1d9e10)(file.errorCode))))).join(', ')
            }),
            icon: getErrorIcon()
        });
        if (!validFiles.length) return;
        validFiles.forEach((file)=>{
            mutateUploadFiles({
                file: file
            });
        });
    }, [
        mutateUploadFiles,
        files,
        formatMessage,
        showFlag,
        mutateValidateFiles
    ]);
    const getFileInput = (0, $42omo.useCallback)((ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: "file-upload-input",
            as: "input",
            ref: ref,
            hidden: true,
            type: "file",
            multiple: true,
            onChange: (e)=>{
                handleFilesSelected(Array.from(e.target.files ?? []));
                // Temporary until we only have a single file input and no ref param
                if (ref.current) ref.current.value = '';
            }
        }), [
        handleFilesSelected
    ]);
    return {
        uploadFiles: {
            isSubmitting: isSubmittingUploadFiles || isSubmittingValidateFiles
        },
        anyFilesUploading: anyFilesUploading,
        handleFilesSelected: handleFilesSelected,
        files: files,
        removeFile: removeFile,
        clearFiles: clearFiles,
        clearAttachments: clearAttachments,
        getFileInput: getFileInput
    };
});
module.exports["useConversationFiles"] = $2dc4faee3a604e24$export$1e28ba9a04bf7961;

});

parcelRegister("auPMn", function(module, exports) {
/**
 * MIME types that should be treated as text files for preview generation.
 * Includes plain text, code files, markup, and structured data formats.
 */ const $2326faffe1b678ce$var$TEXT_MIME_TYPES = [
    'text/',
    'application/json',
    'application/xml',
    'application/x-yaml',
    'application/javascript',
    'application/typescript',
    'application/x-sh'
];
/**
 * File extensions that should be treated as text files.
 * Used as fallback when MIME type is not recognized by the browser.
 */ const $2326faffe1b678ce$var$TEXT_EXTENSIONS = [
    '.txt',
    '.md',
    '.markdown',
    '.json',
    '.xml',
    '.yaml',
    '.yml',
    '.js',
    '.jsx',
    '.ts',
    '.tsx',
    '.css',
    '.scss',
    '.less',
    '.html',
    '.htm',
    '.csv',
    '.log',
    '.sh',
    '.bash',
    '.py',
    '.rb',
    '.java',
    '.c',
    '.cpp',
    '.h',
    '.go',
    '.rs',
    '.sql'
];
function $2326faffe1b678ce$export$689bea3eece53c0e(mimeType, fileName) {
    // First check MIME type
    if (mimeType && $2326faffe1b678ce$var$TEXT_MIME_TYPES.some((type)=>mimeType.startsWith(type))) return true;
    // Fallback to extension check if MIME type is empty or unrecognized
    if (fileName) {
        const lowerFileName = fileName.toLowerCase();
        return $2326faffe1b678ce$var$TEXT_EXTENSIONS.some((ext)=>lowerFileName.endsWith(ext));
    }
    return false;
}
module.exports["isTextFile"] = $2326faffe1b678ce$export$689bea3eece53c0e;

});

parcelRegister("cgmTK", function(module, exports) {

var $auPMn = parcelRequire("auPMn");

/**
 * Generates a thumbnail blob URL from a text-based file by rendering the first few lines to canvas.
 * Supports plain text, markdown, JSON, YAML, XML, code files, etc.
 *
 * @param file - Text file to generate thumbnail from
 * @returns Promise resolving to blob URL
 * @throws Error if thumbnail generation fails or if called in SSR context
 */ async function $7736c958fbea66e5$export$fa096b217fa924a6(file) {
    if (typeof window === 'undefined' || typeof document === 'undefined') throw new Error('Text thumbnail generation requires browser environment');
    // Read first 1000 characters of the file
    const text = await file.slice(0, 1000).text();
    const lines = text.split('\n').slice(0, 12); // First 12 lines for preview
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Canvas 2D context unavailable');
    const width = 200;
    const height = 200;
    canvas.width = width;
    canvas.height = height;
    context.fillStyle = '#FFFFFF';
    context.fillRect(0, 0, width, height);
    const fontSize = 10;
    const lineHeight = 14;
    const padding = 8;
    context.fillStyle = '#172B4D';
    context.font = `${fontSize}px SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`;
    context.textBaseline = 'top';
    lines.forEach((line, index)=>{
        const y = padding + index * lineHeight;
        if (y + lineHeight > height - padding) return;
        // Truncate line if too long
        const maxWidth = width - padding * 2;
        let displayText = line;
        if (context.measureText(line).width > maxWidth) {
            // Truncate and add ellipsis
            while(context.measureText(displayText + '...').width > maxWidth && displayText.length > 0)displayText = displayText.slice(0, -1);
            displayText += '...';
        }
        context.fillText(displayText, padding, y);
    });
    // Add subtle border
    context.strokeStyle = '#DFE1E6';
    context.lineWidth = 1;
    context.strokeRect(0, 0, width, height);
    return new Promise((resolve, reject)=>{
        canvas.toBlob((blob)=>{
            if (blob) resolve(URL.createObjectURL(blob));
            else reject(new Error('Failed to generate blob from canvas'));
        }, 'image/png');
    });
}


async function $623c39f9ecbb03e8$export$905085f77a7184a2(fileObject) {
    if (fileObject.type.startsWith('image/')) try {
        return URL.createObjectURL(fileObject);
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : 'Failed to create blob URL for image file';
        throw new Error(`Failed to create blob URL for image: ${errorMessage}`);
    }
    else if ((0, $auPMn.isTextFile)(fileObject.type, fileObject.name)) return await (0, $7736c958fbea66e5$export$fa096b217fa924a6)(fileObject);
    throw new Error(`Unsupported file type: ${fileObject.type}`);
}
module.exports["generateFilePreview"] = $623c39f9ecbb03e8$export$905085f77a7184a2;

});

parcelRegister("3X525", function(module, exports) {
const $d93391a18568f80b$export$4b24e3a88bb9f9d0 = 10;
const $d93391a18568f80b$export$62220f2257a1b032 = 20971520; // 20MB
const $d93391a18568f80b$export$b39af14b910b9848 = 104857600; // 100MB
module.exports["MAX_FILES"] = $d93391a18568f80b$export$4b24e3a88bb9f9d0;

});

parcelRegister("fbZF8", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $4wH3g = parcelRequire("4wH3g");


var $fBMbo = parcelRequire("fBMbo");


var $1qfLF = parcelRequire("1qfLF");


var $g5gZt = parcelRequire("g5gZt");


var $hmuev = parcelRequire("hmuev");


var $1bY7o = parcelRequire("1bY7o");


var $b4wUN = parcelRequire("b4wUN");


var $8jHAi = parcelRequire("8jHAi");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");


var $3gadb = parcelRequire("3gadb");




const $482d2b6a189b000d$export$b9bd19bdeffb47f1 = ({ contextProviders: contextProviders = [], onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable } = {})=>{
    const [currentBrowser, setCurrentBrowser] = (0, $42omo.useState)(null);
    const [currentContexts, setCurrentContexts] = (0, $42omo.useState)([]);
    const handleShowContextBrowser = (0, $42omo.useCallback)((browser)=>{
        setCurrentBrowser(browser);
        onContextBrowserShow?.(browser);
    }, [
        onContextBrowserShow
    ]);
    const handlePromptInputContextAvailable = (0, $42omo.useCallback)((contexts)=>{
        const contextMap = new Map();
        // add existing contexts first
        currentContexts.forEach((context)=>{
            contextMap.set(context.key, context);
        });
        // add/override with new contexts
        contexts.forEach((context)=>{
            contextMap.set(context.key, context);
        });
        const updatedContexts = Array.from(contextMap.values());
        setCurrentContexts(updatedContexts);
        onContextAvailable?.(updatedContexts);
    }, [
        currentContexts,
        onContextAvailable
    ]);
    const getMenuItems = (0, $42omo.useCallback)(()=>{
        return contextProviders.map((provider)=>provider.getMenuItem(handleShowContextBrowser, handlePromptInputContextAvailable)).filter((item)=>item !== null);
    }, [
        contextProviders,
        handleShowContextBrowser,
        handlePromptInputContextAvailable
    ]);
    const clearContexts = (0, $42omo.useCallback)(()=>{
        setCurrentContexts([]);
        onContextAvailable?.([]);
    }, [
        onContextAvailable
    ]);
    const removeContext = (0, $42omo.useCallback)((contextKey)=>{
        const updatedContexts = currentContexts.filter((context)=>context.key !== contextKey);
        setCurrentContexts(updatedContexts);
        onContextAvailable?.(updatedContexts);
    }, [
        currentContexts,
        onContextAvailable
    ]);
    return {
        currentBrowser: currentBrowser,
        currentContexts: currentContexts,
        getMenuItems: getMenuItems,
        clearContexts: clearContexts,
        removeContext: removeContext,
        setCurrentBrowser: setCurrentBrowser
    };
};



var $kIvLT = parcelRequire("kIvLT");


var $5VZ9F = parcelRequire("5VZ9F");


var $i1Nyn = parcelRequire("i1Nyn");


var $7qwOJ = parcelRequire("7qwOJ");


var $6Y7nw = parcelRequire("6Y7nw");

function $d971d809a8e21bf8$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}



var $ipUai = parcelRequire("ipUai");


var $PRMv4 = parcelRequire("PRMv4");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $hw7wB = parcelRequire("hw7wB");











var $3X525 = parcelRequire("3X525");


var $5Bdam = parcelRequire("5Bdam");


var $cgtv4 = parcelRequire("cgtv4");

var $5c181fafcb8735e6$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    fileUploadButtonLabel: {
        id: "rovo-chat.file-upload-button.label",
        defaultMessage: "Upload file"
    },
    fileUploadButtonMaxFilesLabel: {
        id: "rovo-chat.file-upload-button.max-files-label",
        defaultMessage: "Limit of {maxFiles, plural, one {# file} other {# files}} reached"
    }
});


const $f9254ba572c994ce$export$8fc396871921c53a = ({ onClick: onClick, assistanceServiceParams: assistanceServiceParams, attachmentsStoreKey: attachmentsStoreKey })=>{
    (0, $fBMbo.di)((0, $6Y7nw.useConversationFiles));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { files: files } = (0, $6Y7nw.useConversationFiles)({
        assistanceServiceParams: {
            ...assistanceServiceParams,
            touchpointSource: 'fileUploadButton'
        },
        key: attachmentsStoreKey
    });
    const isMaxFilesReached = files.length >= (0, $3X525.MAX_FILES);
    const handleClick = ()=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'chatFileUploadButton'
        });
        onClick();
    };
    const menuItem = /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
            label: ""
        }),
        label: formatMessage((0, $5c181fafcb8735e6$export$2e2bcd8739ae039).fileUploadButtonLabel),
        isDisabled: isMaxFilesReached,
        onClick: handleClick,
        testId: "file-upload-dropdown-item"
    }); // Wrap with tooltip when disabled to show the max files message
    if (isMaxFilesReached) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $5c181fafcb8735e6$export$2e2bcd8739ae039).fileUploadButtonMaxFilesLabel, {
            maxFiles: (0, $3X525.MAX_FILES)
        }),
        children: menuItem
    });
    return menuItem;
};








const $2f9581b1028ef545$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    chatInputActionsButtonsTooltip: {
        id: "ai-mate.chat-input.open-chat-input-buttons-tooltip",
        defaultMessage: "Add"
    },
    mentionTypeAheadButtonLabel: {
        id: "ai-mate.chat-input.mention-type-ahead-button.label",
        defaultMessage: "Mention someone"
    },
    linkTypeAheadButtonLabel: {
        id: "ai-mate.chat-input.link-type-ahead-button.label",
        defaultMessage: "Add a link"
    },
    addContentButtonLabel: {
        id: "ai-mate.chat-input.add-content-button.label",
        defaultMessage: "Use what you're viewing as context"
    },
    addMoreFormattingButtonLabel: {
        id: "ai-mate.chat-input.add-more-formatting-button.label",
        defaultMessage: "More formatting"
    },
    addCurrentPageAsContextDisabledTooltip: {
        id: "ai-mate.chat-input.add-current-page-as-context-disabled-tooltip",
        defaultMessage: "This page isn't supported yet"
    }
});



const $cd4abe94a6566bf9$var$AgentSection = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "yHuuD",
    name: "AgentSection",
    loader: async ()=>(await (parcelRequire("7JdXM"))).AgentSection,
    loading: ()=>null
});

const $cd4abe94a6566bf9$var$RecommendedAgentsPreloader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Zlqrd",
    name: "RecommendedAgentsPreloader",
    loader: async ()=>(await (parcelRequire("j5lLr"))).RecommendedAgentsPreloader,
    loading: ()=>null
});
const $cd4abe94a6566bf9$var$styles = {
    menuContainer: "_zulp1b66 _2rko1qi0 _1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _2lx21bp4 _4cvr1fhb _bfhkvuon _1ul9p3fh _p12f1mjv _16qs130s",
    menuContainerAdjusted: "_zulp1b66 _1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _2lx21bp4 _4cvr1fhb _bfhkvuon _1ul9p3fh _p12f1mjv",
    menuSection: "_zulpv77o _1e0c1txw _2lx21bp4",
    sectionHeader: "_11c81vhk _18zru2gc _1rjc12x7 _syaz1rpy",
    divider: "_1mou12x7 _4t3it94y _bfhksm61",
    menuPopupContainer: "_2rko1mok _19itia51 _1reo15vq _18m915vq _16qs130s _1pbyni7l"
};
const $cd4abe94a6566bf9$var$PopupComponent = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ...props,
        ref: ref,
        xcss: $cd4abe94a6566bf9$var$styles.menuPopupContainer,
        "data-testid": undefined
    }));
const $cd4abe94a6566bf9$export$8a4234462d786b48 = ({ entryPoint: entryPoint, siteId: siteId, useCurrentPageContext: useCurrentPageContext, onLinkTypeAheadClick: onLinkTypeAheadClick, onMentionTypeAheadClick: onMentionTypeAheadClick, onAddTypeAheadClick: onAddTypeAheadClick, assistanceServiceParams: assistanceServiceParams, contextProviders: contextProviders, onContextBrowserShow: onContextBrowserShow, onContextAvailable: onContextAvailable, isDisabled: isDisabled, placement: placement = 'top-start', attachmentsAndCurrentPageAsContextStoreKey: attachmentsStoreAndCurrentPageContextKey, onMenuOpen: onMenuOpen, onAgentSelect: onAgentSelect, isBrowseAgentsModalOpen: isBrowseAgentsModalOpen = false, setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen = ()=>{}, shouldRenderInPortal: shouldRenderInPortal = false, enableBrowserContextBanner: enableBrowserContextBanner = false, browserContextSanitizer: browserContextSanitizer })=>{
    (0, $fBMbo.di)((0, $PRMv4.useCurrentPageAsContext), (0, $6Y7nw.useConversationFiles), (0, $i1Nyn.useChatContextBrowserContext));
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { setUseCurrentPageContextUserPreference: setUseCurrentPageContextUserPreference, currentContext: currentContext } = (0, $PRMv4.useCurrentPageAsContext)();
    const [browserContext] = (0, $i1Nyn.useChatContextBrowserContext)();
    const showAddContextButton = useCurrentPageContext; // Only consider browser context available if enableBrowserContextBanner config is enabled (otherwise behave as non-extension)
    const hasBrowserContext = !!browserContext?.context?.browserUrl && enableBrowserContextBanner; // Check if browser context URL is blocklisted (only when enableBrowserContextBanner is true and sanitizer is provided)
    const isBrowserContextBlocklisted = enableBrowserContextBanner && browserContextSanitizer && hasBrowserContext && browserContext?.context?.browserUrl ? browserContextSanitizer.isBlocklisted(browserContext.context.browserUrl) : false; // Button should be disabled only if:
    // 1. Current context type is 'none' (page not supported)
    // 2. AND no browser context is available (can't use external site context)
    // If browser context is available, enable the button even if currentContext.type === 'none' (unless blocklisted)
    const isContextDisabled = isBrowserContextBlocklisted || currentContext.type === 'none' && !hasBrowserContext;
    const [menuState, setMenuState] = (0, $42omo.useState)('main');
    const [currentContextBrowser, setCurrentContextBrowser] = (0, $42omo.useState)(null);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const { addExternalContext: addExternalContext } = (0, $7qwOJ.useConversationExternalAttachments)(attachmentsStoreAndCurrentPageContextKey);
    const returnFocusRef = (0, $42omo.useRef)(null);
    const inputRef = (0, $42omo.useRef)(null);
    const { getFileInput: getFileInput } = (0, $6Y7nw.useConversationFiles)({
        assistanceServiceParams: {
            ...assistanceServiceParams,
            touchpointSource: 'chatInputActionButtons'
        },
        key: attachmentsStoreAndCurrentPageContextKey
    });
    const { getMenuItems: getMenuItems } = (0, $482d2b6a189b000d$export$b9bd19bdeffb47f1)({
        contextProviders: contextProviders,
        onContextBrowserShow: (browser)=>{
            if (browser) {
                setCurrentContextBrowser(browser);
                setMenuState('external-context');
            } else {
                setCurrentContextBrowser(null);
                setMenuState('main');
            }
            onContextBrowserShow?.(browser);
        },
        onContextAvailable: (contexts)=>{
            setMenuState('main');
            setCurrentContextBrowser(null);
            setIsDropdownOpen(false); // Add external contexts to unified store
            addExternalContext(attachmentsStoreAndCurrentPageContextKey, contexts);
            onContextAvailable?.(contexts);
        }
    });
    const focusOnClose = (event)=>{
        // Refocus on the trigger when closing the popup except for native mouse events
        if (!event || event.detail === 0) requestAnimationFrame(()=>{
            returnFocusRef?.current?.focus();
        });
    };
    const externalMenuItems = getMenuItems();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
                isOpen: isDropdownOpen,
                onClose: ()=>{
                    setIsDropdownOpen(false);
                    setMenuState('main');
                    setCurrentContextBrowser(null);
                    focusOnClose();
                },
                placement: placement,
                shouldRenderToParent: !shouldRenderInPortal,
                shouldFlip: !shouldRenderInPortal,
                popupComponent: (0, $dh538.fg)('rovo_chat_refresh_design_adjustments') ? $cd4abe94a6566bf9$var$PopupComponent : undefined,
                ...(0, $dh538.fg)('global_rovo_button_in_jira') && {
                    zIndex: 600
                },
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5VZ9F.GettingStartedTourSpotlight), {
                        step: 1,
                        entryPoint: entryPoint,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                            ...triggerProps,
                            onClick: (e, analyticsEvent)=>{
                                sendAnalyticsEvent(analyticsEvent.update({
                                    actionSubjectId: 'rovoChatAddMenuTrigger'
                                }));
                                setIsDropdownOpen(!isDropdownOpen);
                                if (!isDropdownOpen) onMenuOpen?.();
                            },
                            isTooltipDisabled: false,
                            isSelected: (0, $dh538.fg)('rovo_chat_refresh_design_adjustments') ? isDropdownOpen : undefined,
                            appearance: "subtle",
                            shape: "circle",
                            icon: isDropdownOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))) : (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
                            label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).chatInputActionsButtonsTooltip),
                            ref: (0, $d971d809a8e21bf8$export$2e2bcd8739ae039)([
                                triggerProps.ref,
                                returnFocusRef
                            ]),
                            isDisabled: isDisabled
                        })
                    }),
                content: ()=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                        xcss: (0, $dh538.fg)('rovo_chat_refresh_design_adjustments') ? $cd4abe94a6566bf9$var$styles.menuContainerAdjusted : $cd4abe94a6566bf9$var$styles.menuContainer,
                        children: [
                            menuState === 'main' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                                        xcss: $cd4abe94a6566bf9$var$styles.menuSection,
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $f9254ba572c994ce$export$8fc396871921c53a), {
                                                attachmentsStoreKey: attachmentsStoreAndCurrentPageContextKey,
                                                onClick: ()=>{
                                                    inputRef.current?.click();
                                                    setIsDropdownOpen(false);
                                                },
                                                assistanceServiceParams: assistanceServiceParams
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).linkTypeAheadButtonLabel),
                                                onClick: ()=>{
                                                    onLinkTypeAheadClick();
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'rovoChatAddLinkButton'
                                                    });
                                                    setIsDropdownOpen(false);
                                                }
                                            }),
                                            externalMenuItems.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                    icon: item.icon,
                                                    label: item.label,
                                                    onClick: ()=>{
                                                        item.action();
                                                        sendAnalyticsEvent({
                                                            action: 'clicked',
                                                            actionSubject: 'button',
                                                            actionSubjectId: `rovoChatExternalContext_${item.key}`
                                                        });
                                                    }
                                                }, item.key)),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b4wUN))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).mentionTypeAheadButtonLabel),
                                                onClick: ()=>{
                                                    onMentionTypeAheadClick();
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'rovoChatMentionButton'
                                                    });
                                                    setIsDropdownOpen(false);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                                                    label: ""
                                                }),
                                                label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).addMoreFormattingButtonLabel),
                                                onClick: ()=>{
                                                    onAddTypeAheadClick();
                                                    sendAnalyticsEvent({
                                                        action: 'clicked',
                                                        actionSubject: 'button',
                                                        actionSubjectId: 'rovoChatAddFormattingButton'
                                                    });
                                                    setIsDropdownOpen(false);
                                                }
                                            }),
                                            showAddContextButton && /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                                position: "top",
                                                content: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).addCurrentPageAsContextDisabledTooltip),
                                                canAppear: ()=>isContextDisabled,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5Bdam.MenuItem), {
                                                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
                                                        label: ""
                                                    }),
                                                    label: formatMessage((0, $2f9581b1028ef545$export$defe85febe8b728c).addContentButtonLabel),
                                                    isDisabled: isContextDisabled,
                                                    onClick: ()=>{
                                                        setUseCurrentPageContextUserPreference(attachmentsStoreAndCurrentPageContextKey, true);
                                                        sendAnalyticsEvent({
                                                            action: 'clicked',
                                                            actionSubject: 'button',
                                                            actionSubjectId: 'rovoChatAddContextButton'
                                                        });
                                                        setIsDropdownOpen(false);
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    onAgentSelect && /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $cd4abe94a6566bf9$var$styles.divider
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $cd4abe94a6566bf9$var$styles.sectionHeader,
                                                children: formatMessage((0, $ipUai.messages).agentsHeader)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                                xcss: $cd4abe94a6566bf9$var$styles.menuSection,
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$AgentSection, {
                                                        assistanceServiceParams: assistanceServiceParams,
                                                        onAgentSelect: onAgentSelect,
                                                        siteId: siteId,
                                                        isBrowseAgentsModalOpen: isBrowseAgentsModalOpen,
                                                        setIsBrowseAgentsModalOpen: setIsBrowseAgentsModalOpen,
                                                        setIsDropdownOpen: setIsDropdownOpen
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            menuState === 'external-context' && currentContextBrowser && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $cd4abe94a6566bf9$var$styles.menuSection,
                                children: currentContextBrowser
                            })
                        ]
                    }),
                shouldUseCaptureOnOutsideClick: true
            }),
            getFileInput(inputRef),
            onAgentSelect && /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$AgentSectionPreloader, {
                assistanceServiceParams: assistanceServiceParams
            })
        ]
    });
};
const $cd4abe94a6566bf9$var$AgentSectionPreloader = ({ assistanceServiceParams: assistanceServiceParams })=>{
    // Preload the bundle
    (0, $42omo.useEffect)(()=>{
        $cd4abe94a6566bf9$var$AgentSection.preload();
    }, []); // Preload the data
    return /*#__PURE__*/ (0, $l998X.jsx)($cd4abe94a6566bf9$var$RecommendedAgentsPreloader, {
        assistanceServiceParams: assistanceServiceParams
    });
};
module.exports["ChatInputActionButtons"] = $cd4abe94a6566bf9$export$8a4234462d786b48;

});

parcelRegister("5VZ9F", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $19Jj3 = parcelRequire("19Jj3");

var $aG6kF = parcelRequire("aG6kF");


var $kIvLT = parcelRequire("kIvLT");


var $7tmqn = parcelRequire("7tmqn");


var $cgtv4 = parcelRequire("cgtv4");

const $5c80665022c6e61d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    back: {
        id: "ai-mate.getting-started-tour.back",
        defaultMessage: "Back"
    },
    done: {
        id: "ai-mate.getting-started-tour.done",
        defaultMessage: "Done"
    },
    next: {
        id: "ai-mate.getting-started-tour.next",
        defaultMessage: "Next"
    },
    stepIndicator: {
        id: "ai-mate.getting-started-tour.indicator",
        defaultMessage: "{stepNumber} of {totalSteps}"
    },
    stepOneTitle: {
        id: "ai-mate.getting-started-tour.step-one.title",
        defaultMessage: "Add work from anywhere"
    },
    stepOneDescription: {
        id: "ai-mate.getting-started-tour.step-one.description",
        defaultMessage: "Choose a template, upload a file, link a page, and more to power your creation."
    },
    stepTwoTitle: {
        id: "ai-mate.getting-started-tour.step-two.title",
        defaultMessage: "Get unstuck on your prompt"
    },
    stepTwoDescription: {
        id: "ai-mate.getting-started-tour.step-two.description",
        defaultMessage: "Try an example or use them to jump-start your draft."
    },
    stepThreeTitle: {
        id: "ai-mate.getting-started-tour.step-three.title",
        defaultMessage: "Talk to Rovo instead of typing"
    },
    stepThreeDescription: {
        id: "ai-mate.getting-started-tour.step-three.description",
        defaultMessage: "Use your voice to get started."
    }
});


const $5c04011d7aad6cfe$var$stepConfig = [
    {
        title: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepOneTitle,
        description: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepOneDescription,
        placement: 'bottom-start'
    },
    {
        title: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepTwoTitle,
        description: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepTwoDescription,
        placement: 'left-start'
    },
    {
        title: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepThreeTitle,
        description: (0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepThreeDescription,
        placement: 'bottom-end'
    }
];
const $5c04011d7aad6cfe$var$ALLOWED_ENTRY_POINT = '-smartCreate';
const $5c04011d7aad6cfe$export$187fca2312a637a5 = ({ entryPoint: entryPoint, children: children, step: step })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { stepNumber: currentStepNumber, totalSteps: totalSteps } = (0, $7tmqn.useGettingStartedTourState)();
    const { setStepNumber: hideGettingStartedSpotlightTour, nextStep: moveToNextStep, previousStep: moveToPreviousStep, dismiss: completeGettingStartedTour } = (0, $7tmqn.useGettingStartedTourStoreActions)();
    const handleOnNextClicked = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightPrimaryButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        if (step === totalSteps) completeGettingStartedTour();
        else moveToNextStep();
    }, [
        step,
        totalSteps,
        completeGettingStartedTour,
        moveToNextStep,
        sendAnalyticsEvent
    ]);
    const handleOnPreviousClicked = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightSecondaryButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        moveToPreviousStep();
    }, [
        step,
        moveToPreviousStep,
        sendAnalyticsEvent
    ]);
    const handleOnDismissClicked = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            actionSubject: 'button',
            action: 'clicked',
            actionSubjectId: 'gettingStartedTourSpotlightDismissButton',
            attributes: {
                tourStep: step
            },
            source: 'smart-create'
        });
        hideGettingStartedSpotlightTour(0);
    }, [
        step,
        hideGettingStartedSpotlightTour,
        sendAnalyticsEvent
    ]);
    if (!(0, $dh538.fg)('platform_aifc_getting_started_spotlight') || !entryPoint?.includes($5c04011d7aad6cfe$var$ALLOWED_ENTRY_POINT)) return children;
    const currentConfig = $5c04011d7aad6cfe$var$stepConfig[step - 1];
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $k7Tf7.PopoverProvider), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a90ar.PopoverTarget), {
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $bqAtB.PopoverContent), {
                dismiss: handleOnDismissClicked,
                isVisible: currentStepNumber === step,
                placement: currentConfig?.placement,
                strategy: "absolute",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                    entranceDirection: "left",
                    children: (props)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                            ...props,
                            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $71521.SpotlightCard), {
                                testId: "spotlight",
                                children: [
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $aZQ5F.SpotlightHeader), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $bUJpY.SpotlightHeadline), {
                                                children: formatMessage(currentConfig?.title)
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $aVS0S.SpotlightControls), {
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2owmo.SpotlightDismissControl), {
                                                    onClick: handleOnDismissClicked
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $f1UQW.SpotlightBody), {
                                        children: formatMessage(currentConfig?.description)
                                    }),
                                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $eopLP.SpotlightFooter), {
                                        children: [
                                            /*#__PURE__*/ (0, $l998X.jsx)((0, $aG6kF.SpotlightStepCount), {
                                                children: formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).stepIndicator, {
                                                    stepNumber: step,
                                                    totalSteps: totalSteps
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $l998X.jsxs)((0, $3chlW.SpotlightActions), {
                                                children: [
                                                    currentStepNumber > 1 && /*#__PURE__*/ (0, $l998X.jsx)((0, $19Jj3.SpotlightSecondaryAction), {
                                                        onClick: handleOnPreviousClicked,
                                                        children: formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).back)
                                                    }),
                                                    /*#__PURE__*/ (0, $l998X.jsx)((0, $fNcP1.SpotlightPrimaryAction), {
                                                        onClick: handleOnNextClicked,
                                                        children: currentStepNumber < totalSteps ? formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).next) : formatMessage((0, $5c80665022c6e61d$export$a7357cdd1f0b0168).done)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
};
module.exports["GettingStartedTourSpotlight"] = $5c04011d7aad6cfe$export$187fca2312a637a5;

});

parcelRegister("7tmqn", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $fb2157568c57e2df$var$initialState = {
    stepNumber: 0,
    totalSteps: 3,
    hasDismissed: false,
    hasStarted: false
};
const $fb2157568c57e2df$var$setStepNumber = (step)=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: step
        });
    };
};
const $fb2157568c57e2df$var$nextStep = ()=>{
    return ({ setState: setState, getState: getState })=>{
        const { stepNumber: stepNumber } = getState();
        const nextStepValue = stepNumber + 1;
        setState({
            stepNumber: nextStepValue > $fb2157568c57e2df$var$initialState.totalSteps ? 0 : nextStepValue
        });
    };
};
const $fb2157568c57e2df$var$previousStep = ()=>{
    return ({ setState: setState, getState: getState })=>{
        const { stepNumber: stepNumber } = getState();
        const nextStepValue = stepNumber - 1;
        setState({
            stepNumber: nextStepValue < 1 ? 1 : nextStepValue
        });
    };
};
const $fb2157568c57e2df$var$resetStep = ()=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: 1,
            hasStarted: true
        });
    };
};
const $fb2157568c57e2df$var$dismiss = ()=>{
    return ({ setState: setState })=>{
        setState({
            stepNumber: 0,
            hasDismissed: true
        });
    };
};
const $fb2157568c57e2df$var$store = (0, $1P1Tu.createStore)({
    initialState: $fb2157568c57e2df$var$initialState,
    actions: {
        setStepNumber: (step)=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$setStepNumber(step));
            },
        nextStep: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$nextStep());
            },
        previousStep: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$previousStep());
            },
        resetStep: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$resetStep());
            },
        dismiss: ()=>({ dispatch: dispatch })=>{
                dispatch($fb2157568c57e2df$var$dismiss());
            }
    }
});
const $fb2157568c57e2df$export$892b983d1b41ebe1 = (0, $9zUhf.createHook)($fb2157568c57e2df$var$store);
const $fb2157568c57e2df$export$7170019ae9cc343d = (0, $9zUhf.createActionsHook)($fb2157568c57e2df$var$store);
const $fb2157568c57e2df$export$7d095908422babd2 = ()=>{
    const [state] = $fb2157568c57e2df$export$892b983d1b41ebe1();
    return state;
};
module.exports["useGettingStartedTourStoreActions"] = $fb2157568c57e2df$export$7170019ae9cc343d;
module.exports["useGettingStartedTourState"] = $fb2157568c57e2df$export$7d095908422babd2;

});

parcelRegister("7qwOJ", function(module, exports) {

var $bJOL1 = parcelRequire("bJOL1");

const $7d0343b3409f6bfe$export$ee6324403e0cde6 = (key)=>{
    const [externalContexts, { addExternalContext: addExternalContext }] = (0, $bJOL1.useExternalContextsStore)(key);
    const externalContextsServiceRepresentations = externalContexts.map((context)=>context.serviceRepresentation);
    return {
        addExternalContext: addExternalContext,
        externalContextsServiceRepresentations: externalContextsServiceRepresentations
    };
};
module.exports["useConversationExternalAttachments"] = $7d0343b3409f6bfe$export$ee6324403e0cde6;

});

parcelRegister("ipUai", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $4eca00df6358d525$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    agentsHeader: {
        id: "ai-mate.chat-input.agents.header",
        defaultMessage: "Start chatting with agents"
    },
    browseAgents: {
        id: "ai-mate.chat-input.agents.browse-agents",
        defaultMessage: "Browse agents"
    },
    createAgent: {
        id: "ai-mate.chat-input.agents.create-agent",
        defaultMessage: "Create agent"
    }
});
module.exports["messages"] = $4eca00df6358d525$export$defe85febe8b728c;

});

parcelRegister("PRMv4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $dh538 = parcelRequire("dh538");


var $i1Nyn = parcelRequire("i1Nyn");


var $V9Rzh = parcelRequire("V9Rzh");

var $329c74d7ff3c6273$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_BOARD"] = "jira-board-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_SERVICE_DESK"] = "jira-service-desk";
    PageContextType["JIRA_PLAN"] = "jira-plan";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE"] = "jira-cmp-space-settings-people";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_VIEW"] = "jira-admin-permission-schemes-view";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_ADD"] = "jira-admin-permission-schemes-add";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_EDIT"] = "jira-admin-permission-schemes-edit";
    PageContextType["JIRA_ADMIN_PERMISSION_SCHEMES_DELETE"] = "jira-admin-permission-schemes-delete";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_PROJECT"] = "atlas-project";
    PageContextType["ATLAS_GOAL"] = "atlas-goal";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $329c74d7ff3c6273$export$46133998910543ac = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $329c74d7ff3c6273$export$6fa751d66e55d2e1 = ()=>{
    const [location, setLocation] = (0, $42omo.useState)(window.location.href);
    // For easier mocking
    const contextValue = (0, $42omo.useContext)($329c74d7ff3c6273$export$46133998910543ac);
    const handleLocationChange = (0, $42omo.useCallback)(()=>{
        if (window.location.href !== location) setLocation(window.location.href);
    }, [
        location,
        setLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};
var $329c74d7ff3c6273$export$59961d6586ccfd15 = /*#__PURE__*/ function(UseCase) {
    UseCase["THINKING_VIEW"] = "thinking-view";
    UseCase["AUTOCOMPLETE"] = "autocomplete";
    return UseCase;
}({});
const $329c74d7ff3c6273$var$ALLOWED_PAGE_CONTEXT_TYPES = {
    ["thinking-view"]: [
        "confluence-page-edit",
        "confluence-page-view",
        "confluence-whiteboard",
        "jira-issue-view",
        "jira-service-desk",
        "jira-project",
        "jira-plan",
        "jira-cmp-space-settings-people",
        "jira-admin-permission-schemes-view",
        "jira-admin-permission-schemes-add",
        "jira-admin-permission-schemes-edit",
        "jira-admin-permission-schemes-delete",
        "atlas-project",
        "atlas-goal",
        "admin-hub"
    ],
    ["autocomplete"]: [
        "bitbucket",
        "confluence-home",
        "confluence-page-edit",
        "confluence-page-view",
        "confluence-whiteboard",
        "jira-backlog",
        "jira-home",
        "jira-issue-view",
        "atlas-home",
        "admin-hub"
    ]
};
const $329c74d7ff3c6273$var$FALLBACK_PAGE_CONTEXT_TYPE = {
    ["thinking-view"]: "unknown",
    ["autocomplete"]: "atlas-home"
};
const $329c74d7ff3c6273$export$a905239756c1fbae = (location, useCase = "thinking-view")=>{
    const allowedTypes = new Set($329c74d7ff3c6273$var$ALLOWED_PAGE_CONTEXT_TYPES[useCase]);
    const allUrlPatterns = [
        [
            "bitbucket",
            /bitbucket\.org\/.*/
        ],
        //If flag is on, use confluence page view for confluence home url pattern since model doesn't have enough data for home
        ...useCase === "autocomplete" && (0, $dh538.fg)('rovo_chat_typeahead_use_confluence-page_fallback') ? [
            [
                "confluence-page-view",
                /\/wiki\/home$/
            ]
        ] : [
            [
                "confluence-home",
                /\/wiki\/home$/
            ]
        ],
        [
            "confluence-page-edit",
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\/edit-v2\//
        ],
        [
            "confluence-page-view",
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\//
        ],
        // Support whiteboard url
        [
            "confluence-whiteboard",
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        // Support whiteboard iframe url
        [
            "confluence-whiteboard",
            /\/whiteboards\/whiteboard\/[^\/\?]+/
        ],
        // Support whiteboard internal url after spa transition
        [
            "confluence-whiteboard",
            /\/whiteboard\/[a-f0-9-]+/
        ],
        [
            "jira-backlog",
            /\/jira\/.*\/backlog$/
        ],
        [
            "jira-board-view",
            /\/jira\/.*\/boards\//
        ],
        [
            "jira-issue-view",
            /\/browse\/[^\/]+$/
        ],
        [
            "jira-issue-view",
            /\/jira\/.+\/projects\/.+\?selectedIssue/
        ],
        [
            "jira-home",
            /\/jira\/dashboards\/last-visited$/
        ],
        [
            "jira-service-desk",
            /\/jira(?:\/.+)?\/servicedesk\/projects\/.+\/queues\/issue\//
        ],
        [
            "jira-project",
            /\/jira\/.+\/projects\//
        ],
        ...(0, $dh538.fg)('rovo_chat_jira_plans_minion') ? [
            [
                "jira-plan",
                /\/jira\/plans\/\d+\//
            ]
        ] : [],
        [
            "jira-home",
            /\/jira\/dashboards\/last-visited$/
        ],
        ...(0, $dh538.fg)('permissions_ai_rovo_nudge_and_context') ? [
            [
                "jira-cmp-space-settings-people",
                /\/plugins\/servlet\/project-config\/[^\/]+\/(people|permissions)/
            ],
            [
                "jira-admin-permission-schemes-view",
                /\/secure\/admin\/ViewPermissionSchemes([!%]?\w*)\.jspa/
            ],
            [
                "jira-admin-permission-schemes-add",
                /\/secure\/admin\/AddPermissionScheme!default\.jspa/
            ],
            [
                "jira-admin-permission-schemes-edit",
                /\/(?:jira\/settings\/issues\/permission-schemes|secure\/admin\/EditPermissions!default\.jspa)/
            ],
            [
                "jira-admin-permission-schemes-delete",
                /\/secure\/admin\/DeletePermissionScheme!default\.jspa/
            ]
        ] : [],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            "atlas-home",
            /\/(home|team)\./
        ],
        [
            "atlas-project",
            /\/(home|team).+\/project\/ATLAS-/
        ],
        [
            "atlas-goal",
            /\/(home|team).+\/goal\/ATLAS-/
        ],
        // admin hub: admin.atlassian.com (production) or admin.stg.atlassian.com (staging)
        [
            "admin-hub",
            /admin(\.stg)?\.atlassian\.com/
        ]
    ];
    const urlPatterns = allUrlPatterns.filter(([type])=>allowedTypes.has(type));
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        return type;
    }
    return $329c74d7ff3c6273$var$FALLBACK_PAGE_CONTEXT_TYPE[useCase];
};
const $329c74d7ff3c6273$export$bc4bf2ff8e40b690 = (useCase = "thinking-view")=>{
    const location = $329c74d7ff3c6273$export$6fa751d66e55d2e1();
    const [pageContextType, setPageContextType] = (0, $42omo.useState)($329c74d7ff3c6273$export$a905239756c1fbae(location, useCase));
    (0, $42omo.useEffect)(()=>{
        setPageContextType($329c74d7ff3c6273$export$a905239756c1fbae(location, useCase));
    }, [
        location,
        useCase
    ]);
    return pageContextType;
};
const $329c74d7ff3c6273$export$a96e0fbf256603d8 = ()=>{
    const pageContextType = $329c74d7ff3c6273$export$bc4bf2ff8e40b690();
    const { getChatMode: getChatMode, setUseCurrentPageContext: setUseCurrentPageContext } = (0, $V9Rzh.useChatModeStoreActions)();
    const [editorContext] = (0, $i1Nyn.useChatContextEditorContext)();
    let currentContext = {
        type: 'none'
    };
    if (editorContext) // prefer editor context over page context if available
    currentContext = {
        type: 'editor_context',
        payload: editorContext
    };
    else if (pageContextType !== "unknown") // if no editor context, use page context if available
    currentContext = {
        type: 'current_page',
        pageContextType: pageContextType
    };
    return {
        canUseCurrentPageContextUserPreference: (key)=>{
            return getChatMode(key).useCurrentPageContext;
        },
        setUseCurrentPageContextUserPreference: setUseCurrentPageContext,
        currentContext: currentContext
    };
};
module.exports["PageContextType"] = $329c74d7ff3c6273$export$7f7a6f1c2ab5127;
module.exports["useWindowLocation"] = $329c74d7ff3c6273$export$6fa751d66e55d2e1;
module.exports["UseCase"] = $329c74d7ff3c6273$export$59961d6586ccfd15;
module.exports["usePageContextType"] = $329c74d7ff3c6273$export$bc4bf2ff8e40b690;
module.exports["useCurrentPageAsContext"] = $329c74d7ff3c6273$export$a96e0fbf256603d8;

});

parcelRegister("V9Rzh", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");

const $cf33f445f34ab659$var$getWebSearchDefaultFromStorage = ()=>{
    if (typeof globalThis === 'undefined' || !globalThis.document || !globalThis.localStorage) return null;
    const value = globalThis.localStorage.getItem('rovo-chat-web-search-default-on');
    if (value === null) return null;
    return value !== 'false';
};
const $cf33f445f34ab659$export$99faa9801df051b0 = ()=>{
    const storageValue = $cf33f445f34ab659$var$getWebSearchDefaultFromStorage();
    // If localStorage explicitly says it's off, default should be off
    // Otherwise, use the experiment flag value
    const webSearchEnabled = storageValue === false ? false : (0, $c6GJD.default).getExperimentValue('rovo_web_search_default_on', 'isEnabled', false);
    return {
        reasoningMode: 'auto',
        webSearchEnabled: webSearchEnabled,
        orgKnowledge: {
            filteredApps: []
        },
        autoApplyEnabled: true,
        useCurrentPageContext: (0, $dh538.fg)('disable_default_on_current_page_as_context') ? false : true
    };
};
const $cf33f445f34ab659$var$updateMode = (key, mode)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || $cf33f445f34ab659$export$99faa9801df051b0();
        setState({
            [key]: {
                ...state,
                ...mode
            }
        });
    };
};
const $cf33f445f34ab659$var$store = (0, $1P1Tu.createStore)({
    initialState: {},
    actions: {
        setReasoningMode: (key, reasoningMode)=>({ dispatch: dispatch })=>{
                dispatch($cf33f445f34ab659$var$updateMode(key, {
                    reasoningMode: reasoningMode
                }));
            },
        resetReasoningMode: (key)=>({ dispatch: dispatch })=>{
                dispatch($cf33f445f34ab659$var$updateMode(key, {
                    reasoningMode: $cf33f445f34ab659$export$99faa9801df051b0().reasoningMode
                }));
            },
        setWebSearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
                dispatch($cf33f445f34ab659$var$updateMode(key, {
                    webSearchEnabled: isEnabled
                }));
            },
        setOrgKnowledge: (key, orgKnowledge)=>({ dispatch: dispatch })=>{
                dispatch($cf33f445f34ab659$var$updateMode(key, {
                    orgKnowledge: orgKnowledge
                }));
            },
        setUseCurrentPageContext: (key, isEnabled)=>({ dispatch: dispatch })=>{
                dispatch($cf33f445f34ab659$var$updateMode(key, {
                    useCurrentPageContext: isEnabled
                }));
            },
        setChatMode: (key, chatMode)=>({ dispatch: dispatch })=>{
                let updatedChatMode = chatMode;
                let orgKnowledge = $cf33f445f34ab659$export$99faa9801df051b0().orgKnowledge;
                if (chatMode.appFilters === undefined) orgKnowledge = $cf33f445f34ab659$export$99faa9801df051b0().orgKnowledge;
                else if (chatMode.appFilters.length > 0) orgKnowledge = {
                    filteredApps: chatMode.appFilters
                };
                else orgKnowledge = 'disabled';
                updatedChatMode = {
                    ...chatMode,
                    orgKnowledge: orgKnowledge
                };
                dispatch($cf33f445f34ab659$var$updateMode(key, updatedChatMode));
            },
        getChatMode: (key)=>({ getState: getState })=>{
                const state = getState()[key] || $cf33f445f34ab659$export$99faa9801df051b0();
                return {
                    ...state,
                    ...$cf33f445f34ab659$var$getDerivedReasoningMode(state.reasoningMode),
                    appFilters: $cf33f445f34ab659$var$getAppFilters(state.orgKnowledge)
                };
            },
        clearMode: (key)=>({ dispatch: dispatch })=>{
                dispatch($cf33f445f34ab659$var$updateMode(key, $cf33f445f34ab659$export$99faa9801df051b0()));
            }
    }
});
const $cf33f445f34ab659$var$getDerivedReasoningMode = (reasoningMode)=>{
    return {
        deepResearchEnabled: reasoningMode === 'deep-research',
        thinkDeeperEnabled: reasoningMode === 'think-deeper',
        autoReasoningEnabled: reasoningMode === 'auto'
    };
};
const $cf33f445f34ab659$var$getAppFilters = (orgKnowledge)=>{
    if (orgKnowledge === 'disabled') // no org knowledge applied at all.
    return [];
    else if (orgKnowledge.filteredApps.length === 0) // all org knowledge applied and no apps filtered.
    return undefined;
    else // org knowledge applied and apps filtered.
    return orgKnowledge.filteredApps;
};
const $cf33f445f34ab659$var$selector = (state, key)=>{
    const chatMode = state[key] || $cf33f445f34ab659$export$99faa9801df051b0();
    return {
        ...chatMode,
        ...$cf33f445f34ab659$var$getDerivedReasoningMode(chatMode.reasoningMode),
        appFilters: $cf33f445f34ab659$var$getAppFilters(chatMode.orgKnowledge)
    };
};
const $cf33f445f34ab659$export$cdc6dc7c4e8829fa = (0, $9zUhf.createHook)($cf33f445f34ab659$var$store, {
    selector: $cf33f445f34ab659$var$selector
});
const $cf33f445f34ab659$export$aaf871ddd4ec7885 = (0, $9zUhf.createActionsHook)($cf33f445f34ab659$var$store);
const $cf33f445f34ab659$export$e8c93422b36ab121 = (key)=>{
    const state = $cf33f445f34ab659$export$cdc6dc7c4e8829fa(key)[0];
    return state;
};
module.exports["useChatModeStore"] = $cf33f445f34ab659$export$cdc6dc7c4e8829fa;
module.exports["useChatModeStoreActions"] = $cf33f445f34ab659$export$aaf871ddd4ec7885;
module.exports["useChatModeState"] = $cf33f445f34ab659$export$e8c93422b36ab121;

});

parcelRegister("5Bdam", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $cvXh8 = parcelRequire("cvXh8");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $052T2 = parcelRequire("052T2");


var $h8Wyp = parcelRequire("h8Wyp");

const $9de080f6aa623171$var$styles = {
    menuItem: "_zulp12x7 _2rko1qi0 _18zrutpp _1bsb1osq _1e0c1txw _2lx2vrvc _1tkezwfg _1bah1yb4 _4cvr1h6o _80omtlke _bfhksm61 _irr31dpa _1di6fcek",
    menuItemActive: "_bfhk15s3 _syaz6x5g",
    menuItemDisabled: "_80om13gf _syaz1gmx _tzy42wxo",
    menuItemContent: "_zulp12x7 _16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _1e0c1txw _4cvr1h6o _1ul9idpf",
    menuItemIcon: "_1e0c1txw _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o",
    menuItemIconAdjusted: "_1e0c1txw _1bsb1tcg _4t3i1tcg _4cvr1h6o _1bah1h6o _syazazsu",
    menuItemLabelContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _y3gn1e5h",
    menuItemLabel: "_1reo15vq _18m915vq _1e0c1ule _1bsb1osq _o5721q9c _1bto1l2s"
};
const $9de080f6aa623171$export$2ce376c2cc3355c8 = ({ label: label, icon: icon, onClick: onClick, isActive: isActive, isLoading: isLoading, isDisabled: isDisabled, testId: testId })=>{
    const [showTooltip, setShowTooltip] = (0, $42omo.useState)(false);
    const textRef = (0, $42omo.useRef)(null);
    const containerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const checkOverflow = ()=>{
            if (textRef.current && containerRef.current) {
                const isOverflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
                setShowTooltip(isOverflowing);
            }
        };
        checkOverflow();
        const resizeObserver = new ResizeObserver(checkOverflow);
        if (containerRef.current) resizeObserver.observe(containerRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        label
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        xcss: (0, $1Whri.cx)($9de080f6aa623171$var$styles.menuItem, isActive && $9de080f6aa623171$var$styles.menuItemActive, isDisabled && $9de080f6aa623171$var$styles.menuItemDisabled),
        onClick: isDisabled ? undefined : onClick,
        "aria-disabled": isDisabled,
        role: "menuitem",
        testId: testId || 'menu-item-container',
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $9de080f6aa623171$var$styles.menuItemContent,
                testId: "menu-item-content",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $dh538.fg)('rovo_chat_refresh_design_adjustments') ? $9de080f6aa623171$var$styles.menuItemIconAdjusted : $9de080f6aa623171$var$styles.menuItemIcon,
                        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h8Wyp.LoadingState), {
                            size: "small",
                            testId: "loading-state"
                        }) : icon
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $9de080f6aa623171$var$styles.menuItemLabelContainer,
                        ref: containerRef,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $052T2.ConditionalTooltip), {
                            withTooltip: showTooltip,
                            content: label,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: $9de080f6aa623171$var$styles.menuItemLabel,
                                ref: textRef,
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    color: isActive ? 'color.text.selected' : 'color.text.subtle',
                                    testId: "menu-item-label",
                                    children: label
                                })
                            })
                        })
                    })
                ]
            }),
            isActive && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                label: "checkmark"
            })
        ]
    });
};
module.exports["MenuItem"] = $9de080f6aa623171$export$2ce376c2cc3355c8;

});

parcelRegister("052T2", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

const $67aeb4e4700bfc15$export$d8abb7a1cfbd4b6b = ({ withTooltip: withTooltip, content: content, children: children })=>{
    return withTooltip ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: content,
        children: children
    }) : children;
};
module.exports["ConditionalTooltip"] = $67aeb4e4700bfc15$export$d8abb7a1cfbd4b6b;

});

parcelRegister("h8Wyp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $9hlns = parcelRequire("9hlns");

const $22fb140c5a96806b$var$styles = {
    loader: "_4t3i1osq _1bsb1osq"
};
const $22fb140c5a96806b$export$62aa48085237e36f = ({ testId: testId, size: size = 'xlarge' })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        testId: testId,
        alignBlock: 'center',
        alignInline: 'center',
        xcss: $22fb140c5a96806b$var$styles.loader,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: size
        })
    });
};
module.exports["LoadingState"] = $22fb140c5a96806b$export$62aa48085237e36f;

});

parcelRegister("7JdXM", function(module, exports) {

let $5a0791297c4d19d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5a0791297c4d19d6$var$load("49cor").then(()=>parcelRequire('7Zdh8'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("j5lLr", function(module, exports) {

let $de4f5ddb97541f52$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de4f5ddb97541f52$var$load("3fdRd").then(()=>parcelRequire('bVuTs'));

});

parcelRegister("ZsUvD", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");


var $5SEdb = parcelRequire("5SEdb");


var $bJOL1 = parcelRequire("bJOL1");


var $TZbdu = parcelRequire("TZbdu");

const $169827c496727c29$var$styles = {
    wrapper: "_1rjcutpp _1reo1wug _o5721q9c _p12f1osq _1dm8q5uf _y4tiutpp"
};
const $169827c496727c29$var$useAutoScrollOnDataChange = (data)=>{
    const prevDataLength = (0, $42omo.useRef)(data.length);
    const [isAutoScroll, setIsAutoScroll] = (0, $42omo.useState)(false);
    const dataLength = data.length;
    (0, $42omo.useEffect)(()=>{
        if (prevDataLength.current < dataLength) setIsAutoScroll(true);
        else setIsAutoScroll(false);
        prevDataLength.current = dataLength;
    }, [
        dataLength
    ]);
    return isAutoScroll;
};
const $169827c496727c29$export$20d4570a6e3e703b = ({ attachtmentsStoreKey: attachtmentsStoreKey })=>{
    const [attachmentsState, { removeExternalContext: removeExternalContext, removeFile: removeFile }] = (0, $bJOL1.useAllAttachmentsStore)(attachtmentsStoreKey);
    const isAutoScroll = $169827c496727c29$var$useAutoScrollOnDataChange(attachmentsState);
    if (attachmentsState.length === 0) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        space: "space.150",
        xcss: $169827c496727c29$var$styles.wrapper,
        shouldWrap: false,
        children: attachmentsState.map((context, index)=>{
            const isLast = index === attachmentsState.length - 1;
            switch(context.type){
                case 'file':
                    const file = context.data;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $TZbdu.FileCard), {
                        fileName: file.name,
                        onRemove: ()=>removeFile(attachtmentsStoreKey, file.name),
                        isLoading: file.isLoading,
                        error: file.error,
                        autoScroll: isAutoScroll && Boolean(file.error || isLast),
                        previewBlobUrl: file.previewBlobUrl,
                        isPreviewLoading: file.isPreviewLoading,
                        fileObject: file.fileObject
                    }, file.name);
                case 'external':
                    const promptInputContext = context.data;
                    const externalContext = promptInputContext.representation;
                    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5SEdb.PreviewCard), {
                        label: externalContext.label,
                        subLabel: externalContext.description,
                        onRemove: ()=>removeExternalContext(attachtmentsStoreKey, promptInputContext.key),
                        autoScroll: isAutoScroll && Boolean(isLast),
                        cardIcon: externalContext.image
                    }, promptInputContext.key);
                default:
                    return null;
            }
        })
    });
};
module.exports["InputContextListDisplay"] = $169827c496727c29$export$20d4570a6e3e703b;

});

parcelRegister("TZbdu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $c6GJD = parcelRequire("c6GJD");


var $gdv5Z = parcelRequire("gdv5Z");


var $1yaYZ = parcelRequire("1yaYZ");

var $kIvLT = parcelRequire("kIvLT");


var $jIfmm = parcelRequire("jIfmm");


var $5SEdb = parcelRequire("5SEdb");


var $auPMn = parcelRequire("auPMn");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");




var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");








var $cgtv4 = parcelRequire("cgtv4");

var $48abd69c594aae8c$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    previewNotAvailable: {
        id: "ai-mate.file-preview-modal.preview-not-available",
        defaultMessage: "Preview not available for this file type"
    }
});


const $47ed744b079f29c0$var$styles = {
    imagePreview: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f1osq _c71l1us8 _5ral1f51 _1e0c1ule",
    pdfPreview: "_19itglyw _1bsb1osq _4t3i1us8 _1e0c1ule",
    loadingContainer: "_1e0c1txw _1bah1h6o _4cvr1h6o _1tke1kdj",
    textPreview: "_1reo1wug _18m91wug _2rko12b0 _11c81u0j _c71l1us8 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhki8nm _o5721jtm _1nmz1hna"
}; /**
    * Determines file type category from MIME type or file name
    */ 
const $47ed744b079f29c0$var$getFileType = (file)=>{
    if (file.type.startsWith('image/')) return 'image';
    if (file.type === 'application/pdf') return 'pdf';
    if ((0, $auPMn.isTextFile)(file.type, file.name)) return 'text';
    return 'unknown';
}; /**
    * Modal component for previewing images, PDFs, and text files.
    */ 
const $47ed744b079f29c0$export$7e11cd3da4852b36 = ({ isOpen: isOpen, onClose: onClose, fileName: fileName, fileObject: fileObject, previewBlobUrl: previewBlobUrl, textContent: textContent, isLoadingText: isLoadingText })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fileType = fileObject ? $47ed744b079f29c0$var$getFileType(fileObject) : previewBlobUrl ? 'image' : 'unknown';
    const [pdfBlobUrl, setPdfBlobUrl] = (0, $42omo.useState)(null); // Create PDF blob URL and track errors
    (0, $42omo.useEffect)(()=>{
        if (fileType === 'pdf' && fileObject) try {
            const blobUrl = URL.createObjectURL(fileObject);
            setPdfBlobUrl(blobUrl);
        } catch (error) {
            // Log error to Sentry for monitoring
            (0, $1yaYZ.logException)({
                exception: error,
                name: 'pdf-blob-url-creation-error',
                tags: {
                    fileType: fileObject.type
                }
            }); // User will see "Preview not available" message
            setPdfBlobUrl(null);
        }
        else setPdfBlobUrl(null);
    }, [
        fileType,
        fileObject
    ]); // Cleanup PDF blob URL on unmount
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
        };
    }, [
        pdfBlobUrl
    ]);
    const renderPreview = ()=>{
        if (fileType === 'image' && previewBlobUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "img",
            src: previewBlobUrl,
            alt: fileName,
            xcss: $47ed744b079f29c0$var$styles.imagePreview
        });
        if (fileType === 'pdf' && pdfBlobUrl) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            as: "object",
            type: "application/pdf",
            data: `${pdfBlobUrl}#toolbar=1`,
            title: fileName,
            xcss: $47ed744b079f29c0$var$styles.pdfPreview,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                as: "embed",
                type: "application/pdf",
                src: `${pdfBlobUrl}#toolbar=1`,
                xcss: $47ed744b079f29c0$var$styles.pdfPreview
            })
        });
        if (fileType === 'text') {
            if (isLoadingText) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $47ed744b079f29c0$var$styles.loadingContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                    size: "large"
                })
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $47ed744b079f29c0$var$styles.textPreview,
                children: textContent
            });
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $47ed744b079f29c0$var$styles.loadingContainer,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                children: formatMessage((0, $48abd69c594aae8c$export$2e2bcd8739ae039).previewNotAvailable)
            })
        });
    };
    if (!(0, $c6GJD.default).getExperimentValue('rovo_chat_file_previews_experiment', 'isEnabled', false)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: onClose,
            width: "x-large",
            shouldScrollInViewport: true,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: fileName
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    hasInlinePadding: false,
                    children: renderPreview()
                })
            ]
        })
    });
};





var $52d66d6d58d8ca49$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    fileCloseIconLabel: {
        id: "ai-mate.chat-input.file-close-icon-label",
        defaultMessage: "Remove file"
    },
    fileErrorIconLabel: {
        id: "ai-mate.chat-input.file-error-icon-label",
        defaultMessage: "Error loading file"
    },
    textLoadFailed: {
        id: "ai-mate.chat-input.text-load-failed",
        defaultMessage: "Failed to load file content"
    },
    textFileTooLarge: {
        id: "ai-mate.chat-input.text-file-too-large",
        defaultMessage: "This file is too large to preview ({sizeMB}MB)."
    }
});


const $526d9c7505b62ef8$var$MAX_TEXT_SIZE = 2097152;
const $526d9c7505b62ef8$var$styles = {
    fileCardBgWrapper: "_2rko12b0 _bfhkhp5a _1e0c1txw"
};
const $526d9c7505b62ef8$var$FileCardBgWrappper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $526d9c7505b62ef8$var$styles.fileCardBgWrapper,
        children: children
    });
};
const $526d9c7505b62ef8$var$getFileNameAndExtension = (fileName)=>{
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === 0) return {
        name: fileName,
        extension: ''
    };
    return {
        name: fileName.slice(0, lastDotIndex),
        extension: fileName.slice(lastDotIndex + 1)
    };
};
const $526d9c7505b62ef8$export$593fd10f7e6c6505 = ({ fileName: fileName, onRemove: onRemove, isLoading: isLoading, error: error, autoScroll: autoScroll, previewBlobUrl: previewBlobUrl, isPreviewLoading: isPreviewLoading, fileObject: fileObject })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const { name: fileNameWithoutExtension, extension: extension } = $526d9c7505b62ef8$var$getFileNameAndExtension(fileName);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [textContent, setTextContent] = (0, $42omo.useState)(null);
    const [isLoadingText, setIsLoadingText] = (0, $42omo.useState)(false);
    const handleCardClick = (0, $42omo.useCallback)(()=>{
        if (!fileObject) return;
        if ((0, $auPMn.isTextFile)(fileObject.type, fileObject.name)) {
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'preview',
                actionSubjectId: 'filePreview',
                attributes: {
                    fileType: fileObject.type,
                    fileSize: fileObject.size
                }
            });
            setIsLoadingText(true);
            setIsModalOpen(true); // Performance safeguard: Limit text file preview to 2MB
            if (fileObject.size > $526d9c7505b62ef8$var$MAX_TEXT_SIZE) {
                const sizeMB = (fileObject.size / 1048576).toFixed(1);
                setTextContent(formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).textFileTooLarge, {
                    sizeMB: sizeMB
                }));
                setIsLoadingText(false);
                return;
            }
            fileObject.text().then((content)=>{
                setTextContent(content);
                setIsLoadingText(false);
            }).catch((error)=>{
                (0, $1yaYZ.logException)({
                    exception: error,
                    name: 'text-file-content-load-error',
                    tags: {
                        fileType: fileObject.type
                    }
                });
                const errorMessage = error instanceof Error ? error.message : formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).textLoadFailed);
                setTextContent(errorMessage);
                setIsLoadingText(false);
            });
        } else if (fileObject.type.startsWith('image/') || fileObject.type === 'application/pdf') {
            sendAnalyticsEvent({
                action: 'opened',
                actionSubject: 'preview',
                actionSubjectId: 'filePreview',
                attributes: {
                    fileType: fileObject.type,
                    fileSize: fileObject.size
                }
            });
            setIsModalOpen(true);
        }
    }, [
        fileObject,
        formatMessage,
        sendAnalyticsEvent
    ]);
    const isPreviewableType = fileObject && (fileObject.type.startsWith('image/') || fileObject.type === 'application/pdf' || (0, $auPMn.isTextFile)(fileObject.type, fileObject.name));
    const canOpenPreview = isPreviewableType && !isLoading && !isPreviewLoading && !error && (0, $c6GJD.default).getExperimentValue('rovo_chat_file_previews_experiment', 'isEnabled', false);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $5SEdb.PreviewCard), {
                autoScroll: autoScroll,
                label: fileNameWithoutExtension,
                subLabel: extension?.toUpperCase(),
                isLoading: isLoading || isPreviewLoading,
                error: error,
                onRemove: onRemove,
                imageSrc: previewBlobUrl,
                onClick: canOpenPreview ? handleCardClick : undefined,
                cardIcon: /*#__PURE__*/ (0, $l998X.jsx)($526d9c7505b62ef8$var$FileCardBgWrappper, {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jIfmm.FileIcon), {
                        fileName: fileName,
                        size: "medium"
                    })
                }),
                subLabelIcon: /*#__PURE__*/ (0, $l998X.jsx)((0, $jIfmm.FileIconSimple), {
                    size: "small",
                    fileName: fileName,
                    color: "var(--ds-icon-subtle, #505258)"
                }),
                errorLabel: formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).fileErrorIconLabel),
                removeLabel: formatMessage((0, $52d66d6d58d8ca49$export$2e2bcd8739ae039).fileCloseIconLabel)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $47ed744b079f29c0$export$7e11cd3da4852b36), {
                isOpen: isModalOpen,
                onClose: ()=>setIsModalOpen(false),
                fileName: fileName,
                fileObject: fileObject,
                previewBlobUrl: previewBlobUrl,
                textContent: textContent,
                isLoadingText: isLoadingText
            })
        ]
    });
};
module.exports["FileCard"] = $526d9c7505b62ef8$export$593fd10f7e6c6505;

});

parcelRegister("jIfmm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // @ts-ignore explicitly imported 'react' to avoid commonjs build issues with compiled library. Ref: https://atlassian.slack.com/archives/C08BQ9QDRFX/p1748283909199679
// eslint-disable-next-line no-unused-vars

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $cgtv4 = parcelRequire("cgtv4");

var $9204b6cd3db809a0$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    iconLabel: {
        id: "rovo-chat.message-file.icon-label",
        defaultMessage: "File"
    }
});



const $77341e7889b8b78c$var$ArchiveIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8Q8zP")));

const $77341e7889b8b78c$var$AudioIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("hcJ56")));

const $77341e7889b8b78c$var$DocumentIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("i9cac"))));

const $77341e7889b8b78c$var$ExcelIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7X7LY")));

const $77341e7889b8b78c$var$GenericIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("djgQ6"))));

const $77341e7889b8b78c$var$GoogleDocIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("fk3Vu")));

const $77341e7889b8b78c$var$GoogleSheetIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("lGa5e")));

const $77341e7889b8b78c$var$GoogleSlideIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("1DZBp")));

const $77341e7889b8b78c$var$ImageIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("478Ii")));

const $77341e7889b8b78c$var$PDFIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9ZH0J")));

const $77341e7889b8b78c$var$PowerpointIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gkryH")));

const $77341e7889b8b78c$var$SourceCodeIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("iM8DS")));

const $77341e7889b8b78c$var$SpreadsheetIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("iFCP2"))));

const $77341e7889b8b78c$var$VideoIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("6Cxjr")));

const $77341e7889b8b78c$var$WordDocumentIconMedium = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("kjtlE"))); // Icons

const $77341e7889b8b78c$var$ArchiveIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5dAfr")));

const $77341e7889b8b78c$var$AudioIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("33MJ0")));

const $77341e7889b8b78c$var$DocumentIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("5mB97"))));

const $77341e7889b8b78c$var$ExcelIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("516g5")));

const $77341e7889b8b78c$var$GenericIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("8DZd1"))));

const $77341e7889b8b78c$var$GoogleDocIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("c8ZoX")));

const $77341e7889b8b78c$var$GoogleSheetIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("9wre1")));

const $77341e7889b8b78c$var$GoogleSlideIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("htcSJ")));

const $77341e7889b8b78c$var$ImageIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gSwgA")));

const $77341e7889b8b78c$var$PDFIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("7peNt")));

const $77341e7889b8b78c$var$PowerpointIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("ffDhW")));

const $77341e7889b8b78c$var$SourceCodeIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jQ6zD")));

const $77341e7889b8b78c$var$SpreadsheetIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("lxsNd"))));

const $77341e7889b8b78c$var$VideoIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("8MDgw")));

const $77341e7889b8b78c$var$WordDocumentIcon = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("5lE6Q"))); // New icons

const $77341e7889b8b78c$var$ImageIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("fZtQj"))));

const $77341e7889b8b78c$var$FileNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("chO1Z"))));

const $77341e7889b8b78c$var$VideoIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("2Yaht"))));

const $77341e7889b8b78c$var$AudioIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>Promise.resolve((parcelRequire("e3TOY"))));

const $77341e7889b8b78c$var$SpreadsheetIconNew = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("gNsmn")));
const $77341e7889b8b78c$export$a697c9ed370839d5 = ({ fileName: fileName, ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fileExtension = fileName.split('.').pop();
    const label = formatMessage((0, $9204b6cd3db809a0$export$2e2bcd8739ae039).iconLabel);
    if (!fileExtension) return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIcon, {
        label: label
    });
    switch(fileExtension.toLowerCase()){
        // Images
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ImageIconNew, {
                ...props,
                label: label
            });
        // Spreadsheets
        case 'csv':
        case 'tsv':
        case 'xls':
        case 'xlsx':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SpreadsheetIconNew, {
                ...props,
                label: label
            });
        // Audio
        case 'mp3':
        case 'wav':
        case 'flac':
        case 'ogg':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$AudioIconNew, {
                ...props,
                label: label
            });
        // Videos
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$VideoIconNew, {
                ...props,
                label: label
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$FileNew, {
                ...props,
                label: label
            });
    }
};
const $77341e7889b8b78c$export$8c1a3d13e85d78b7 = ({ fileName: fileName, size: size = 'small' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fileExtension = fileName.split('.').pop();
    const label = formatMessage((0, $9204b6cd3db809a0$export$2e2bcd8739ae039).iconLabel);
    if (!fileExtension) return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIcon, {
        label: label
    }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIconMedium, {
        label: label
    });
    switch(fileExtension.toLowerCase()){
        // TXT Files
        case 'txt':
        case 'md':
        case 'log':
        case 'json':
        case 'yaml':
        case 'yml':
        case 'xml':
        case 'rtf':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$DocumentIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$DocumentIconMedium, {
                label: label
            });
        // Plain Spreadsheets
        case 'csv':
        case 'tsv':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SpreadsheetIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SpreadsheetIconMedium, {
                label: label
            });
        // Word Documents
        case 'doc':
        case 'docx':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$WordDocumentIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$WordDocumentIconMedium, {
                label: label
            });
        // PDF Files
        case 'pdf':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PDFIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PDFIconMedium, {
                label: label
            });
        // PowerPoint Presentations
        case 'ppt':
        case 'pptx':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PowerpointIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$PowerpointIconMedium, {
                label: label
            });
        // Excel Spreadsheets
        case 'xls':
        case 'xlsx':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ExcelIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ExcelIconMedium, {
                label: label
            });
        // Images
        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ImageIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ImageIconMedium, {
                label: label
            });
        // Audio
        case 'mp3':
        case 'wav':
        case 'flac':
        case 'ogg':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$AudioIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$AudioIconMedium, {
                label: label
            });
        // Videos
        case 'mp4':
        case 'avi':
        case 'mov':
        case 'mkv':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$VideoIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$VideoIconMedium, {
                label: label
            });
        case 'zip':
        case 'rar':
        case '7z':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ArchiveIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$ArchiveIconMedium, {
                label: label
            });
        // Source Code
        case 'css':
        case 'html':
        case 'htm':
        case 'c':
        case 'cpp':
        case 'cs':
        case 'java':
        case 'js':
        case 'jsx':
        case 'vue':
        case 'svelte':
        case 'as':
        case 'sh':
        case 'bash':
        case 'bats':
        case 'h':
        case 'cc':
        case 'cxx':
        case 'hpp':
        case 'hxx':
        case 'coffee':
        case 'litcoffee':
        case 'clj':
        case 'cljs':
        case 'cljc':
        case 'edn':
        case 'dockerfile':
        case 'dockerignore':
        case 'erl':
        case 'hrl':
        case 'f':
        case 'for':
        case 'f90':
        case 'f95':
        case 'f03':
        case 'f08':
        case 'go':
        case 'kt':
        case 'kts':
        case 'tex':
        case 'sty':
        case 'cls':
        case 'less':
        case 'makefile':
        case 'mak':
        case 'mk':
        case 'm':
        case 'mat':
        case 'mm':
        case 'pas':
        case 'pp':
        case 'p':
        case 'pl':
        case 'pm':
        case 't':
        case 'pod':
        case 'php':
        case 'php3':
        case 'php4':
        case 'php5':
        case 'phtml':
        case 'py':
        case 'pyw':
        case 'pyc':
        case 'pyo':
        case 'pyd':
        case 'r':
        case 'rb':
        case 'erb':
        case 'rake':
        case 'gemspec':
        case 'rs':
        case 'rslib':
        case 'sas':
        case 'sas7bdat':
        case 'scss':
        case 'sass':
        case 'scala':
        case 'sc':
        case 'sbt':
        case 'st':
        case 'sm':
        case 'sql':
        case 'swift':
        case 'tcl':
        case 'itcl':
        case 'ts':
        case 'tsx':
        case 'v':
        case 'vh':
        case 'vhd':
        case 'vhdl':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SourceCodeIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$SourceCodeIconMedium, {
                label: label
            });
        case 'gdoc':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleDocIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleDocIconMedium, {
                label: label
            });
        case 'gsheet':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSheetIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSheetIconMedium, {
                label: label
            });
        case 'gslide':
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSlideIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GoogleSlideIconMedium, {
                label: label
            });
        default:
            return size === 'small' ? /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIcon, {
                label: label
            }) : /*#__PURE__*/ (0, $l998X.jsx)($77341e7889b8b78c$var$GenericIconMedium, {
                label: label
            });
    }
};
module.exports["FileIconSimple"] = $77341e7889b8b78c$export$a697c9ed370839d5;
module.exports["FileIcon"] = $77341e7889b8b78c$export$8c1a3d13e85d78b7;

});

parcelRegister("8Q8zP", function(module, exports) {

let $66f9d53b36a1c87f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66f9d53b36a1c87f$var$load("2fk6g").then(()=>parcelRequire('fX9Sa'));

});

parcelRegister("hcJ56", function(module, exports) {

let $c86686e07b9e0d86$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c86686e07b9e0d86$var$load("72780").then(()=>parcelRequire('gguok'));

});

parcelRegister("7X7LY", function(module, exports) {

let $5ca4129d5a883a9f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ca4129d5a883a9f$var$load("eTBsW").then(()=>parcelRequire('gH8Rx'));

});

parcelRegister("fk3Vu", function(module, exports) {

let $b27bc4f01f81a82c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b27bc4f01f81a82c$var$load("lxiFd").then(()=>parcelRequire('5W6v1'));

});

parcelRegister("lGa5e", function(module, exports) {

let $fc8557957af59f74$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fc8557957af59f74$var$load("6HBYC").then(()=>parcelRequire('giYeH'));

});

parcelRegister("1DZBp", function(module, exports) {

let $132937e71aaf3ed1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $132937e71aaf3ed1$var$load("bYxCZ").then(()=>parcelRequire('eWLPt'));

});

parcelRegister("478Ii", function(module, exports) {

let $2fee932bd4798889$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2fee932bd4798889$var$load("hszIA").then(()=>parcelRequire('20uDq'));

});

parcelRegister("9ZH0J", function(module, exports) {

let $746b2ca068d8f3b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $746b2ca068d8f3b8$var$load("eVYW1").then(()=>parcelRequire('lzyQK'));

});

parcelRegister("gkryH", function(module, exports) {

let $be33e4276f6027a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $be33e4276f6027a7$var$load("020xd").then(()=>parcelRequire('dfQbH'));

});

parcelRegister("iM8DS", function(module, exports) {

let $dab369d9cf26d73b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dab369d9cf26d73b$var$load("6vhrJ").then(()=>parcelRequire('7t8Pn'));

});

parcelRegister("6Cxjr", function(module, exports) {

let $4d2021df6d8f57b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d2021df6d8f57b5$var$load("4jPsO").then(()=>parcelRequire('hXc8o'));

});

parcelRegister("kjtlE", function(module, exports) {

let $ec9c58f6e253e433$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec9c58f6e253e433$var$load("ls0Um").then(()=>parcelRequire('lkBga'));

});

parcelRegister("5dAfr", function(module, exports) {

let $3cca48c73573eb39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3cca48c73573eb39$var$load("2fk6g").then(()=>parcelRequire('dlbUV'));

});

parcelRegister("33MJ0", function(module, exports) {

let $23a772a51c01d9a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $23a772a51c01d9a7$var$load("jDjSj").then(()=>parcelRequire('d4cCP'));

});

parcelRegister("516g5", function(module, exports) {

let $3a71e68ec6145457$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3a71e68ec6145457$var$load("eTBsW").then(()=>parcelRequire('d8Kpd'));

});

parcelRegister("c8ZoX", function(module, exports) {

let $8d75dc799514e943$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8d75dc799514e943$var$load("lxiFd").then(()=>parcelRequire('4rkAw'));

});

parcelRegister("9wre1", function(module, exports) {

let $6eec388d67832b92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6eec388d67832b92$var$load("6HBYC").then(()=>parcelRequire('l59oX'));

});

parcelRegister("htcSJ", function(module, exports) {

let $cb7f232b5be92725$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cb7f232b5be92725$var$load("bYxCZ").then(()=>parcelRequire('jOGxt'));

});

parcelRegister("gSwgA", function(module, exports) {

let $c49ab7ec4a42565a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c49ab7ec4a42565a$var$load("8059b").then(()=>parcelRequire('41GKb'));

});

parcelRegister("7peNt", function(module, exports) {

let $5646588e31a854db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5646588e31a854db$var$load("eVYW1").then(()=>parcelRequire('11LZV'));

});

parcelRegister("ffDhW", function(module, exports) {

let $b1a6bb9a21a18a09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b1a6bb9a21a18a09$var$load("020xd").then(()=>parcelRequire('hY1Uy'));

});

parcelRegister("jQ6zD", function(module, exports) {

let $e717f90bdc95406f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e717f90bdc95406f$var$load("3wmvj").then(()=>parcelRequire('1iV2p'));

});

parcelRegister("8MDgw", function(module, exports) {

let $01a678d5b4524a60$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $01a678d5b4524a60$var$load("hPalR").then(()=>parcelRequire('ayTrS'));

});

parcelRegister("5lE6Q", function(module, exports) {

let $3e4e06d4705f4ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e4e06d4705f4ba7$var$load("ls0Um").then(()=>parcelRequire('90Icb'));

});

parcelRegister("gNsmn", function(module, exports) {

let $c3a7389d823fcf78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3a7389d823fcf78$var$load("ijPJo").then(()=>parcelRequire('g7f9W'));

});

parcelRegister("hnap0", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");




parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $cvXh8 = parcelRequire("cvXh8");

const $36df8291a6905ce9$export$7abe5c0eca305a26 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        shape: "circle",
        isTooltipDisabled: false,
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                ...iconProps,
                label: ''
            }),
        appearance: "primary",
        label: "Accept",
        onClick: onClick
    });
};


var $6VMxF = parcelRequire("6VMxF");



parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");





var $bAxHS = parcelRequire("bAxHS");


var $cgtv4 = parcelRequire("cgtv4");

var $ca272b553354018f$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    voiceDictationButtonLabel: {
        id: "rovo-chat.voice-dictation.label",
        defaultMessage: "Dictation"
    }
});


const $ddd3d9833ba5ad8f$export$b961018097c75c7a = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        shape: "circle",
        isTooltipDisabled: false,
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bAxHS))), {
                ...iconProps,
                label: ''
            }),
        appearance: "subtle",
        onClick: onClick,
        label: formatMessage((0, $ca272b553354018f$export$2e2bcd8739ae039).voiceDictationButtonLabel)
    });
};




parcelRequire("42omo");





var $hmuev = parcelRequire("hmuev");

const $1cbc8b81a31bdb47$export$a27af6ac3487f513 = ({ onClick: onClick })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        shape: "circle",
        isTooltipDisabled: false,
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                ...iconProps,
                label: ''
            }),
        appearance: "subtle",
        onClick: onClick,
        label: "Reject"
    });
};



var $5VZ9F = parcelRequire("5VZ9F");

const $47c9275fd33997dc$export$17b7b65a0b5f1d03 = ({ entryPoint: entryPoint, state: state, onRejectRecording: onRejectRecording, onStartRecording: onStartRecording, onAcceptRecording: onAcceptRecording, children: children, isVoiceDictationEnabled: isVoiceDictationEnabled = true })=>{
    const handleOnMicrophoneClick = (0, $42omo.useCallback)(()=>{
        if (state !== (0, $6VMxF.VoiceDictationState).Recording) onStartRecording();
    }, [
        state,
        onStartRecording
    ]);
    if (!isVoiceDictationEnabled) return children;
    switch(state){
        case (0, $6VMxF.VoiceDictationState).Recording:
        case (0, $6VMxF.VoiceDictationState).Initializing:
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1cbc8b81a31bdb47$export$a27af6ac3487f513), {
                        onClick: onRejectRecording
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $36df8291a6905ce9$export$7abe5c0eca305a26), {
                        onClick: onAcceptRecording
                    })
                ]
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5VZ9F.GettingStartedTourSpotlight), {
                        step: 3,
                        entryPoint: entryPoint,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ddd3d9833ba5ad8f$export$b961018097c75c7a), {
                            onClick: handleOnMicrophoneClick
                        })
                    }),
                    children
                ]
            });
    }
};
module.exports["VoiceActionsPanel"] = $47c9275fd33997dc$export$17b7b65a0b5f1d03;

});

parcelRegister("4zqRX", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $6VMxF = parcelRequire("6VMxF");


var $cdw4J = parcelRequire("cdw4J");

const $402491f12c37302a$var$styles = {
    ellipsesContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug"
};
const $402491f12c37302a$export$988d501c27cfdba6 = ({ children: children, state: state })=>{
    switch(state){
        case (0, $6VMxF.VoiceDictationState).Recording:
        case (0, $6VMxF.VoiceDictationState).Initializing:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $402491f12c37302a$var$styles.ellipsesContainer,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cdw4J.EllipsesAnimation), {
                    isAnimated: true
                })
            });
        default:
            return children;
    }
};
module.exports["VoiceRecordingPanel"] = $402491f12c37302a$export$988d501c27cfdba6;

});

parcelRegister("f2la9", function(module, exports) {
/* SkillsEditorExtension.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bre0g = parcelRequire("bre0g");


var $dh538 = parcelRequire("dh538");


var $ij2FZ = parcelRequire("ij2FZ");


var $kIvLT = parcelRequire("kIvLT");


var $gkZa1 = parcelRequire("gkZa1");


var $3QWW6 = parcelRequire("3QWW6");

const $88d8e842aa349fe5$var$getSkillIcon = (iconName)=>iconName && (0, $gkZa1.skillIcon)[iconName] ? (0, $gkZa1.skillIcon)[iconName] : (0, $gkZa1.defaultIcon);
// These three PJM skills require the feature gate to be enabled
const $88d8e842aa349fe5$var$GATED_JIRA_SKILLS = [
    'create-work-items',
    'update-work-items',
    'write-status-update'
];
const $88d8e842aa349fe5$export$638dd2312a955e92 = [
    {
        slug: 'update-work-items',
        name: 'Update work items',
        description: 'Update work item fields like assignee, summary, descriptions, and more',
        product: 'Jira',
        iconName: 'work-item'
    },
    {
        slug: 'write-status-update',
        name: 'Write status update',
        description: 'Provide an update on the status of work in a space',
        product: 'Jira',
        iconName: 'ai-generative-text'
    },
    {
        slug: 'summarize-release',
        name: 'Summarize release',
        description: 'Summarize release scope, risks, blockers, and more',
        product: 'Jira',
        iconName: 'chart-bar-line'
    },
    {
        slug: 'draft-release-notes',
        name: 'Draft release notes',
        description: 'Write release notes covering key changes in a release',
        product: 'Jira',
        iconName: 'ai-generative-text'
    },
    {
        slug: 'create-release',
        name: 'Create release',
        description: 'Create a release to package code for deployment',
        product: 'Jira',
        iconName: 'add'
    },
    {
        slug: 'explain-next-status',
        name: 'Explain next status',
        description: 'Get a summary of available statuses and transitions for a work item',
        product: 'Jira',
        iconName: 'project-status'
    },
    {
        slug: 'get-data-insights',
        name: 'Get data insights',
        description: 'Create charts and get insights on your work',
        product: 'Jira',
        iconName: 'chart-pie'
    },
    {
        slug: 'manage-jira-permissions',
        name: 'Manage Jira permissions',
        description: `Manage permissions in Jira projects`,
        product: 'Jira',
        iconName: 'lock-locked'
    },
    {
        slug: 'find-jira-settings',
        name: 'Find Jira settings',
        description: `Get assistance finding the correct Jira admin settings for your needs`,
        product: 'Jira',
        iconName: 'settings'
    },
    {
        slug: 'assist-jira-plans',
        name: 'Assist Jira plans',
        description: 'Get help optimizing and managing Jira plans',
        product: 'Jira',
        iconName: 'plan'
    },
    {
        slug: 'search-assets',
        name: 'Search Assets',
        description: 'Query Assets data to get organizational insights in Rovo Chat',
        product: 'Jira',
        iconName: 'assets'
    }
];
const $88d8e842aa349fe5$var$filterSkillsByFeatureGate = (skills)=>{
    const jiraSkillsEnabled = (0, $dh538.fg)('rovo_jira_skills_enabled');
    if (jiraSkillsEnabled) return skills;
    return skills.filter((skill)=>{
        // Include the skill if it's not in the gated list or if the gate is enabled
        return !$88d8e842aa349fe5$var$GATED_JIRA_SKILLS.includes(skill.slug);
    });
};
const $88d8e842aa349fe5$export$a728a4b0cfbf102d = ({ skills: skills = $88d8e842aa349fe5$export$638dd2312a955e92, isConversationAgentic: isConversationAgentic, promptHasSkill: promptHasSkill, enableSkills: enableSkills = true })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $kIvLT.useAnalytics)();
    const createManifest = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((skills = $88d8e842aa349fe5$export$638dd2312a955e92)=>{
        const filteredSkills = $88d8e842aa349fe5$var$filterSkillsByFeatureGate(skills);
        const manifest = {
            title: 'Skills',
            type: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
            key: (0, $ij2FZ.ROVO_SKILL_EXTENSION_KEY),
            categories: [
                'Skills'
            ],
            icons: {
                '16': (0, $gkZa1.defaultIcon),
                '24': (0, $gkZa1.defaultIcon),
                '48': (0, $gkZa1.defaultIcon)
            },
            modules: {
                quickInsert: filteredSkills.map((skill)=>{
                    const { slug: slug, description: description, name: name, product: product, iconName: iconName } = skill;
                    return {
                        key: slug,
                        keywords: [
                            'skills',
                            'skill',
                            slug,
                            product ?? ''
                        ],
                        // 1 is the default priority
                        priority: 99,
                        title: name,
                        description: description,
                        icon: $88d8e842aa349fe5$var$getSkillIcon(iconName),
                        action: async ()=>{
                            sendAnalyticsEvent({
                                eventType: 'ui',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'rovoChatSkillSelected',
                                attributes: {
                                    slashCommand: slug,
                                    skillProductKey: product
                                }
                            });
                            return [
                                {
                                    type: 'inlineExtension',
                                    attrs: {
                                        extensionKey: (0, $ij2FZ.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                                        extensionType: (0, $ij2FZ.ROVO_SKILL_EXTENSION_TYPE),
                                        parameters: skill
                                    }
                                },
                                // render an empty space after the skill tag
                                {
                                    type: 'text',
                                    text: ' '
                                }
                            ];
                        }
                    };
                }),
                nodes: {
                    skillTag: {
                        type: 'inlineExtension',
                        render: async ()=>({ node: node })=>{
                                const params = node.parameters;
                                if (params) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3QWW6.SkillTag), {
                                    ...params
                                });
                                return null;
                            }
                    }
                }
            }
        };
        return manifest;
    }, [
        sendAnalyticsEvent
    ]);
    const manifestProvider = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        // Return undefined if skills are disabled
        if (!enableSkills) return undefined;
        // skills are only applicable to non-agentic conversations
        // remove skills if a skill is already present in the prompt until chaining is allowed
        if ((isConversationAgentic || promptHasSkill) && (0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) return [
            new (0, $bre0g.default)([
                createManifest([])
            ])
        ];
        else if ((0, $dh538.fg)('rovo_chat_enable_skills_ui_m1')) return [
            new (0, $bre0g.default)([
                createManifest(skills)
            ])
        ];
        return undefined;
    }, [
        isConversationAgentic,
        promptHasSkill,
        createManifest,
        skills,
        enableSkills
    ]);
    return manifestProvider;
};
module.exports["TEMP_SKILLS_LIST"] = $88d8e842aa349fe5$export$638dd2312a955e92;
module.exports["useSkillsManifest"] = $88d8e842aa349fe5$export$a728a4b0cfbf102d;

});

parcelRegister("ciV2C", function(module, exports) {

let $8f5369acfd9ab17e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8f5369acfd9ab17e$var$load("2ap9J").then(()=>parcelRequire('bKhxF'));

});

parcelRegister("8OGHW", function(module, exports) {

let $66b41f16e830c814$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $66b41f16e830c814$var$load("1yrlK").then(()=>parcelRequire('2LFoe'));

});

parcelRegister("4qVJ2", function(module, exports) {

let $33a65e3728a6deed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $33a65e3728a6deed$var$load("czqcb").then(()=>parcelRequire('OmUay'));

});

parcelRegister("eqsS5", function(module, exports) {

let $a809e3a38eaabc9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a809e3a38eaabc9b$var$load("iAqyW").then(()=>parcelRequire('h7YX1'));

});

parcelRegister("8sr2T", function(module, exports) {

let $6285eaf809731400$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6285eaf809731400$var$load("8vVzT").then(()=>parcelRequire('4DzVW'));

});

parcelRegister("i4zNS", function(module, exports) {

let $d2845f86362f2ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d2845f86362f2ced$var$load("hpUn4").then(()=>parcelRequire('3Pjsu'));

});

parcelRegister("6E8pW", function(module, exports) {

let $4d6d0204a36cd6bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4d6d0204a36cd6bd$var$load("l4YAS").then(()=>parcelRequire('f2ref'));

});

parcelRegister("3mxkw", function(module, exports) {

let $272d47d3be217e93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $272d47d3be217e93$var$load("6HxBR").then(()=>parcelRequire('2KFft'));

});

parcelRegister("3QWW6", function(module, exports) {
/* SkillTag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lvsjl = parcelRequire("lvsjl");


var $1Whri = parcelRequire("1Whri");


var $7hXDW = parcelRequire("7hXDW");


var $lGgRw = parcelRequire("lGgRw");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $i4C2H = parcelRequire("i4C2H");


var $gkZa1 = parcelRequire("gkZa1");

const $4e067729dc89bc6a$var$styles = {
    parallelogram: "_2rkolb4i _18u01b66 _19bv12x7 _u5f312x7 _t9ec1hsb _1e0c1o8l",
    background: "_bfhki8nm",
    backgroundInverse: "_bfhk1vck",
    content: "_t9ecstek"
};
const $4e067729dc89bc6a$var$hovercardStyles = {
    container: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbnklw",
    skillName: "_k48pmoej _otyru2gc _4cvr1h6o",
    product: "_19pkutpp _syazazsu"
};
const $4e067729dc89bc6a$var$getBorderColor = (accentColor, invertColors)=>{
    // return the color and use it directly, otherwise return the default token
    if (accentColor) return accentColor;
    else if (invertColors) return "var(--ds-border-inverse, #FFFFFF)";
    return "var(--ds-border, #0B120E24)";
};
const $4e067729dc89bc6a$var$SkillTagInternal = ({ triggerProps: triggerProps = {}, invertColors: invertColors, accentColor: accentColor, slug: slug, IconComponent: IconComponent, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: (0, $1Whri.cx)($4e067729dc89bc6a$var$styles.parallelogram, invertColors ? $4e067729dc89bc6a$var$styles.backgroundInverse : $4e067729dc89bc6a$var$styles.background),
        style: {
            borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${$4e067729dc89bc6a$var$getBorderColor(accentColor, invertColors)}`
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ...triggerProps,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            xcss: $4e067729dc89bc6a$var$styles.content,
            space: "space.050",
            alignBlock: "center",
            children: [
                IconComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
                    fallback: null,
                    interactionName: "skill-tag-icon",
                    children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                        label: "",
                        size: "small",
                        color: invertColors ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)"
                    })
                }),
                slug
            ]
        })
    });
const $4e067729dc89bc6a$var$SkillHoverCard = ({ onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, product: product, IconComponent: IconComponent, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $4e067729dc89bc6a$var$hovercardStyles.container,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                    xcss: $4e067729dc89bc6a$var$hovercardStyles.skillName,
                    space: "space.100",
                    children: [
                        IconComponent && /*#__PURE__*/ (0, $l998X.jsx)((0, $i4C2H.default), {
                            fallback: null,
                            interactionName: "skill-tag-hovercard-icon",
                            children: /*#__PURE__*/ (0, $l998X.jsx)(IconComponent, {
                                label: "",
                                size: "medium",
                                color: "var(--ds-icon-accent-blue, #357DE8)"
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                            size: "xsmall",
                            children: props.name
                        })
                    ]
                }),
                props.description && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text",
                        children: props.description
                    })
                }),
                product && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $4e067729dc89bc6a$var$hovercardStyles.product,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        size: "small",
                        children: product
                    })
                })
            ]
        })
    });
// delay opening and closing of the hovercard to prevent flickering
const $4e067729dc89bc6a$var$SKILL_TAG_HOVERCARD_DELAY = 200;
const $4e067729dc89bc6a$export$55feb0e4f341a6f6 = ({ invertColors: invertColors = false, disableHovercard: disableHovercard = false, product: product, iconName: iconName, ...props })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const [setIsOpenDebounced, cancelSetIsOpen] = (0, $lvsjl.default)((open)=>{
        setIsOpen(open);
    }, $4e067729dc89bc6a$var$SKILL_TAG_HOVERCARD_DELAY);
    const IconComponent = iconName ? (0, $gkZa1.skillIconMap)[iconName] : undefined;
    const hasHovercardInfo = props?.name && props?.description;
    return disableHovercard || !hasHovercardInfo ? /*#__PURE__*/ (0, $l998X.jsx)($4e067729dc89bc6a$var$SkillTagInternal, {
        ...props,
        invertColors: invertColors,
        disableHovercard: disableHovercard,
        IconComponent: IconComponent
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        placement: "top",
        fallbackPlacements: [
            'bottom',
            'left'
        ],
        // don't take focus away from the editor, etc.
        autoFocus: false,
        isOpen: isOpen,
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)($4e067729dc89bc6a$var$SkillHoverCard, {
                // cancel the close debounce when moving between the tag and the hovercard
                onMouseEnter: ()=>cancelSetIsOpen(),
                onMouseLeave: ()=>setIsOpenDebounced(false),
                product: product,
                IconComponent: IconComponent,
                ...props
            }),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, $l998X.jsx)($4e067729dc89bc6a$var$SkillTagInternal, {
                triggerProps: triggerProps,
                invertColors: invertColors,
                disableHovercard: disableHovercard,
                IconComponent: IconComponent,
                onMouseEnter: ()=>{
                    setIsOpenDebounced(true);
                },
                onMouseLeave: ()=>{
                    setIsOpenDebounced(false);
                },
                ...props
            });
        }
    });
};
module.exports["SkillTag"] = $4e067729dc89bc6a$export$55feb0e4f341a6f6;

});

parcelRegister("CV9x9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $c6GJD = parcelRequire("c6GJD");


var $16lEl = parcelRequire("16lEl");


var $29BPs = parcelRequire("29BPs");


var $h26dv = parcelRequire("h26dv");


var $i08Mr = parcelRequire("i08Mr");


var $fDnfG = parcelRequire("fDnfG");


var $cgtv4 = parcelRequire("cgtv4");

var $61feb0d05111c898$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    // BITBUCKET_PULL_REQUESTS
    bitbucketPullRequestsPrompt1: {
        id: "ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-1",
        defaultMessage: "Summarize this pull request."
    },
    bitbucketPullRequestsPrompt2: {
        id: "ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-2",
        defaultMessage: "Explain the code changes to me."
    },
    bitbucketPullRequestsPrompt3: {
        id: "ai-mate.chat-history.empty-state.bitbucket-pull-requests-prompt-3",
        defaultMessage: "Summarize the comments on this pull request."
    },
    // BITBUCKET_REPOSITORY_SOURCE
    bitbucketRepositorySourcePrompt1: {
        id: "ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-1",
        defaultMessage: "Explain this file."
    },
    bitbucketRepositorySourcePrompt2: {
        id: "ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-2",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketRepositorySourcePrompt3: {
        id: "ai-mate.chat-history.empty-state.bitbucket-repository-source-prompt-3",
        defaultMessage: " What APIs or modules do these files interact with?"
    },
    // BITBUCKET_HOME
    bitbucketPrompt1: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-1",
        defaultMessage: "What are the pull requests authored by `person`?"
    },
    bitbucketPrompt2: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-2",
        defaultMessage: "What are the open PRs for the current Jira sprint?"
    },
    bitbucketPrompt3: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-3",
        defaultMessage: "Has `Jira work item` been deployed?"
    },
    bitbucketPrompt4: {
        id: "ai-mate.chat-history.empty-state.bitbucket-prompt-4",
        defaultMessage: "Who are the reviewers on this `Pull request`?"
    },
    // CONFLUENCE_HOME
    confluenceHomePrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-1",
        defaultMessage: "Is there any new activity on pages I've written?"
    },
    confluenceHomePrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-2",
        defaultMessage: "Are there any new comments mentioning me?"
    },
    confluenceHomePrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-3",
        defaultMessage: "Summarize the most recently published pages in this space."
    },
    confluenceHomePrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-4",
        defaultMessage: "Summarize my contributions to pages from last week."
    },
    confluenceHomePrompt5: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-5",
        defaultMessage: "Can you take this `page` and write it in a less technical way?"
    },
    confluenceHomePrompt6: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-6",
        defaultMessage: "Create a game plan template for project management."
    },
    confluenceHomePrompt7: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-7",
        defaultMessage: "What research do we have on common customer problems?"
    },
    confluenceHomePrompt8: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-8",
        defaultMessage: "Has anyone on my team published any new pages this week?"
    },
    confluenceHomePrompt9: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-9",
        defaultMessage: "Has `person` published any new pages this week?"
    },
    confluenceHomePrompt10: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-10",
        defaultMessage: "Has `person` commented on any pages that I've published?"
    },
    confluenceHomePrompt11: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-11",
        defaultMessage: "What are the key takeaways from `page`?"
    },
    confluenceHomePrompt12: {
        id: "ai-mate.chat-history.empty-state.confluence-home-prompt-12",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_VIEW
    confluencePageViewPrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluencePageViewPrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-2",
        defaultMessage: "Summarize the comments on this page."
    },
    confluencePageViewPrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-3",
        defaultMessage: "Explain this page to me like I'm a beginner."
    },
    confluencePageViewPrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-4",
        defaultMessage: "Who wrote this page and what team are they on?"
    },
    confluencePageViewPrompt5: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-5",
        defaultMessage: "Has anything on this page changed in the last week?"
    },
    confluencePageViewPrompt6: {
        id: "ai-mate.chat-history.empty-state.confluence-page-view-prompt-6",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_PAGE_EDIT
    confluencePageEditPrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-1",
        defaultMessage: "Can you improve the writing on this page?"
    },
    confluencePageEditPrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-2",
        defaultMessage: "Write an executive summary for this page."
    },
    confluencePageEditPrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-3",
        defaultMessage: "Give me links to some other relevant pages."
    },
    confluencePageEditPrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-page-edit-prompt-4",
        defaultMessage: "What should I work on next?"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardPrompt1: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-1",
        defaultMessage: "Summarize what I'm looking at."
    },
    confluenceWhiteboardPrompt2: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-2",
        defaultMessage: "Highlight any patterns or trends visible here."
    },
    confluenceWhiteboardPrompt3: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard.prompt-3",
        defaultMessage: "Identify any key action items or decisions captured in this whiteboard."
    },
    confluenceWhiteboardPrompt4: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-prompt-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_HOME
    jiraHomePrompt1: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-1",
        defaultMessage: "Find Jira work items that have been updated this week."
    },
    jiraHomePrompt2: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-2",
        defaultMessage: "What Jira work items are the highest priority?"
    },
    jiraHomePrompt3: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-3",
        defaultMessage: "What Jira work items have comments mentioning me?"
    },
    jiraHomePrompt4: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-4",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraHomePrompt5: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-5",
        defaultMessage: "Create a description template for user stories."
    },
    jiraHomePrompt6: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-6",
        defaultMessage: "What should I work on next?"
    },
    // JIRA_ISSUE_VIEW
    jiraIssueViewPrompt1: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-1",
        defaultMessage: "Are there any similar Jira work items to this one?"
    },
    jiraIssueViewPrompt2: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-2",
        defaultMessage: "How could I improve the description?"
    },
    jiraIssueViewPrompt3: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-3",
        defaultMessage: "What labels could I add to this work item?"
    },
    jiraIssueViewPrompt4: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-4",
        defaultMessage: "What should I work on next?"
    },
    // JIRA PROJECT
    jiraProjectPrompt1: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-1",
        defaultMessage: "What work hasn\u2019t been picked up in a while?"
    },
    jiraProjectPrompt2: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-2",
        defaultMessage: "Are any Jira work items blocked?"
    },
    jiraProjectPrompt3: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-3",
        defaultMessage: "List Jira work items that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-4",
        defaultMessage: "How many work items are assigned to `person`?"
    },
    jiraProjectPrompt5: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-5",
        defaultMessage: "Has `person` commented on any Jira work items in this sprint?"
    },
    jiraProjectPrompt6: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-6",
        defaultMessage: "What Jira work items are unassigned?"
    },
    jiraProjectPrompt7: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-7",
        defaultMessage: "What Jira work items have been open the longest?"
    },
    jiraProjectPrompt8: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-8",
        defaultMessage: "Who has the most tasks?"
    },
    jiraProjectPrompt9: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-10",
        defaultMessage: "Find and group similar Jira work items."
    },
    jiraProjectPrompt10: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-11",
        defaultMessage: "Are there any Jira work items not connected to a parent work item?"
    },
    jiraProjectPrompt11: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-12",
        defaultMessage: "Take `Jira work item` description and align it to best-practice."
    },
    jiraProjectPrompt12: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-13",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraProjectPrompt13: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-14",
        defaultMessage: "Create a description template for user stories."
    },
    jiraProjectPrompt14: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-15",
        defaultMessage: "What should I work on next?"
    },
    // ATLAS HOME
    atlasHomePrompt1: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-1",
        defaultMessage: "What Confluence pages have I contributed to recently?"
    },
    atlasHomePrompt2: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-2",
        defaultMessage: "Find all Jira tickets that are assigned to me."
    },
    atlasHomePrompt3: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-3",
        defaultMessage: "What is our travel policy?"
    },
    atlasHomePrompt4: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-4",
        defaultMessage: "Draft a Confluence page for a marketing campaign."
    },
    atlasHomePrompt5: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-5",
        defaultMessage: "How can I create a project timeline?"
    },
    atlasHomePrompt6: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-6",
        defaultMessage: "Write a follow up email to potential clients."
    },
    atlasHomePrompt7: {
        id: "ai-mate.chat-history.empty-state.atlas-home-prompt-7",
        defaultMessage: "What should I work on next?"
    },
    // UNKNOWN
    unknownPrompt1: {
        id: "ai-mate.chat-history.empty-state.suggestion1",
        defaultMessage: "Are any of my work items overdue?"
    },
    unknownPrompt2: {
        id: "ai-mate.chat-history.empty-state.suggestion2",
        defaultMessage: "What should I work on next?"
    },
    unknownPrompt3: {
        id: "ai-mate.chat-history.empty-state.suggestion3",
        defaultMessage: "Write an update about my week"
    },
    // LLM LABELS
    // CONFLUENCE_HOME
    confluenceHomeLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.confluence-home-llm-label-1",
        defaultMessage: "About this space"
    },
    confluenceHomeLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.confluence-home-llm-label-2",
        defaultMessage: "Insights on this space"
    },
    confluenceHomeLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.confluence-home-llm-label-3",
        defaultMessage: "Space suggestion"
    },
    // CONFLUENCE_PAGE_VIEW
    confluencePageLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-1",
        defaultMessage: "About this page"
    },
    confluencePageLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-2",
        defaultMessage: "More from this page"
    },
    confluencePageLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-3",
        defaultMessage: "Insights on this page"
    },
    confluencePageLLMLabel4: {
        id: "ai-mate.chat-history.empty-state.confluence-page-llm-label-3",
        defaultMessage: "Page suggestion"
    },
    // CONFLUENCE_WHITEBOARD
    confluenceWhiteboardLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-1",
        defaultMessage: "About this whiteboard"
    },
    confluenceWhiteboardLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-2",
        defaultMessage: "More from this whiteboard"
    },
    confluenceWhiteboardLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.confluence-whiteboard-llm-label-3",
        defaultMessage: "Insights on this whiteboard"
    },
    // JIRA ISSUE VIEW
    jiraIssueLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-1",
        defaultMessage: "About this work item"
    },
    jiraIssueLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-2",
        defaultMessage: "More from this work item"
    },
    jiraIssueLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-3",
        defaultMessage: "Insights on this work item"
    },
    jiraIssueLLMLabel4: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-4",
        defaultMessage: "Work item suggestion"
    },
    // JIRA PROJECT
    jiraProjectLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-1",
        defaultMessage: "About this project"
    },
    jiraProjectLLMLabel2: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-2",
        defaultMessage: "Insights on this project"
    },
    jiraProjectLLMLabel3: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-3",
        defaultMessage: "More from this project"
    },
    jiraProjectLLMLabel4: {
        id: "ai-mate.chat-history.empty-state.jira-project-llm-label-4",
        defaultMessage: "Project suggestion"
    },
    // UNKNOWN
    unknownLLMLabel1: {
        id: "ai-mate.chat-history.empty-state.unknown-llm-label-1",
        defaultMessage: "Suggestion"
    },
    jiraHomePrompt1IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-1-issue-term-refresh",
        defaultMessage: "Find Jira work items that have been updated this week."
    },
    jiraHomePrompt2IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-2-issue-term-refresh",
        defaultMessage: "What Jira work items are the highest priority?"
    },
    jiraHomePrompt3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-3-issue-term-refresh",
        defaultMessage: "What Jira work items have comments mentioning me?"
    },
    jiraHomePrompt4IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-home-prompt-4-issue-term-refresh",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraIssueViewPrompt1IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-1-issue-term-refresh",
        defaultMessage: "Are there any similar Jira work items to this one?"
    },
    jiraIssueViewPrompt3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-view-prompt-3-issue-term-refresh",
        defaultMessage: "What labels could I add to this work item?"
    },
    jiraProjectPrompt2IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-2-issue-term-refresh",
        defaultMessage: "Are any Jira work items blocked?"
    },
    jiraProjectPrompt3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-3-issue-term-refresh",
        defaultMessage: "List Jira work items that are currently \u201CIn Progress\u201D and group them by assignee."
    },
    jiraProjectPrompt4IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-4-issue-term-refresh",
        defaultMessage: "How many work items are assigned to `person`?"
    },
    jiraProjectPrompt5IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-5-issue-term-refresh",
        defaultMessage: "Has `person` commented on any Jira work items in this sprint?"
    },
    jiraProjectPrompt6IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-6-issue-term-refresh",
        defaultMessage: "What Jira work items are unassigned?"
    },
    jiraProjectPrompt7IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-7-issue-term-refresh",
        defaultMessage: "What Jira work items have been open the longest?"
    },
    jiraProjectPrompt9IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-10-issue-term-refresh",
        defaultMessage: "Find and group similar Jira work items."
    },
    jiraProjectPrompt10IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-11-issue-term-refresh",
        defaultMessage: "Are there any Jira work items not connected to a parent work item?"
    },
    jiraProjectPrompt11IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-12-issue-term-refresh",
        defaultMessage: "Take `Jira work item` description and align it to best-practice."
    },
    jiraProjectPrompt12IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-13-issue-term-refresh",
        defaultMessage: "Summarize the comments on `Jira work item`."
    },
    jiraProjectPrompt13IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-project-prompt-14-issue-term-refresh",
        defaultMessage: "Create a description template for user stories."
    },
    jiraIssueLLMLabel1IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-1-issue-term-refresh",
        defaultMessage: "About this work item"
    },
    jiraIssueLLMLabel2IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-2-issue-term-refresh",
        defaultMessage: "More from this work item"
    },
    jiraIssueLLMLabel3IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-3-issue-term-refresh",
        defaultMessage: "Insights on this work item"
    },
    jiraIssueLLMLabel4IssueTermRefresh: {
        id: "ai-mate.chat-history.empty-state.jira-issue-llm-label-4-issue-term-refresh",
        defaultMessage: "Work item suggestion"
    }
});


var $f3c63b7f858a4d16$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $f3c63b7f858a4d16$var$PAGE_TYPE_CONVERSATION_STARTERS = {
    ["bitbucket-pull-request"]: [
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketPullRequestsPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketPullRequestsPrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketPullRequestsPrompt3
        }
    ],
    ["bitbucket-repository-source"]: [
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketRepositorySourcePrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketRepositorySourcePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketRepositorySourcePrompt3
        }
    ],
    ["bitbucket"]: [
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketPrompt1
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).bitbucketPrompt3
        }
    ],
    ["confluence-home"]: [
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt1
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt2
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt6
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt9
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt10
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt11
        }
    ],
    ["confluence-page-view"]: [
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageViewPrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageViewPrompt2
        },
        {
            labelType: 'rephrase-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageViewPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageViewPrompt4
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageViewPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageViewPrompt6
        }
    ],
    ["confluence-whiteboard"]: [
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceWhiteboardPrompt1
        },
        {
            labelType: 'get-answers',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceWhiteboardPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceWhiteboardPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceWhiteboardPrompt4
        }
    ],
    ["confluence-page-edit"]: [
        {
            labelType: 'rephrase-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageEditPrompt1
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageEditPrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageEditPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageEditPrompt4
        }
    ],
    ["jira-home"]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt4
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt6
        }
    ],
    ["jira-issue-view"]: [
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueViewPrompt1
        },
        {
            labelType: 'rephrase-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueViewPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueViewPrompt3
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueViewPrompt4
        }
    ],
    ["jira-project"]: [
        {
            labelType: 'stay-up-to-date',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt2
        },
        {
            labelType: 'measure-productivity',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt3
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt4
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt5
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt6
        },
        {
            labelType: 'measure-productivity',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt7
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt8
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt9
        },
        {
            labelType: 'get-answers',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt10
        },
        {
            labelType: 'rephrase-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt11
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt12
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt13
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectPrompt14
        }
    ],
    ["atlas-home"]: [
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).atlasHomePrompt1
        },
        {
            labelType: 'measure-productivity',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).atlasHomePrompt2
        },
        {
            labelType: 'get-answers',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).atlasHomePrompt3
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).atlasHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).atlasHomePrompt5
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).atlasHomePrompt6
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt1
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt4
        },
        {
            labelType: 'rephrase-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt5
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt11
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt8
        },
        {
            labelType: 'find-people',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomePrompt10
        },
        {
            labelType: 'stay-up-to-date',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt2
        },
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt3
        },
        {
            labelType: 'summarize-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraHomePrompt4
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).atlasHomePrompt7
        }
    ],
    ["unknown"]: [
        {
            labelType: 'find-information',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).unknownPrompt1
        },
        {
            labelType: 'be-productive',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).unknownPrompt2
        },
        {
            labelType: 'draft-content',
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).unknownPrompt3
        }
    ],
    ["admin-hub"]: []
};
const $f3c63b7f858a4d16$export$16170b6653b94b8e = {
    ["confluence-home"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomeLLMLabel1
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomeLLMLabel2
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceHomeLLMLabel3
        }
    ],
    ["confluence-page-view"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel1
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel2
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel3
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel4
        }
    ],
    ["confluence-whiteboard"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceWhiteboardLLMLabel1
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceWhiteboardLLMLabel2
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluenceWhiteboardLLMLabel3
        }
    ],
    ["confluence-page-edit"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel1
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel2
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel3
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).confluencePageLLMLabel4
        }
    ],
    ["jira-home"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel1
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel2
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel3
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel4
        }
    ],
    ["jira-issue-view"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueLLMLabel1
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueLLMLabel2
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueLLMLabel3
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraIssueLLMLabel4
        }
    ],
    ["jira-project"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel1
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel2
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel3
        },
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).jiraProjectLLMLabel4
        }
    ],
    ["unknown"]: [
        {
            message: (0, $61feb0d05111c898$export$2e2bcd8739ae039).unknownLLMLabel1
        }
    ]
};
const $f3c63b7f858a4d16$export$a905239756c1fbae = (location)=>{
    const urlPatterns = [
        [
            "bitbucket-repository-source",
            /bitbucket\.org\/[^\/]+\/[^\/]+\/src\//
        ],
        [
            "bitbucket-pull-request",
            /bitbucket\.org\/[^\/]+\/[^\/]+\/pull-requests\//
        ],
        [
            "bitbucket",
            /bitbucket\.org\/.*/
        ],
        [
            "confluence-home",
            /\/wiki\/home$/
        ],
        [
            "confluence-page-edit",
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\/edit-v2\//
        ],
        [
            "confluence-page-view",
            /\/wiki\/spaces\/[^\/]+\/(?:pages|blog)\//
        ],
        [
            "confluence-whiteboard",
            /\/wiki\/spaces\/[^\/]+\/whiteboard\//
        ],
        [
            "jira-issue-view",
            /\/browse\/[^\/]+$/
        ],
        [
            "jira-issue-view",
            /\/jira\/.+\/projects\/.+\?selectedIssue/
        ],
        [
            "jira-project",
            /\/jira\/.+\/projects\//
        ],
        [
            "jira-home",
            /\/jira\/dashboards\/last-visited$/
        ],
        // atlas home is either home.atlassian.com, home.stg.atlassian.com, team.atlassian.com, or team.stg.atlassian.com
        [
            "atlas-home",
            /\/(home|team)\./
        ],
        // admin hub: admin.atlassian.com (production) or admin.stg.atlassian.com (staging)
        [
            "admin-hub",
            /admin(\.stg)?\.atlassian\.com/
        ]
    ];
    for (const [type, pattern] of urlPatterns){
        const matched = pattern.test(location);
        if (!matched) continue;
        if (type === "confluence-whiteboard") {
            const isExperimentEnable = (0, $c6GJD.default).getExperimentValue('contextual_conversation_starters_for_whiteboards', 'enable', false);
            return isExperimentEnable ? type : "unknown";
        }
        return type;
    }
    return "unknown";
};
const $f3c63b7f858a4d16$export$bc4bf2ff8e40b690 = ()=>{
    const location = (0, $fDnfG.useWindowLocation)();
    const [pageContextType, setPageContextType] = (0, $42omo.useState)($f3c63b7f858a4d16$export$a905239756c1fbae(location));
    (0, $42omo.useEffect)(()=>{
        setPageContextType($f3c63b7f858a4d16$export$a905239756c1fbae(location));
    }, [
        location
    ]);
    return pageContextType;
};
const $f3c63b7f858a4d16$var$shuffleArray = (arr)=>{
    // Shuffle array using Fisher-Yates algorithm
    for(let i = arr.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [
            arr[j],
            arr[i]
        ];
    }
    return arr;
};
const $f3c63b7f858a4d16$var$getRandomStarters = (starters, num)=>{
    // Return the first `num` items
    return $f3c63b7f858a4d16$var$shuffleArray(starters).slice(0, num);
};
const $f3c63b7f858a4d16$export$25eb3e1e01b253d9 = [
    "confluence-page-view",
    "confluence-page-edit",
    "confluence-whiteboard",
    "jira-issue-view"
];
const $f3c63b7f858a4d16$var$getConversationStarterLimit = (isFullscreen)=>isFullscreen ? 6 : 3;
const $f3c63b7f858a4d16$export$7f12a4d44b4b382b = (pageContextType)=>{
    /**
   * To avoid repetition, this function shuffles the labels array
   * and for every function call, it always get the next one in the shuffled array.
   *
   * Using `useMemo`, this function will reset the labelsShuffled when pageContextType changes.
   * so it will always randomise the correct labels for the current pageContextType.
   */ const getLLMLabel = (0, $42omo.useMemo)(()=>{
        const labelsByPageType = $f3c63b7f858a4d16$export$16170b6653b94b8e[pageContextType];
        if (!labelsByPageType) return ()=>({
                labelText: undefined,
                currentLabelIndex: -1
            });
        const shuffledLabels = $f3c63b7f858a4d16$var$shuffleArray(labelsByPageType);
        let labelIndex = 0;
        return ()=>{
            const currentLabelIndex = labelIndex;
            const labelText = shuffledLabels[labelIndex];
            // make sure the index loops back to the beginning of the array
            labelIndex = (labelIndex + 1) % shuffledLabels.length;
            return {
                labelText: labelText,
                currentLabelIndex: currentLabelIndex
            };
        };
    }, [
        pageContextType
    ]);
    return {
        getLLMLabel: getLLMLabel
    };
};
const $f3c63b7f858a4d16$export$640585e02de0f425 = (0, $h26dv.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onError: onError, onSuccess: onSuccess, onInit: onInit })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const pageContextType = $f3c63b7f858a4d16$export$bc4bf2ff8e40b690();
    const { fullScreen: fullScreen } = (0, $i08Mr.useUIConfig)();
    const [didTimeOut, setDidTimeOut] = (0, $42omo.useState)(false);
    const [starters, setStarters] = (0, $42omo.useState)(new Array(3).fill(null));
    const timeoutRef = (0, $42omo.useRef)(null);
    const cancelTimeout = (0, $42omo.useCallback)(()=>{
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    }, []);
    const staticContextualConversationStarters = (0, $42omo.useMemo)(()=>{
        const contextualStarters = $f3c63b7f858a4d16$var$PAGE_TYPE_CONVERSATION_STARTERS[pageContextType].map((starter)=>{
            return {
                labelType: starter.labelType,
                message: formatMessage(starter.message),
                type: 'static'
            };
        });
        const conversationStarterLimit = $f3c63b7f858a4d16$var$getConversationStarterLimit(fullScreen ?? false);
        // We don't need to shuffle the starters when the page context type is unknown
        const staticContextualStarters = pageContextType === "unknown" ? contextualStarters.slice(0, conversationStarterLimit) : $f3c63b7f858a4d16$var$getRandomStarters(contextualStarters, conversationStarterLimit);
        return staticContextualStarters;
    }, [
        pageContextType,
        fullScreen,
        formatMessage
    ]);
    const { getLLMLabel: getLLMLabel } = $f3c63b7f858a4d16$export$7f12a4d44b4b382b(pageContextType);
    const { mutate: getDynamicContextualStarters, error: error, isSubmitting: isSubmitting } = (0, $29BPs.useMutation)({
        mutationFn: async ({ fallbackStarters: fallbackStarters, userDefinedStarters: userDefinedStarters = [], locationUrl: browser_url })=>{
            onInit?.();
            experienceTracker.start({
                id: (0, $16lEl.ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                name: (0, $16lEl.ExperienceName).FETCH_CONTEXTUAL_STARTERS
            });
            setDidTimeOut(false);
            setStarters([
                ...userDefinedStarters,
                ...fallbackStarters.slice(0, 1),
                ...new Array(3).fill(null)
            ].slice(0, 3));
            beginTimeout(userDefinedStarters, fallbackStarters);
            return await assistanceService.generateContextualStarters({
                browser_url: browser_url
            });
        },
        onSuccess: async (responseData)=>{
            onSuccess?.();
            experienceTracker.succeed({
                name: (0, $16lEl.ExperienceName).FETCH_CONTEXTUAL_STARTERS
            });
            let updatedStarters = [
                ...starters
            ];
            if (didTimeOut) return;
            cancelTimeout();
            responseData?.conversation_starters.map(({ text: responseStarter })=>{
                const index = updatedStarters.indexOf(null);
                const starterAlreadyExists = updatedStarters.some((starter)=>starter?.message === responseStarter);
                // If there is a null value in the starters array AND the new starter we get from the backend
                // does not already exist in the array, replace the null value with the new starter
                if (index !== -1 && !starterAlreadyExists) {
                    updatedStarters[index] = {
                        message: responseStarter,
                        type: 'llm-generated',
                        labelType: 'llm-generated',
                        llmLabel: getLLMLabel().labelText
                    };
                    setStarters(updatedStarters);
                }
            });
        },
        onError: (error)=>{
            onError?.(error);
            experienceTracker.fail({
                name: (0, $16lEl.ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                error: error
            });
        }
    });
    const beginTimeout = (0, $42omo.useCallback)((userDefinedStarters, fallbackStarters)=>{
        timeoutRef.current = window.setTimeout(()=>{
            experienceTracker.abort({
                name: (0, $16lEl.ExperienceName).FETCH_CONTEXTUAL_STARTERS,
                reason: 'timeout'
            });
            setDidTimeOut(true);
            setStarters([
                ...userDefinedStarters,
                ...fallbackStarters
            ].slice(0, 3));
        }, 2000);
        return cancelTimeout;
    }, [
        cancelTimeout,
        experienceTracker
    ]);
    return {
        getDynamicContextualStarters: getDynamicContextualStarters,
        starters: starters,
        error: error,
        // TODO - Implement appropriate request abort logic for useMutation, much like useStreamingMutation has, this is a stop gap
        isMutating: didTimeOut ? false : isSubmitting,
        staticContextualConversationStarters: staticContextualConversationStarters,
        cancelTimeout: cancelTimeout
    };
});
module.exports["determinePageType"] = $f3c63b7f858a4d16$export$a905239756c1fbae;
module.exports["llmGeneratedConvoStartersPageTypeAllowList"] = $f3c63b7f858a4d16$export$25eb3e1e01b253d9;
module.exports["useContextualConversationStarters"] = $f3c63b7f858a4d16$export$640585e02de0f425;

});

parcelRegister("fDnfG", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

const $d1554a578f10d6c8$export$46133998910543ac = (0, $42omo.createContext)(null);
const $d1554a578f10d6c8$export$6fa751d66e55d2e1 = ()=>{
    const [location, setLocation] = (0, $42omo.useState)(window.location.href);
    // For easier mocking
    const contextValue = (0, $42omo.useContext)($d1554a578f10d6c8$export$46133998910543ac);
    const handleLocationChange = (0, $42omo.useCallback)(()=>{
        if (window.location.href !== location) setLocation(window.location.href);
    }, [
        location,
        setLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        const originalPushState = window.history.pushState;
        const originalReplaceState = window.history.replaceState;
        window.history.pushState = function(...args) {
            originalPushState.apply(this, args);
            handleLocationChange();
        };
        window.history.replaceState = function(...args) {
            originalReplaceState.apply(this, args);
            handleLocationChange();
        };
        const unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'popstate',
                listener: handleLocationChange
            }
        ]);
        return ()=>{
            unbind();
            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, [
        handleLocationChange
    ]);
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $d1554a578f10d6c8$export$6fa751d66e55d2e1;

});

parcelRegister("bJOL1", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $c6GJD = parcelRequire("c6GJD");


var $1yaYZ = parcelRequire("1yaYZ");


var $auPMn = parcelRequire("auPMn");


var $cgmTK = parcelRequire("cgmTK");

const $07d6ee757337fb7d$var$defaultStateContextPerKey = {
    attachments: new Map()
};
/**
 * Cleanup blob URLs for file attachments to prevent memory leaks.
 * Only runs when the feature flag is enabled.
 */ const $07d6ee757337fb7d$var$cleanupBlobUrls = (attachments)=>{
    if (!(0, $c6GJD.default).getExperimentValue('rovo_chat_file_previews_experiment', 'isEnabled', false)) return;
    attachments.forEach((attachment)=>{
        if (attachment.type === 'file' && attachment.data.previewBlobUrl) URL.revokeObjectURL(attachment.data.previewBlobUrl);
    });
};
const $07d6ee757337fb7d$var$updateAttachements = (key, entries, overwrite = false)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
        setState({
            [key]: {
                attachments: new Map([
                    ...!overwrite ? state.attachments.entries() : [],
                    ...entries
                ])
            }
        });
    };
};
const $07d6ee757337fb7d$var$store = (0, $1P1Tu.createStore)({
    name: 'conversationAttachments',
    initialState: {},
    actions: {
        addFiles: (key, files)=>({ getState: getState, dispatch: dispatch })=>{
                // Check if any files need preview generation (images, text files)
                const needsPreview = (file)=>file.fileObject && (file.fileObject.type.startsWith('image/') || (0, $auPMn.isTextFile)(file.fileObject.type, file.fileObject.name)) && (0, $c6GJD.default).getExperimentValue('rovo_chat_file_previews_experiment', 'isEnabled', false);
                // Add files with preview loading state if needed
                const fileAttachments = files.map((file)=>[
                        file.name,
                        {
                            type: 'file',
                            data: needsPreview(file) ? {
                                ...file,
                                isPreviewLoading: true
                            } : file
                        }
                    ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, fileAttachments));
                files.forEach((file)=>{
                    if (needsPreview(file) && file.fileObject) (0, $cgmTK.generateFilePreview)(file.fileObject).then((previewBlobUrl)=>{
                        dispatch($07d6ee757337fb7d$var$store.actions.updateFileWithName(key, file.name, {
                            previewBlobUrl: previewBlobUrl,
                            isPreviewLoading: false
                        }));
                    }).catch((error)=>{
                        // Log error to Sentry for monitoring
                        (0, $1yaYZ.logException)({
                            exception: error,
                            name: 'file-preview-generation-error',
                            tags: {
                                fileType: file.fileObject?.type
                            }
                        });
                        // Store error and clear loading state, user will see default file icon
                        dispatch($07d6ee757337fb7d$var$store.actions.updateFileWithName(key, file.name, {
                            isPreviewLoading: false,
                            previewError: error instanceof Error ? error.message : String(error)
                        }));
                    });
                });
            },
        addExternalContext: (key, context)=>({ getState: getState, dispatch: dispatch })=>{
                const externalContextAttachments = context.map((context)=>[
                        context.key,
                        {
                            type: 'external',
                            data: context
                        }
                    ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, externalContextAttachments));
            },
        updateFileWithName: (key, fileName, fileData)=>({ getState: getState, dispatch: dispatch })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                const attachment = currentAttachtments.get(fileName);
                if (attachment && attachment.type === 'file') dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    [
                        fileName,
                        {
                            ...attachment,
                            data: {
                                ...attachment.data,
                                ...fileData
                            }
                        }
                    ]
                ]));
            },
        removeFile: (key, fileName)=>({ getState: getState, dispatch: dispatch })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                // Cleanup blob URL before removing
                const attachment = currentAttachtments.get(fileName);
                if (attachment) $07d6ee757337fb7d$var$cleanupBlobUrls([
                    attachment
                ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    ...currentAttachtments.entries()
                ].filter(([entryKey, value])=>value.type !== 'file' || entryKey !== fileName), true));
            },
        removeExternalContext: (key, id)=>({ getState: getState, dispatch: dispatch })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    ...currentAttachtments.entries()
                ].filter(([entryKey, value])=>value.type !== 'external' || entryKey !== id), true));
            },
        clearFiles: (key)=>({ dispatch: dispatch, getState: getState })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                // Cleanup all file blob URLs
                $07d6ee757337fb7d$var$cleanupBlobUrls([
                    ...currentAttachtments.values()
                ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [
                    ...currentAttachtments.entries()
                ].filter(([_, value])=>value.type !== 'file'), true));
            },
        clearAttachments: (key)=>({ dispatch: dispatch, getState: getState })=>{
                const { attachments: currentAttachtments } = getState()[key] || $07d6ee757337fb7d$var$defaultStateContextPerKey;
                // Cleanup all blob URLs
                $07d6ee757337fb7d$var$cleanupBlobUrls([
                    ...currentAttachtments.values()
                ]);
                dispatch($07d6ee757337fb7d$var$updateAttachements(key, [], true));
            }
    }
});
const $07d6ee757337fb7d$export$c0d6d7bef4e6e587 = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store);
const $07d6ee757337fb7d$export$c07f930e4d0c507 = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store, {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || $07d6ee757337fb7d$var$defaultStateContextPerKey.attachments.values()
        ]
});
const $07d6ee757337fb7d$export$7d10ab840754c21b = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store, {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || []
        ].filter((item)=>item.type === 'file').map((item)=>item.data) || []
});
const $07d6ee757337fb7d$export$cffce0bcbf2f13f8 = (0, $9zUhf.createHook)($07d6ee757337fb7d$var$store, {
    selector: (state, key)=>[
            ...state[key]?.attachments?.values() || []
        ]?.filter((item)=>item.type === 'external')?.map((item)=>item.data) || []
});
module.exports["useAllAttachmentsStore"] = $07d6ee757337fb7d$export$c07f930e4d0c507;
module.exports["useFileAttachmentsStore"] = $07d6ee757337fb7d$export$7d10ab840754c21b;
module.exports["useExternalContextsStore"] = $07d6ee757337fb7d$export$cffce0bcbf2f13f8;

});

parcelRegister("5SEdb", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $c6GJD = parcelRequire("c6GJD");


var $hmuev = parcelRequire("hmuev");


var $a3fRD = parcelRequire("a3fRD");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $9hlns = parcelRequire("9hlns");


var $3gadb = parcelRequire("3gadb");


var $c3meS = parcelRequire("c3meS");

const $b536e6d938936901$var$styles = {
    previewCard: "_2rko1mok _1h6d1l7x _189ee4h9 _1dqonqa1 _p12f9rak _4t3ivbgk _kqswh2mm _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _bozgutpp _bfhkhp5a _irr3116u",
    previewCardContent: "_1ul9idpf",
    iconWrapper: "_1reo15vq _18m915vq _2rko12b0 _bfhki8nm _4t3ickbl _1bsbckbl _kqswh2mm _1o9zidpf",
    icon: "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
    crossIcon: "_2rko1rr0 _189ee4h9 _1dqonqa1 _1h6d1l7x _kqswstnw _1xi2xmi2 _154ixmi2 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkvuon _4t3i1tcg _1bsb1tcg _tzy4idpf _irr319i6",
    crossIconVisible: "_tzy4kb7n",
    labelWrapper: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    thumbnailImageCover: "_1bsb1osq _4t3i1osq _5ral1dfr",
    thumbnailImageContain: "_1bsb1osq _4t3i1osq _5ral1f51",
    clickable: "_80omtlke"
};
const $b536e6d938936901$var$LoadingIndicator = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
        size: "small"
    });
};
const $b536e6d938936901$var$MediaContentRenderer = ({ isLoading: isLoading, error: error, imageSrc: imageSrc, cardIcon: cardIcon, errorLabel: errorLabel })=>{
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$LoadingIndicator, {});
    if (error) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: errorLabel || error,
        color: "var(--ds-icon-danger, #C9372C)"
    });
    if (imageSrc) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "img",
        src: imageSrc,
        alt: "",
        xcss: (0, $c6GJD.default).getExperimentValue('rovo_chat_file_previews_experiment', 'isEnabled', false) ? $b536e6d938936901$var$styles.thumbnailImageCover : $b536e6d938936901$var$styles.thumbnailImageContain
    });
    if (cardIcon) return cardIcon;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3meS))),
        alt: ""
    });
};
const $b536e6d938936901$var$MediaWrapper = ({ show: show = true, ...contentProps })=>{
    if (!show) return null;
    const shouldShowCentered = contentProps.isLoading || contentProps.error;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b536e6d938936901$var$styles.iconWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$LoadingIndicator, {}),
            children: contentProps.imageSrc && !shouldShowCentered ? /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$MediaContentRenderer, {
                ...contentProps
            }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    !contentProps.isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3meS))),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                        xcss: $b536e6d938936901$var$styles.icon,
                        children: /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$MediaContentRenderer, {
                            ...contentProps
                        })
                    })
                ]
            })
        })
    });
};
const $b536e6d938936901$var$RemoveButton = ({ onRemove: onRemove, isVisible: isVisible = false, removeLabel: removeLabel })=>{
    if (!onRemove) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        onClick: onRemove,
        xcss: (0, $1Whri.cx)($b536e6d938936901$var$styles.crossIcon, isVisible && $b536e6d938936901$var$styles.crossIconVisible),
        // @ts-ignore - data attributes not in Pressable types
        "data-remove-button": "true",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: removeLabel || '',
            spacing: "compact",
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        })
    });
};
const $b536e6d938936901$var$useAutoScroll = (autoScroll)=>{
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (autoScroll && ref.current) ref.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
        });
    }, [
        autoScroll
    ]);
    return ref;
};
const $b536e6d938936901$var$LabelContent = ({ label: label, subLabel: subLabel, subLabelIcon: subLabelIcon })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $b536e6d938936901$var$styles.previewCardContent,
        space: "space.050",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b536e6d938936901$var$styles.labelWrapper,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    color: "color.text",
                    size: "medium",
                    children: label
                })
            }),
            subLabel && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                alignBlock: "center",
                children: [
                    subLabelIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                        fallback: null,
                        children: subLabelIcon
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtlest",
                        size: "small",
                        children: subLabel
                    })
                ]
            })
        ]
    });
const $b536e6d938936901$export$b56e55a3645a3ec = ({ onRemove: onRemove, onClick: onClick, isLoading: isLoading, error: error, autoScroll: autoScroll, label: label, subLabel: subLabel, subLabelIcon: subLabelIcon, cardIcon: cardIcon, imageSrc: imageSrc, removeLabel: removeLabel, errorLabel: errorLabel, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const ref = $b536e6d938936901$var$useAutoScroll(autoScroll);
    const showMedia = !!(cardIcon || imageSrc);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        // Don't trigger onClick if clicking the remove button
        if (e.target.closest('[data-remove-button]')) return;
        onClick?.();
    }, [
        onClick
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((e)=>{
        // Handle Enter and Space keys for accessibility
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: error || label,
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            ref: ref,
            testId: testId,
            tabIndex: onClick ? 0 : undefined,
            role: onClick ? 'button' : undefined,
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false),
            onFocus: ()=>setIsHovered(true),
            onBlur: ()=>setIsHovered(false),
            onClick: onClick ? handleClick : undefined,
            onKeyDown: onClick ? handleKeyDown : undefined,
            xcss: onClick ? $b536e6d938936901$var$styles.clickable : undefined,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                xcss: $b536e6d938936901$var$styles.previewCard,
                alignBlock: "center",
                space: "space.150",
                spread: "space-between",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$LabelContent, {
                        label: label,
                        subLabel: subLabel,
                        subLabelIcon: subLabelIcon
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$MediaWrapper, {
                        show: showMedia,
                        isLoading: isLoading,
                        error: error,
                        imageSrc: imageSrc,
                        cardIcon: cardIcon,
                        errorLabel: errorLabel
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)($b536e6d938936901$var$RemoveButton, {
                        onRemove: onRemove,
                        isVisible: isHovered && !!onRemove,
                        removeLabel: removeLabel
                    })
                ]
            })
        })
    });
};
module.exports["PreviewCard"] = $b536e6d938936901$export$b56e55a3645a3ec;

});

parcelRegister("gkZa1", function(module, exports) {

var $42omo = parcelRequire("42omo");













const $569b8cc87349548f$export$dce8bc0f04f0d915 = {
    skill: ()=>(parcelRequire("ciV2C")),
    assets: ()=>(parcelRequire("8OGHW")),
    add: ()=>Promise.resolve((parcelRequire("g5gZt"))),
    'chart-bar-line': ()=>(parcelRequire("4qVJ2")),
    'ai-generative-text': ()=>(parcelRequire("eqsS5")),
    'work-item': ()=>Promise.resolve((parcelRequire("2qVkt"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("9Q2dU"))),
    'chart-pie': ()=>(parcelRequire("8sr2T")),
    plan: ()=>(parcelRequire("i4zNS")),
    settings: ()=>Promise.resolve((parcelRequire("fIcbd"))),
    'project-status': ()=>(parcelRequire("6E8pW")),
    'merge-success': ()=>(parcelRequire("3mxkw"))
};
const $569b8cc87349548f$export$ca2f546e21dcce87 = $569b8cc87349548f$export$dce8bc0f04f0d915.skill;
const $569b8cc87349548f$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($569b8cc87349548f$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $42omo.lazy)(loader)
    ]));
const $569b8cc87349548f$export$78596fa6083c04d1 = $569b8cc87349548f$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $569b8cc87349548f$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $569b8cc87349548f$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $569b8cc87349548f$export$f7883dcc9f65479a;

});

parcelRegister("c3meS", function(module, exports) {
module.exports = new URL("preview-bg.12045916.svg", import.meta.url).toString();

});


//# sourceMappingURL=FullPageEditorComponent.1968b9e0.js.map
